import React, { useEffect, useState, useRef } from "react";
import FullLoader from "../assets/images/full-page-loader.gif";
// import addIcon from '../assets/images/addbtnicon/plusicon.svg';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import backButton from '../assets/images/back_button_arrow.svg';
import { notifycatch } from "../utils/toast";
import { Radio, Select, Col, Row, Input, Checkbox, Modal } from "antd";
import BlockCategoryTable from './BlockCategoryTable';
import creativetemicon from '../assets/images/icons/creative_tem_icon.svg';
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
// import deleteIcon from '../assets/images/icons/trash.svg';
import playIcon from '../assets/images/icons/play.svg';
import zoneIcon from '../assets/images/icons/zone.svg';
import searchIcon from '../assets/images/icons/search.svg';
import downloadIcon from '../assets/images/icons/download.svg';
import gamSizesData from '../constants/GamSizes/sizes.json';
import gamVastMasterSizesData from '../constants/GamSizes/vastMasterSizes.json';
import gamCompanionSizesData from '../constants/GamSizes/companionSizes.json';
const { TextArea } = Input;
const { Option } = Select;

const ZoneViewEdit = ({ handlePageViewChange, id, zoneCategory, zoneViewName }) => {
    // const loadingContext = useContext(LoadingContext);
    const [formVisible, setFormVisible] = useState(false);
    const [blockCategorySelected, setBlockCategorySelected] = useState(new Set());
    const [blockCategoryNormalizeKey, setBlockCategoryNormalizeKey] = useState(0);
    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 0);
        }
    };

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {
        setFormType(zoneCategory)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let role = jwtDecode(token).role;

            // if (role === "mobops" || role === "sa" || role === "am") {
            axios
                .get(configData.SERVER_URL + "ops/getExchangeTypes", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setIntegrationTypeOptions_openrtb(response.data.data);
                })
                .catch((error) => { });


            // axios
            //     .get(configData.SERVER_URL + "remotefeed/feedTypeList", {
            //         headers: {
            //             "Content-Type": "application/json",
            //         },
            //     })
            //     .then((response) => {
            //         setFeedListRepeaterOptions(response.data.data)
            //     })
            //     .catch((error) => { });


            // }

            setRole(role);


            axios
                .get(configData.SERVER_URL + "publica/templates", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setTemplateOptions_publica(response.data.data)

                })
                .catch((error) => { });

            axios
                .get(configData.SERVER_URL + "zone/getAdKTempList", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setTemplateOptions_vastzone(response.data)
                })
                .catch((error) => { });



            axios
                .get(configData.SERVER_URL + "zone/zoneDetails?zoneId=" + id, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (zoneCategory === "Prebid") {
                        setPlatformType_prebid(response.data.data.invent_type)
                        setFormatType_prebid(
                            response.data.data.traffic_type
                                ? response.data.data.traffic_type.split(",").map(item => item.trim())
                                : []
                        );


                        if (response.data.data.traffic_type?.includes("Banner")) {
                            setBannerCheckbox_prebid(response.data.data.bannerCheckbox)
                        }
                        setZoneName_prebid(response.data.data.z_name)
                        setZoneActiveCheckbox_prebid(response.data.data.status)
                        setIntegrationType_prebid(response.data.data.exchange_type)
                        setImpression_prebid(response.data.data.imp_daily)
                        setRequest_prebid(response.data.data.req_daily)

                        // let tempArr = []
                        // if (response.data.data.remoteIds.length > 0) {
                        //     tempArr = response.data.data.remoteIds.map(item => ({
                        //         ...item,
                        //         validation_feed_provider_id: false,
                        //         validation_remote_id: false
                        //     }))
                        // }

                        // setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        // setFeedListRepeater(tempArr);

                        setRevSharePercent_prebid(response.data.data.revshare === undefined ? "" : response.data.data.revshare)
                        setHighestBidFloorCheckbox_prebid(response.data.data.isHighestBidFloor === undefined ? false : response.data.data.isHighestBidFloor)
                        setMinCpm_prebid(response.data.data.minEcpm === undefined ? "" : response.data.data.minEcpm)
                        setMaxCpm_prebid(response.data.data.maxEcpm === undefined ? "" : response.data.data.maxEcpm)
                        setHuman_prebid(response.data.data.sampling_human !== undefined && response.data.data.sampling_human !== null ? String(response.data.data.sampling_human) : "")
                        // PIXALATE SUNSET: Pixalate no longer returned by API
                        // setPixalate_prebid(response.data.data.sampling_pixalate !== undefined && response.data.data.sampling_pixalate !== null ? String(response.data.data.sampling_pixalate) : "")
                        setDoubleverify_prebid(response.data.data.sampling_dv !== undefined && response.data.data.sampling_dv !== null ? String(response.data.data.sampling_dv) : "")
                        setBlockCategorySelected(new Set(response.data.data.block_category || []))
                        setBlockCategoryNormalizeKey(k => k + 1)
                        setIsAddValueCheckbox_prebid(response.data.data.ipd_bool || false)
                        setOverride_prebid(response.data.data.ipd_value || "")

                    }

                    else if (zoneCategory === "Open RTB") {

                        setPlatformType_openrtb(response.data.data.invent_type)
                        setFormatType_openrtb(response.data.data.traffic_type
                            ? response.data.data.traffic_type.split(",").map(item => item.trim())
                            : [])
                        if (response.data.data.traffic_type?.includes("Banner")) {
                            setBannerCheckbox_openrtb(response.data.data.bannerCheckbox)
                        }
                        setZoneName_openrtb(response.data.data.z_name)
                        setZoneActiveCheckbox_openrtb(response.data.data.status)
                        setIntegrationType_openrtb(response.data.data.exchange_type)
                        setImpression_openrtb(response.data.data.imp_daily)
                        setRequest_openrtb(response.data.data.req_daily)

                        // let tempArr = []
                        // if (response.data.data.remoteIds.length > 0) {
                        //     tempArr = response.data.data.remoteIds.map(item => ({
                        //         ...item,
                        //         validation_feed_provider_id: false,
                        //         validation_remote_id: false
                        //     }))
                        // }


                        // setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        // setFeedListRepeater(tempArr);

                        setRevSharePercent_openrtb(response.data.data.revshare === undefined ? "" : response.data.data.revshare)
                        setHighestBidFloorCheckbox_openrtb(response.data.data.isHighestBidFloor === undefined ? false : response.data.data.isHighestBidFloor)
                        setMinCpm_openrtb(response.data.data.minEcpm === undefined ? "" : response.data.data.minEcpm)
                        setMaxCpm_openrtb(response.data.data.maxEcpm === undefined ? "" : response.data.data.maxEcpm)
                        setHuman_openrtb(response.data.data.sampling_human !== undefined && response.data.data.sampling_human !== null ? String(response.data.data.sampling_human) : "")
                        // PIXALATE SUNSET: Pixalate no longer returned by API
                        // setPixalate_openrtb(response.data.data.sampling_pixalate !== undefined && response.data.data.sampling_pixalate !== null ? String(response.data.data.sampling_pixalate) : "")
                        setDoubleverify_openrtb(response.data.data.sampling_dv !== undefined && response.data.data.sampling_dv !== null ? String(response.data.data.sampling_dv) : "")
                        setBlockCategorySelected(new Set(response.data.data.block_category || []))
                        setBlockCategoryNormalizeKey(k => k + 1)
                        setIsAddValueCheckbox_openrtb(response.data.data.ipd_bool || false)
                        setOverride_openrtb(response.data.data.ipd_value || "")

                    }

                    else if (zoneCategory === "publica") {

                        setPlatformType_publica(response.data.data.invent_type)
                        setChannelName_publica(response.data.data.channel_name)
                        setRegion_publica(response.data.data.region)
                        setECpm_publica(response.data.data.eCpm)
                        setTemplate_publica(response.data.data.template.label)
                        setTemplateText_publica(response.data.data.template.value)
                        setHuman_publica(response.data.data.sampling_human !== undefined && response.data.data.sampling_human !== null ? String(response.data.data.sampling_human) : "")
                        setPixalate_publica(response.data.data.sampling_pixalate !== undefined && response.data.data.sampling_pixalate !== null ? String(response.data.data.sampling_pixalate) : "")
                        setDoubleverify_publica(response.data.data.sampling_dv !== undefined && response.data.data.sampling_dv !== null ? String(response.data.data.sampling_dv) : "")

                        if ((role !== "admin" && role !== "u_admin")) {
                            setVastVersion_publica(response.data.data.header_bidder_vast_version)
                            setBidAdjustment_publica(response.data.data.bid_adjustment)
                            setBidValue_publica(response.data.data.bid_adjustment_value)
                            setAsi_publica(response.data.data.asi)
                            setSid_publica(response.data.data.sid)
                            setName_publica(response.data.data.name)
                            setDomain_publica(response.data.data.domain)
                            setIsAddValueCheckbox_publica(response.data.data.isAddValueCheckbox)
                            setOverride_publica(response.data.data.override)

                        }

                        if (role === "sa" || role === "mobops" || role === "am") {
                            setOverride_eCpm_Checkbox_publica((response.data.data.isTargetEcpm === undefined || response.data.data.isTargetEcpm === null) ? false : response.data.data.isTargetEcpm)
                            setECpm_target_publica((response.data.data.target_ecpm === undefined || response.data.data.target_ecpm === null) ? "" : response.data.data.target_ecpm)
                        }
                    }

                    else if (zoneCategory === "GAM Tag") {

                        setAccountName_gamtag(response.data.data.z_name)
                        setPlatformType_gamtag(response.data.data.invent_type)
                        setOwnership_gamtag(response.data.data.gamData?.ownership)
                        setVastVersion_gamtag(response.data.data.gamData?.vastVersion)
                        seteCPM_gamtag(response.data.data.gamData?.ecpm)

                    }

                    else if (zoneCategory === "GAM") {
                        // Tags tab is always a fresh form on open
                        reset_gamtags();
                        const d = response.data.data;
                        // Tags "Sizes" options are the zone's own sizes (banner + vast + companion)
                        setTagSizesOptions_gamtags(buildTagSizesOptions_gamtags(d.gamData?.sizes));
                        setPlatformType_gam(d.invent_type)
                        setFormatType_gam(d.traffic_type)
                        // Tag type is derived from the zone's inventory + format type (read-only).
                        setTagType_gamtags(getForcedGamTagType_gamtags(d.invent_type, d.traffic_type))
                        if (d.traffic_type === "Video") {
                            setSizesList_gam(Array.isArray(d.gamData.sizes.vastSizes) ? d.gamData.sizes.vastSizes : [])
                            setCompanionList_gam(Array.isArray(d.gamData.sizes.companionSizes) ? d.gamData.sizes.companionSizes : [])
                        }
                        else {
                            setSizesList_gam(Array.isArray(d.gamData.sizes.bannerSizes) ? d.gamData.sizes.bannerSizes : [])
                        }
                        setZoneName_gam(d.z_name)
                        // Zone Name format: PublisherName-TrafficType-FormatType.
                        // Recover the publisher name so it can be rebuilt when traffic/format type changes.
                        const zoneNameSuffix_gam = `-${d.invent_type}-${d.traffic_type}`
                        setPublisherName_gam(
                            typeof d.z_name === "string" && d.z_name.endsWith(zoneNameSuffix_gam)
                                ? d.z_name.slice(0, d.z_name.length - zoneNameSuffix_gam.length)
                                : (d.p_name || "")
                        )

                        if (d.invent_type === "CTV" && d.gamData?.adUnit?.applicationId) {
                            setTvAppNameCheckbox_gam(true);
                            setTvApplication_gam(d.gamData.adUnit.applicationId)
                        }


                        setFixedPrice_gam(d.fixed_cpm !== undefined && d.fixed_cpm !== null ? String(d.fixed_cpm) : "")
                        setUpr_gam(d.gamData.upr.set_upr !== undefined && d.gamData.upr.set_upr !== null ? String(d.gamData.upr.set_upr) : "")
                        setOverrideUpr_gam(d.isTargetEcpm)
                        setOverrideSetUpr_gam(d.target_ecpm !== undefined && d.target_ecpm !== null ? String(d.target_ecpm) : "")
                        setUprCategory_gam(d.gamData?.upr?.upr_id || "");
                        setZoneActiveCheckbox_gam(d.status !== undefined ? d.status : true)
                    }

                    else if (zoneCategory === "Vast Zone") {
                        setPlatformType_vastzone(response.data.data.invent_type)
                        setStreamPosition_vastzone(response.data.data.stream_position)
                        setZoneName_vastzone(response.data.data.z_name)
                        setZoneActiveCheckbox_vastzone(response.data.data.status)
                        setRevenueType_vastzone(response.data.data.revenue_type)
                        // setRevenueType_vastzone_prev(response.data.data.revenue_type)
                        if (response.data.data.revenue_type === "Fixed_Price") {
                            setECpm_vastzone(response.data.data.fixed_cpm)
                            // setECpm_vastzone_prev(response.data.data.fixed_cpm)

                            if (role === "sa" || role === "mobops" || role === "am") {
                                setOverride_eCpm_Checkbox_vastzone((response.data.data.isTargetEcpm === undefined || response.data.data.isTargetEcpm === null) ? false : response.data.data.isTargetEcpm)
                                setECpm_target_vastzone((response.data.data.target_ecpm === undefined || response.data.data.target_ecpm === null) ? "" : response.data.data.target_ecpm)
                            }

                        }
                        if (response.data.data.revenue_type === "Revshare") {
                            setRevSharePercent_vastzone(response.data.data.revshare)
                            // setRevSharePercent_vastzone_prev(response.data.data.revshare)
                        }
                        setRequest_vastzone(response.data.data.req_daily)
                        setImpression_vastzone(response.data.data.imp_daily)

                        // let tempArr = []
                        // if (response.data.data.remoteIds.length > 0) {
                        //     tempArr = response.data.data.remoteIds.map(item => ({
                        //         ...item,
                        //         validation_feed_provider_id: false,
                        //         validation_remote_id: false
                        //     }))
                        // }

                        // setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        // setFeedListRepeater(tempArr);
                        setHuman_vastzone(response.data.data.sampling_human !== undefined && response.data.data.sampling_human !== null ? String(response.data.data.sampling_human) : "")
                        // PIXALATE SUNSET: Pixalate no longer returned by API
                        // setPixalate_vastzone(response.data.data.sampling_pixalate !== undefined && response.data.data.sampling_pixalate !== null ? String(response.data.data.sampling_pixalate) : "")
                        setDoubleverify_vastzone(response.data.data.sampling_dv !== undefined && response.data.data.sampling_dv !== null ? String(response.data.data.sampling_dv) : "")
                        setBlockCategorySelected(new Set(response.data.data.block_category || []))
                        setBlockCategoryNormalizeKey(k => k + 1)
                        setIsAddValueCheckbox_vastzone(response.data.data.ipd_bool || false)
                        setOverride_vastzone(response.data.data.ipd_value || "")
                        if (response.data.data.vastTagInfo?.[0]) {
                            setTemplate_vastzone(response.data.data.vastTagInfo[0].label || "")
                            setTemplateText_vastzone(response.data.data.vastTagInfo[0].value || "")

                        }

                    }


                    else if (zoneCategory === "vast_aniview") {
                        setPlatformType_vast_aniview(response.data.data.invent_type)
                        // setPlatformType_vast_aniview_prev(response.data.data.invent_type)
                        setChannelName_vast_aniview(response.data.data.z_name)
                        // setChannelName_vast_aniview_prev(response.data.data.z_name)
                        setECpm_vast_aniview(response.data.data.fixed_cpm)
                        // setECpm_vast_aniview_prev(response.data.data.fixed_cpm)
                        setp_name_vast_aniview(response.data.data.p_name)
                        setp_aniviewId_vast_aniview(response.data.data.p_aniviewId)
                    }



                    else if (zoneCategory === "Player Tag" || zoneCategory === "tag_outstream") {
                        setPlatformType_playertag(response.data.data.invent_type)
                        setPlayerMode_playertag(response.data.data.playerMode)
                        setFloatingPosition_playertag(response.data.data.floatingPos)
                        // setFloatingPosition_playertag_prev(response.data.data.floatingPos)
                        setChannelName_playertag(response.data.data.aniviewData?.channel?.channelName)
                        setECpm_playertag(response.data.data.fixed_cpm)
                        setMainTableVideo_playertag(response.data.data.aniviewData?.videoIds)

                    }


                    setFormVisible(true)
                })
                .catch((error) => {
                    setFormVisible(true)
                    notifyfailure("Failed to fetch the zone details.")
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    // const [floatingPosition_playertag_prev, setFloatingPosition_playertag_prev] = useState("");
    // const [revenueType_vastzone_prev, setRevenueType_vastzone_prev] = useState("");
    // const [eCpm_vastzone_prev, setECpm_vastzone_prev] = useState("");
    // const [revSharePercent_vastzone_prev, setRevSharePercent_vastzone_prev] = useState("");

    ////////////////////////////////////////////role and publisher list/publisher for not admin states  and form view////////////////////////////////

    function resetFormView() {
        setButtonProcessing(false)
        setFormType("")
        setFormVisible(false)
        reset_prebid()
        reset_openrtb()
        reset_publica()
        reset_gamtag()
        reset_gam()
        reset_gamtags()
        reset_playertag()
        reset_vastzone()
        reset_vast_aniview()
        // setFloatingPosition_playertag_prev("");
        // setRevenueType_vastzone_prev("");
        // setECpm_vastzone_prev("");
        // setRevSharePercent_vastzone_prev("");
        // setPlatformType_vast_aniview_prev("");
        // setChannelName_vast_aniview_prev("");
        // setECpm_vast_aniview_prev("");
    }

    const [role, setRole] = useState("admin");
    // For these roles the GAM TV-app / Override-UPR / UPR-Category fields are hidden
    const isGamRestricted = role === "admin" || role === "u_admin" || role === "am";
    const [buttonProcessing, setButtonProcessing] = useState(false);


    const [formType, setFormType] = useState("");
    const [formTypeOption] = useState([
        { label: "Prebid", value: "Prebid" },
        { label: "Open RTB", value: "Open RTB" },
        { label: "GAM", value: "GAM" },
        { label: "Vast Publica", value: "publica" },
        { label: "Vast Adkernel", value: "Vast Zone" },
        { label: "Vast (Aniview)", value: "vast_aniview" },
        { label: "Player Tag (Instream)", value: "Player Tag" },
        { label: "Player Tag (Outstream)", value: "tag_outstream" },
        { label: "GAM Tag", value: "GAM Tag" },
    ]);





    // const [feedListRepeaterOptions, setFeedListRepeaterOptions] = useState([])
    // const [feedListRepeater, setFeedListRepeater] = useState([]);
    // const [feedListRepeaterOldData, setFeedListRepeaterOldData] = useState([]);


    // const handleChangeFeedProviderId = (e, index) => {
    //     const listTrigger = [...feedListRepeater];
    //     listTrigger[index]["feed_provider_id"] = e;
    //     listTrigger[index]["validation_feed_provider_id"] = false;
    //     setFeedListRepeater(listTrigger);
    // };

    // const handleChangeRemoteId = (e, index) => {
    //     const listTrigger = [...feedListRepeater];
    //     if (/^[\d\W]*$/.test(e.target.value.trim())) {

    //         listTrigger[index]["remote_id"] = e.target.value.trim();
    //         if (e.target.value.trim().length === 0) {
    //             listTrigger[index]["validation_remote_id"] = true;
    //         }
    //         else {
    //             listTrigger[index]["validation_remote_id"] = false;
    //         }
    //         setFeedListRepeater(listTrigger);
    //     }

    // };

    // const handleRemoveFeedListRepeater = (index) => {
    //     let listTrigger = [...feedListRepeater];
    //     listTrigger.splice(index, 1);
    //     setFeedListRepeater(listTrigger);
    // };

    // const handleAddFeedListRepeater = () => {
    //     setFeedListRepeater([
    //         ...feedListRepeater,
    //         {
    //             feed_provider_id: "",
    //             remote_id: "",
    //             validation_feed_provider_id: false,
    //             validation_remote_id: false
    //         },
    //     ]);
    // };




    // const validateFeedListRepeater = () => {
    //     setFeedListRepeater(prevFeedListRepeater =>
    //         prevFeedListRepeater.map(item => {
    //             const isFeedProviderIdEmpty = item.feed_provider_id === "";
    //             const isRemoteIdEmpty = item.remote_id === "";

    //             return {
    //                 ...item,
    //                 validation_feed_provider_id: isFeedProviderIdEmpty, // Set to true if feed_provider_id is empty
    //                 validation_remote_id: isRemoteIdEmpty // Set to true if remote_id is empty
    //             };
    //         })
    //     );

    //     // Return true if all fields are filled, false if any are empty
    //     return feedListRepeater.every(item => item.feed_provider_id !== "" && item.remote_id !== "");
    // };



    /////////////////////////////////////////////////////prebaid code /////////////////////////////////////////
    const [platformType_prebid, setPlatformType_prebid] = useState("");
    const [formatType_prebid, setFormatType_prebid] = useState([]);
    const [formatTypeIsRequiredError_prebid] = useState(false);
    // const [formatTypeOptions_prebid, setFormatTypeOptions_prebid] = useState([
    //     { label: "Banner", value: "Banner" },
    //     { label: "Video", value: "Video" },
    //     { label: "Native", value: "Native" },
    // ]);
    const [integrationType_prebid, setIntegrationType_prebid] =
        useState("");
    const [integrationTypeOptions_prebid, setIntegrationTypeOptions_prebid] =
        useState([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
    const [bannerCheckbox_prebid, setBannerCheckbox_prebid] = useState(null);


    const [zoneActiveCheckbox_prebid, setZoneActiveCheckbox_prebid] =
        useState(true);
    const [zoneName_prebid, setZoneName_prebid] = useState("");
    const [zoneNameIsRequiredError_prebid, setZoneNameIsRequiredError_prebid] =
        useState(false);

    const [revSharePercent_prebid, setRevSharePercent_prebid] = useState("");
    const [revSharePercentIsRequiredError_prebid, setRevSharePercentIsRequiredError_prebid] = useState(false);
    const [revSharePercentValidError_prebid, setRevSharePercentValidError_prebid] = useState(false);
    const [highestBidFloorCheckbox_prebid, setHighestBidFloorCheckbox_prebid] =
        useState(false);
    const [minCpm_prebid, setMinCpm_prebid] = useState("");
    const [minCpmValueError_prebid, setMinCpmValueError_prebid] = useState(false);
    const [maxCpm_prebid, setMaxCpm_prebid] = useState("");
    const [maxCpmValueError_prebid, setMaxCpmValueError_prebid] = useState(false);

    const [request_prebid, setRequest_prebid] = useState("");
    const [impression_prebid, setImpression_prebid] = useState("");

    const [human_prebid, setHuman_prebid] = useState("");
    const [humanValidError_prebid, setHumanValidError_prebid] = useState(false);
    const [pixalate_prebid, setPixalate_prebid] = useState("");
    const [pixalateValidError_prebid, setPixalateValidError_prebid] = useState(false);
    const [doubleverify_prebid, setDoubleverify_prebid] = useState("");
    const [doubleverifyValidError_prebid, setDoubleverifyValidError_prebid] = useState(false);

    function reset_prebid() {
        setPlatformType_prebid("");
        setFormatType_prebid([]);
        // setFormatTypeOptions_prebid([
        //     { label: "Banner", value: "Banner" },
        //     { label: "Video", value: "Video" },
        //     { label: "Native", value: "Native" },
        // ]);
        setIntegrationType_prebid("");
        setIntegrationTypeOptions_prebid([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
        setBannerCheckbox_prebid(null);
        setZoneActiveCheckbox_prebid(true);
        setZoneName_prebid("");
        setZoneNameIsRequiredError_prebid(false)

        setRevSharePercent_prebid("")
        setRevSharePercentIsRequiredError_prebid(false)
        setRevSharePercentValidError_prebid(false)
        setHighestBidFloorCheckbox_prebid(false)
        setMinCpm_prebid("")
        setMinCpmValueError_prebid(false)
        setMaxCpm_prebid("")
        setMaxCpmValueError_prebid(false)

        setRequest_prebid("");
        setImpression_prebid("");
        setHuman_prebid("");
        setHumanValidError_prebid(false);
        setPixalate_prebid("");
        setPixalateValidError_prebid(false);
        setDoubleverify_prebid("");
        setDoubleverifyValidError_prebid(false);
    }

    function onChangeZoneName_prebid(event) {
        setZoneNameIsRequiredError_prebid(false);
        setZoneName_prebid(event.target.value);
        setNameExists((p) => ({ ...p, prebid: false }));
        debouncedCheckZoneName("prebid", event.target.value);
    }

    function onBlurZoneName_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_prebid(true);
        }
        setZoneName_prebid(event.target.value.trim());
        if (nameCheckTimers.current.prebid) clearTimeout(nameCheckTimers.current.prebid);
        checkZoneNameUnique("prebid", event.target.value.trim());
    }


    function onChangeRevSharePercent_prebid(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setRevSharePercent_prebid(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0.1 && Number(event.target.value.trim()) <= 100) {
                setRevSharePercentValidError_prebid(false)
                setRevSharePercentIsRequiredError_prebid(false)
            }
            else {
                if (event.target.value.trim() === "") {
                    setRevSharePercentValidError_prebid(false)
                    setRevSharePercentIsRequiredError_prebid(true)
                }
                else {
                    setRevSharePercentIsRequiredError_prebid(false)
                    setRevSharePercentValidError_prebid(true)
                }
            }
        }
    }

    function onBlurRevSharePercent_prebid(event) {
        if (event.target.value.trim() === "") {
            setRevSharePercentIsRequiredError_prebid(true)
        }

    }

    function onChangeHighestBidFloorCheckbox_prebid(event) {
        setHighestBidFloorCheckbox_prebid(event.target.checked);
    }

    function onChangeMinCpm_prebid(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

            setMinCpm_prebid(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMinCpmValueError_prebid(false);

            } else {
                let minValCheck = 0.00001;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {

                    setMinCpmValueError_prebid(true);
                } else {

                    setMinCpmValueError_prebid(false);
                }
            }
        }
    }


    function onChangeMaxCpm_prebid(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxCpm_prebid(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMaxCpmValueError_prebid(false);

            } else {
                let minValCheck = 0.00001;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMaxCpmValueError_prebid(true);
                } else {
                    setMaxCpmValueError_prebid(false);
                }
            }
        }
    }

    function onChangeHuman_prebid(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setHuman_prebid(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setHumanValidError_prebid(false);
            } else {
                setHumanValidError_prebid(true);
            }
        }
    }

    function onBlurHuman_prebid(event) {
        setHuman_prebid(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setHumanValidError_prebid(true);
        } else {
            setHumanValidError_prebid(false);
        }
    }

    // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
    /*
    function onChangePixalate_prebid(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setPixalate_prebid(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setPixalateValidError_prebid(false);
            } else {
                setPixalateValidError_prebid(true);
            }
        }
    }

    function onBlurPixalate_prebid(event) {
        setPixalate_prebid(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setPixalateValidError_prebid(true);
        } else {
            setPixalateValidError_prebid(false);
        }
    }
    */

    function onChangeDoubleverify_prebid(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDoubleverify_prebid(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setDoubleverifyValidError_prebid(false);
            } else {
                setDoubleverifyValidError_prebid(true);
            }
        }
    }

    function onBlurDoubleverify_prebid(event) {
        setDoubleverify_prebid(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setDoubleverifyValidError_prebid(true);
        } else {
            setDoubleverifyValidError_prebid(false);
        }
    }

    ///////////////////////////////////////////////////open rtb code ///////////////////////////////////////////
    const [platformType_openrtb, setPlatformType_openrtb] = useState("");
    const [formatType_openrtb, setFormatType_openrtb] = useState([]);

    const [integrationType_openrtb, setIntegrationType_openrtb] =
        useState("");
    const [integrationTypeOptions_openrtb, setIntegrationTypeOptions_openrtb] =
        useState([]);

    const [bannerCheckbox_openrtb, setBannerCheckbox_openrtb] = useState(null);
    const [zoneActiveCheckbox_openrtb, setZoneActiveCheckbox_openrtb] =
        useState(true);
    const [zoneName_openrtb, setZoneName_openrtb] = useState("");
    const [zoneNameIsRequiredError_openrtb, setZoneNameIsRequiredError_openrtb] =
        useState(false);

    const [revSharePercent_openrtb, setRevSharePercent_openrtb] = useState("");
    const [revSharePercentIsRequiredError_openrtb, setRevSharePercentIsRequiredError_openrtb] = useState(false);
    const [revSharePercentValidError_openrtb, setRevSharePercentValidError_openrtb] = useState(false);
    const [highestBidFloorCheckbox_openrtb, setHighestBidFloorCheckbox_openrtb] =
        useState(false);
    const [minCpm_openrtb, setMinCpm_openrtb] = useState("");
    const [minCpmValueError_openrtb, setMinCpmValueError_openrtb] = useState(false);
    const [maxCpm_openrtb, setMaxCpm_openrtb] = useState("");
    const [maxCpmValueError_openrtb, setMaxCpmValueError_openrtb] = useState(false);

    const [request_openrtb, setRequest_openrtb] = useState("");
    const [impression_openrtb, setImpression_openrtb] = useState("");

    const [human_openrtb, setHuman_openrtb] = useState("");
    const [humanValidError_openrtb, setHumanValidError_openrtb] = useState(false);
    const [pixalate_openrtb, setPixalate_openrtb] = useState("");
    const [pixalateValidError_openrtb, setPixalateValidError_openrtb] = useState(false);
    const [doubleverify_openrtb, setDoubleverify_openrtb] = useState("");
    const [doubleverifyValidError_openrtb, setDoubleverifyValidError_openrtb] = useState(false);

    function reset_openrtb() {
        setPlatformType_openrtb("");
        setFormatType_openrtb([]);

        setIntegrationType_openrtb("");
        // setIntegrationTypeOptions_openrtb([
        //     { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
        //     { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
        //     { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        // ]);
        setBannerCheckbox_openrtb(null);
        setZoneActiveCheckbox_openrtb(true);
        setZoneName_openrtb("");
        setZoneNameIsRequiredError_openrtb(false)
        setRevSharePercent_openrtb("")
        setRevSharePercentIsRequiredError_openrtb(false)
        setRevSharePercentValidError_openrtb(false)
        setHighestBidFloorCheckbox_openrtb(false)
        setMinCpm_openrtb("")
        setMinCpmValueError_openrtb(false)
        setMaxCpm_openrtb("")
        setMaxCpmValueError_openrtb(false)
        setRequest_openrtb("");
        setImpression_openrtb("");
        setHuman_openrtb("");
        setHumanValidError_openrtb(false);
        setPixalate_openrtb("");
        setPixalateValidError_openrtb(false);
        setDoubleverify_openrtb("");
        setDoubleverifyValidError_openrtb(false);
    }


    function onChangeZoneName_openrtb(event) {
        setZoneNameIsRequiredError_openrtb(false);
        setZoneName_openrtb(event.target.value);
        setNameExists((p) => ({ ...p, openrtb: false }));
        debouncedCheckZoneName("openrtb", event.target.value);
    }

    function onBlurZoneName_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_openrtb(true);
        }
        setZoneName_openrtb(event.target.value.trim());
        if (nameCheckTimers.current.openrtb) clearTimeout(nameCheckTimers.current.openrtb);
        checkZoneNameUnique("openrtb", event.target.value.trim());
    }


    function onChangeRevSharePercent_openrtb(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setRevSharePercent_openrtb(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0.1 && Number(event.target.value.trim()) <= 100) {
                setRevSharePercentValidError_openrtb(false)
                setRevSharePercentIsRequiredError_openrtb(false)
            }
            else {
                if (event.target.value.trim() === "") {
                    setRevSharePercentValidError_openrtb(false)
                    setRevSharePercentIsRequiredError_openrtb(true)
                }
                else {
                    setRevSharePercentIsRequiredError_openrtb(false)
                    setRevSharePercentValidError_openrtb(true)
                }
            }
        }
    }

    function onBlurRevSharePercent_openrtb(event) {
        if (event.target.value.trim() === "") {
            setRevSharePercentIsRequiredError_openrtb(true)
        }

    }

    function onChangeHighestBidFloorCheckbox_openrtb(event) {
        setHighestBidFloorCheckbox_openrtb(event.target.checked);
    }

    function onChangeMinCpm_openrtb(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

            setMinCpm_openrtb(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMinCpmValueError_openrtb(false);

            } else {
                let minValCheck = 0.00001;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {

                    setMinCpmValueError_openrtb(true);
                } else {

                    setMinCpmValueError_openrtb(false);
                }
            }
        }
    }


    function onChangeMaxCpm_openrtb(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxCpm_openrtb(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMaxCpmValueError_openrtb(false);

            } else {
                let minValCheck = 0.00001;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMaxCpmValueError_openrtb(true);
                } else {
                    setMaxCpmValueError_openrtb(false);
                }
            }
        }
    }

    function onChangeHuman_openrtb(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setHuman_openrtb(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setHumanValidError_openrtb(false);
            } else {
                setHumanValidError_openrtb(true);
            }
        }
    }

    function onBlurHuman_openrtb(event) {
        setHuman_openrtb(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setHumanValidError_openrtb(true);
        } else {
            setHumanValidError_openrtb(false);
        }
    }

    // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
    /*
    function onChangePixalate_openrtb(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setPixalate_openrtb(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setPixalateValidError_openrtb(false);
            } else {
                setPixalateValidError_openrtb(true);
            }
        }
    }

    function onBlurPixalate_openrtb(event) {
        setPixalate_openrtb(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setPixalateValidError_openrtb(true);
        } else {
            setPixalateValidError_openrtb(false);
        }
    }
    */

    function onChangeDoubleverify_openrtb(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDoubleverify_openrtb(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setDoubleverifyValidError_openrtb(false);
            } else {
                setDoubleverifyValidError_openrtb(true);
            }
        }
    }

    function onBlurDoubleverify_openrtb(event) {
        setDoubleverify_openrtb(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setDoubleverifyValidError_openrtb(true);
        } else {
            setDoubleverifyValidError_openrtb(false);
        }
    }

    /////////////////////////////////////////////////////publica code ///////////////////////////////////////////

    const [platformType_publica, setPlatformType_publica] = useState("CTV");

    const [vastVersion_publica, setVastVersion_publica] = useState("3");
    const [vastVersionOptions_publica] = useState([
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "4.1", value: "4.1" },
    ]);

    const [channelName_publica, setChannelName_publica] = useState("");
    const [channelNameIsRequiredError_publica, setChannelNameIsRequiredError_publica] =
        useState(false);

    const [region_publica, setRegion_publica] = useState("");
    const [regionIsRequiredError_publica, setRegionIsRequiredError_publica] = useState(false);
    const [regionOptions_publica] = useState([
        { label: "APAC", value: "ap-southeast-2" },
        { label: "Europe", value: "eu-west-1" },
        { label: "Japan", value: "ap-northeast-1" },
        { label: "USA", value: "us-east-1" },
    ]);

    const [eCpm_publica, setECpm_publica] = useState("");
    const [eCpmIsRequiredError_publica, setECpmIsRequiredError_publica] = useState(false);
    const [eCpmValidError_publica, setECpmValidError_publica] = useState(false);

    const [override_eCpm_Checkbox_publica, setOverride_eCpm_Checkbox_publica] =
        useState(false);
    const [eCpm_target_publica, setECpm_target_publica] = useState("");
    const [eCpm_target_IsRequiredError_publica, setECpm_target_IsRequiredError_publica] = useState(false);
    const [eCpm_target_ValidError_publica, setECpm_target_ValidError_publica] = useState(false);

    const [bidAdjustment_publica, setBidAdjustment_publica] = useState("");
    const [bidAdjustmentIsRequiredError_publica, setBidAdjustmentIsRequiredError_publica] = useState(false);
    const [bidAdjustmentValidError_publica, setBidAdjustmentValidError_publica] = useState(false);

    const [bidValue_publica, setBidValue_publica] = useState("");
    const [bidValueValidError_publica, setBidValueValidError_publica] = useState(false);

    const [asi_publica, setAsi_publica] = useState("");
    const [asiIsRequiredError_publica, setAsiIsRequiredError_publica] =
        useState(false);

    const [sid_publica, setSid_publica] = useState("");
    const [sidIsRequiredError_publica, setSidIsRequiredError_publica] =
        useState(false);

    const [name_publica, setName_publica] = useState("");
    const [nameIsRequiredError_publica, setNameIsRequiredError_publica] =
        useState(false);

    const [domain_publica, setDomain_publica] = useState("");
    const [domainIsRequiredError_publica, setDomainIsRequiredError_publica] =
        useState(false);


    const [isAddValueCheckbox_publica, setIsAddValueCheckbox_publica] =
        useState(false);
    const [override_publica, setOverride_publica] = useState("");

    const [isAddValueCheckbox_prebid, setIsAddValueCheckbox_prebid] = useState(false);
    const [override_prebid, setOverride_prebid] = useState("");
    const [isAddValueCheckbox_openrtb, setIsAddValueCheckbox_openrtb] = useState(false);
    const [override_openrtb, setOverride_openrtb] = useState("");
    const [isAddValueCheckbox_vastzone, setIsAddValueCheckbox_vastzone] = useState(false);
    const [override_vastzone, setOverride_vastzone] = useState("");
    const [template_vastzone, setTemplate_vastzone] = useState("");
    const [templateIsRequiredError_vastzone, setTemplateIsRequiredError_vastzone] = useState(false);
    const [templateOptions_vastzone, setTemplateOptions_vastzone] = useState({});
    const [templateText_vastzone, setTemplateText_vastzone] = useState("");
    const [isDropdownOpenTemplate_vastzone, setIsDropdownOpenTemplate_vastzone] = useState(false);



    function reset_publica() {
        setPlatformType_publica("CTV")
        setVastVersion_publica("3")
        setChannelName_publica("")
        setChannelNameIsRequiredError_publica(false)
        setRegion_publica("")
        setRegionIsRequiredError_publica(false)
        setECpm_publica("")
        setECpmIsRequiredError_publica(false)
        setECpmValidError_publica(false)
        setBidAdjustment_publica("")
        setBidAdjustmentIsRequiredError_publica(false)
        setBidAdjustmentValidError_publica(false)
        setBidValue_publica("")
        setBidValueValidError_publica(false)
        setAsi_publica("")
        setAsiIsRequiredError_publica(false)
        setSid_publica("")
        setSidIsRequiredError_publica(false)
        setName_publica("")
        setNameIsRequiredError_publica(false)
        setDomain_publica("")
        setDomainIsRequiredError_publica(false)
        setIsAddValueCheckbox_publica(false)
        setOverride_publica("")
        setTemplate_publica("")
        setTemplateIsRequiredError_publica(false)
        setTemplateText_publica("")
        setHuman_publica("");
        setHumanValidError_publica(false);
        setPixalate_publica("");
        setPixalateValidError_publica(false);
        setDoubleverify_publica("");
        setDoubleverifyValidError_publica(false);
    }


    function onChangePlatformType_publica(event) {
        setPlatformType_publica(event.target.value);
    }

    function onChangeVastVersion_publica(event) {
        setVastVersion_publica(event);
    }

    function onChangeChannelName_publica(event) {
        setChannelNameIsRequiredError_publica(false);
        setChannelName_publica(event.target.value);
        setNameExists((p) => ({ ...p, publica: false }));
        debouncedCheckZoneName("publica", event.target.value);
    }

    function onBlurChannelName_publica(event) {
        if (event.target.value.trim().length === 0) {
            setChannelNameIsRequiredError_publica(true);
        }
        setChannelName_publica(event.target.value.trim());
        if (nameCheckTimers.current.publica) clearTimeout(nameCheckTimers.current.publica);
        checkZoneNameUnique("publica", event.target.value.trim());
    }

    function onChangeRegion_publica(event) {
        setRegionIsRequiredError_publica(false)
        setRegion_publica(event);
    }

    function onChangeECpm_publica(event) {
        setECpmIsRequiredError_publica(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_publica(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0) {
                setECpmValidError_publica(false)
            }
            else {
                setECpmValidError_publica(true)
            }
        }
    }

    function onBlurECpm_publica(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_publica(false);
            setECpmIsRequiredError_publica(true);
        } else {
            if (Number(event.target.value.trim()) >= 0) {
                setECpmValidError_publica(false);
            } else {
                setECpmIsRequiredError_publica(false);
                setECpmValidError_publica(true);
            }
        }
        setECpm_publica(event.target.value.trim());

        if ((role !== "admin" && role !== "u_admin")) {
            if (event.target.value.trim().length > 0) {
                setBidAdjustment_publica(Math.round((Number(event.target.value.trim()) * 100) / (Number(event.target.value.trim()) + 2.5)))
                setBidAdjustmentIsRequiredError_publica(false)
                setBidAdjustmentValidError_publica(false)
            }
            else {
                setBidAdjustment_publica("")
                setBidAdjustmentValidError_publica(false)
                setBidAdjustmentIsRequiredError_publica(true)

            }
        }

    }


    function onChangeECpm_target_publica(event) {
        setECpm_target_IsRequiredError_publica(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_target_publica(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0) {
                setECpm_target_ValidError_publica(false)
            }
            else {
                setECpm_target_ValidError_publica(true)
            }
        }
    }

    function onBlurECpm_target_publica(event) {
        if (event.target.value.trim().length === 0) {
            setECpm_target_ValidError_publica(false);
            setECpm_target_IsRequiredError_publica(true);
        } else {
            if (Number(event.target.value.trim()) >= 0) {
                setECpm_target_ValidError_publica(false);
            } else {
                setECpm_target_IsRequiredError_publica(false);
                setECpm_target_ValidError_publica(true);
            }
        }
        setECpm_target_publica(event.target.value.trim());

        if ((role !== "admin" && role !== "u_admin")) {
            if (event.target.value.trim().length > 0) {
                setBidAdjustment_publica(Math.round((Number(event.target.value.trim()) * 100) / (Number(event.target.value.trim()) + 2.5)))
                setBidAdjustmentIsRequiredError_publica(false)
                setBidAdjustmentValidError_publica(false)
            }
            else {
                setBidAdjustment_publica("")
                setBidAdjustmentValidError_publica(false)
                setBidAdjustmentIsRequiredError_publica(true)

            }
        }

    }

    function onChangeBidAdjustment_publica(event) {
        setBidAdjustmentIsRequiredError_publica(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setBidAdjustment_publica(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100) {
                setBidAdjustmentValidError_publica(false)
            }
            else {
                setBidAdjustmentValidError_publica(true)
            }
        }
    }

    function onBlurBidAdjustment_publica(event) {
        if (event.target.value.trim().length === 0) {
            setBidAdjustmentValidError_publica(false);
            setBidAdjustmentIsRequiredError_publica(true);
        } else {
            if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100) {
                setBidAdjustmentValidError_publica(false);
            } else {
                setBidAdjustmentIsRequiredError_publica(false);
                setBidAdjustmentValidError_publica(true);
            }
        }
        setBidAdjustment_publica(event.target.value.trim());
    }

    function onChangeBidValue_publica(event) {
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setBidValue_publica(event.target.value.trim());
            if (Number(event.target.value.trim()) >= 0) {
                setBidValueValidError_publica(false)
            }
            else {
                setBidValueValidError_publica(true)
            }
        }
    }

    function onBlurBidValue_publica(event) {
        if (event.target.value.trim().length === 0) {
            setBidValueValidError_publica(false);
        } else {
            if (Number(event.target.value.trim()) >= 0) {
                setBidValueValidError_publica(false);
            } else {
                setBidValueValidError_publica(true);
            }
        }
        setBidValue_publica(event.target.value.trim());
    }


    function onChangeAsi_publica(event) {

        setAsiIsRequiredError_publica(false);
        setAsi_publica(event.target.value);
    }

    function onBlurAsi_publica(event) {
        if (event.target.value.trim().length === 0) {
            setAsiIsRequiredError_publica(true);
        }
        setAsi_publica(event.target.value.trim());
    }

    function onChangeSid_publica(event) {

        setSidIsRequiredError_publica(false);
        setSid_publica(event.target.value);
    }

    function onBlurSid_publica(event) {
        if (event.target.value.trim().length === 0) {
            setSidIsRequiredError_publica(true);
        }
        setSid_publica(event.target.value.trim());
    }

    function onChangeName_publica(event) {

        setNameIsRequiredError_publica(false);
        setName_publica(event.target.value);
    }

    function onBlurName_publica(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError_publica(true);
        }
        setName_publica(event.target.value.trim());
    }

    function onChangeDomain_publica(event) {

        setDomainIsRequiredError_publica(false);
        setDomain_publica(event.target.value);
    }

    function onBlurDomain_publica(event) {
        if (event.target.value.trim().length === 0) {
            setDomainIsRequiredError_publica(true);
        }
        setDomain_publica(event.target.value.trim());
    }


    function onChangeIsAddValueCheckbox_publica(event) {
        setIsAddValueCheckbox_publica(event.target.checked);
    }

    function onChangeOverride_publica(event) {

        setOverride_publica(event.target.value);
    }

    function onBlurOverride_publica(event) {

        setOverride_publica(event.target.value.trim());
    }

    function onChangeIsAddValueCheckbox_prebid(event) {
        setIsAddValueCheckbox_prebid(event.target.checked);
    }
    function onChangeOverride_prebid(event) {
        setOverride_prebid(event.target.value);
    }
    function onBlurOverride_prebid(event) {
        setOverride_prebid(event.target.value.trim());
    }

    function onChangeIsAddValueCheckbox_openrtb(event) {
        setIsAddValueCheckbox_openrtb(event.target.checked);
    }
    function onChangeOverride_openrtb(event) {
        setOverride_openrtb(event.target.value);
    }
    function onBlurOverride_openrtb(event) {
        setOverride_openrtb(event.target.value.trim());
    }

    function onChangeIsAddValueCheckbox_vastzone(event) {
        setIsAddValueCheckbox_vastzone(event.target.checked);
    }
    function onChangeOverride_vastzone(event) {
        setOverride_vastzone(event.target.value);
    }
    function onBlurOverride_vastzone(event) {
        setOverride_vastzone(event.target.value.trim());
    }

    function onChangeTemplate_vastzone(event) {
        setTemplateIsRequiredError_vastzone(false);
        setTemplate_vastzone(event);
        let selectedTemplate = (templateOptions_vastzone[platformType_vastzone] || [])?.find(
            (template) => template.value === event
        );
        setTemplateText_vastzone(selectedTemplate?.template);
    }


    //--------------------------------------------------------------------------------------------------------
    const [template_publica, setTemplate_publica] = useState("");
    const [templateIsRequiredError_publica, setTemplateIsRequiredError_publica] = useState(false);
    const [templateOptions_publica, setTemplateOptions_publica] = useState([]);

    const [templateText_publica, setTemplateText_publica] = useState("");

    const [human_publica, setHuman_publica] = useState("");
    const [humanValidError_publica, setHumanValidError_publica] = useState(false);
    const [pixalate_publica, setPixalate_publica] = useState("");
    const [pixalateValidError_publica, setPixalateValidError_publica] = useState(false);
    const [doubleverify_publica, setDoubleverify_publica] = useState("");
    const [doubleverifyValidError_publica, setDoubleverifyValidError_publica] = useState(false);

    function onChangeTemplate_publica(event) {
        setTemplateIsRequiredError_publica(false)
        setTemplate_publica(event);

        let selectedTemplate = templateOptions_publica?.find(
            (template) => template.value === event
        );

        setTemplateText_publica(selectedTemplate?.template)
    }

    // function onChangeHuman_publica(event) {
    //     if (/^\d*$/.test(event.target.value.trim())) {
    //         setHuman_publica(event.target.value.trim());
    //         if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
    //             setHumanValidError_publica(false);
    //         } else {
    //             setHumanValidError_publica(true);
    //         }
    //     }
    // }

    // function onBlurHuman_publica(event) {
    //     setHuman_publica(event.target.value.trim());
    //     if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
    //         setHumanValidError_publica(true);
    //     } else {
    //         setHumanValidError_publica(false);
    //     }
    // }

    // function onChangePixalate_publica(event) {
    //     if (/^\d*$/.test(event.target.value.trim())) {
    //         setPixalate_publica(event.target.value.trim());
    //         if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
    //             setPixalateValidError_publica(false);
    //         } else {
    //             setPixalateValidError_publica(true);
    //         }
    //     }
    // }

    // function onBlurPixalate_publica(event) {
    //     setPixalate_publica(event.target.value.trim());
    //     if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
    //         setPixalateValidError_publica(true);
    //     } else {
    //         setPixalateValidError_publica(false);
    //     }
    // }


    //modal opening template  ------
    const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
    const [isDropdownOpenTemplate, setIsDropdownOpenTemplate] = useState(false); // Control dropdown open state
    const [templateModalContext, setTemplateModalContext] = useState("publica"); // "publica" or "vastzone"

    const openTemplateModal = (context = "publica") => {
        setTemplateModalContext(context);
        setTemplateModalOpen(true);
        setIsDropdownOpenTemplate(false); // Close the Select dropdown
        setIsDropdownOpenTemplate_vastzone(false);
    };

    const closeTemplateModal = () => {
        setTemplateModalOpen(false);
        setNameTemplate_html("")
        setNameTemplate_htmlIsRequiredError(false)
        setTagTemplate_html("")
        setTagTemplate_htmlIsRequiredError(false)
    };



    const [nameTemplate_html, setNameTemplate_html] = useState("");
    const [nameTemplate_htmlIsRequiredError, setNameTemplate_htmlIsRequiredError] =
        useState(false);

    function onChangeNameTemplate_html(event) {
        setNameTemplate_htmlIsRequiredError(false);
        setNameTemplate_html(event.target.value);
    }

    function onBlurNameTemplate_html(event) {
        if (event.target.value.trim().length === 0) {
            setNameTemplate_htmlIsRequiredError(true);
        }
        setNameTemplate_html(event.target.value.trim());
    }

    const [tagTemplate_html, setTagTemplate_html] = useState("");
    const [tagTemplate_htmlIsRequiredError, setTagTemplate_htmlIsRequiredError] =
        useState(false);

    function onChangeTagTemplate_html(event) {
        setTagTemplate_htmlIsRequiredError(false);
        setTagTemplate_html(event.target.value);
    }

    function onBlurTagTemplate_html(event) {
        if (event.target.value.trim().length === 0) {
            setTagTemplate_htmlIsRequiredError(true);
        }
        setTagTemplate_html(event.target.value.trim());
    }

    function handleTemplateCreationValidation() {

        if (
            nameTemplate_html.trim().length !== 0 &&
            tagTemplate_html.trim().length !== 0
        ) {
            if (
                nameTemplate_htmlIsRequiredError === false &&
                tagTemplate_htmlIsRequiredError === false
            ) {

                let payload = {
                    label: nameTemplate_html.trim(),
                    value: tagTemplate_html.trim(),
                    zone_type: templateModalContext
                }

                if (templateModalContext === "vastzone") {
                    payload.invent_type = platformType_vastzone;
                }

                const token = Cookies.get("token_xapads_ssp");
                axios
                    .post(`${configData.SERVER_URL}${templateModalContext === "vastzone"
                        ? "zone/createAdkTemp"
                        : "publica/createTemp"
                        }`, payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            "x-access-token": token
                        },
                    })
                    .then((response) => {
                        notifysuccess(response.data.message);

                        const fetchEndpoint = templateModalContext === "vastzone" ? "zone/getAdKTempList" : "publica/templates";
                        axios
                            .get(configData.SERVER_URL + fetchEndpoint, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": token
                                },
                            })
                            .then((response) => {
                                if (templateModalContext === "vastzone") {
                                    setTemplateOptions_vastzone(response.data);
                                } else {
                                    setTemplateOptions_publica(response.data.data);
                                }
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                            });

                        closeTemplateModal()
                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error.response.data.message?.length !== 0) {
                                notifyfailure(error.response.data.message);
                                // setButtonProcessing(false)
                            }
                        } else {
                            notifycatch();
                            // setButtonProcessing(false)
                        }

                    });


            }

        }
        else {

            if (nameTemplate_html.trim().length === 0) {
                setNameTemplate_htmlIsRequiredError(true);
            }

            if (tagTemplate_html.trim().length === 0) {
                setTagTemplate_htmlIsRequiredError(true);
            }

        }

    }



    ///////////////////////////////////////////////////vast zone code ///////////////////////////////////////////

    const [platformType_vastzone, setPlatformType_vastzone] = useState("");

    const [streamPosition_vastzone, setStreamPosition_vastzone] = useState("");
    const [streamPositionOptions_vastzone, setStreamPositionOptions_vastzone] = useState([
        { label: "Outstream", value: "Outstream" },
        { label: "Instream", value: "Instream" },
    ]);

    const [zoneActiveCheckbox_vastzone, setZoneActiveCheckbox_vastzone] =
        useState(true);
    const [zoneName_vastzone, setZoneName_vastzone] = useState("");
    const [zoneNameIsRequiredError_vastzone, setZoneNameIsRequiredError_vastzone] =
        useState(false);



    const [revenueType_vastzone, setRevenueType_vastzone] = useState("");
    const [revenueTypeOptions_vastzone, setRevenueTypeOptions_vastzone] = useState([
        { label: "Fixed Price", value: "Fixed_Price" },
        { label: "Revshare", value: "Revshare" },
    ]);

    const [eCpm_vastzone, setECpm_vastzone] = useState("");
    const [eCpmIsRequiredError_vastzone, setECpmIsRequiredError_vastzone] = useState(false);
    const [eCpmValidError_vastzone, setECpmValidError_vastzone] = useState(false);

    const [override_eCpm_Checkbox_vastzone, setOverride_eCpm_Checkbox_vastzone] =
        useState(false);
    const [eCpm_target_vastzone, setECpm_target_vastzone] = useState("");
    const [eCpm_target_IsRequiredError_vastzone, setECpm_target_IsRequiredError_vastzone] = useState(false);
    const [eCpm_target_ValidError_vastzone, setECpm_target_ValidError_vastzone] = useState(false);


    const [revSharePercent_vastzone, setRevSharePercent_vastzone] = useState("");
    const [revSharePercentIsRequiredError_vastzone, setRevSharePercentIsRequiredError_vastzone] = useState(false);
    const [revSharePercentValidError_vastzone, setRevSharePercentValidError_vastzone] = useState(false);

    const [request_vastzone, setRequest_vastzone] = useState("");
    const [impression_vastzone, setImpression_vastzone] = useState("");

    const [human_vastzone, setHuman_vastzone] = useState("");
    const [humanValidError_vastzone, setHumanValidError_vastzone] = useState(false);
    const [pixalate_vastzone, setPixalate_vastzone] = useState("");
    const [pixalateValidError_vastzone, setPixalateValidError_vastzone] = useState(false);
    const [doubleverify_vastzone, setDoubleverify_vastzone] = useState("");
    const [doubleverifyValidError_vastzone, setDoubleverifyValidError_vastzone] = useState(false);

    function reset_vastzone() {
        setPlatformType_vastzone("");
        setStreamPosition_vastzone("");
        setStreamPositionOptions_vastzone([
            { label: "Outstream", value: "Outstream" },
            { label: "Instream", value: "Instream" },
        ]);

        setZoneActiveCheckbox_vastzone(true);
        setZoneName_vastzone("");
        setZoneNameIsRequiredError_vastzone(false)

        setRevenueType_vastzone("");
        setRevenueTypeOptions_vastzone([
            { label: "Fixed Price", value: "Fixed_Price" },
            { label: "Revshare", value: "Revshare" },
        ]);
        setECpm_vastzone("");
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(false);
        setRevSharePercent_vastzone("");
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(false);
        setHuman_vastzone("");
        setHumanValidError_vastzone(false);
        setPixalate_vastzone("");
        setPixalateValidError_vastzone(false);
        setDoubleverify_vastzone("");
        setDoubleverifyValidError_vastzone(false);
        setTemplate_vastzone("");
        setTemplateIsRequiredError_vastzone(false);
        setTemplateText_vastzone("");
    }

    function onChangeZoneName_vastzone(event) {
        setZoneNameIsRequiredError_vastzone(false);
        setZoneName_vastzone(event.target.value);
        setNameExists((p) => ({ ...p, vastzone: false }));
        debouncedCheckZoneName("vastzone", event.target.value);
    }

    function onBlurZoneName_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_vastzone(true);
        }
        setZoneName_vastzone(event.target.value.trim());
        if (nameCheckTimers.current.vastzone) clearTimeout(nameCheckTimers.current.vastzone);
        checkZoneNameUnique("vastzone", event.target.value.trim());
    }


    function onChangeECpm_vastzone(event) {
        setECpmIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setECpm_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false)
            }
            else {
                setECpmValidError_vastzone(true)
            }
        }
    }

    function onBlurECpm_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_vastzone(false);
            setECpmIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false);
            } else {
                setECpmIsRequiredError_vastzone(false);
                setECpmValidError_vastzone(true);
            }
        }
        setECpm_vastzone(event.target.value.trim());
    }

    function onChangeECpm_target_vastzone(event) {
        setECpm_target_IsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setECpm_target_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpm_target_ValidError_vastzone(false)
            }
            else {
                setECpm_target_ValidError_vastzone(true)
            }
        }
    }

    function onBlurECpm_target_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setECpm_target_ValidError_vastzone(false);
            setECpm_target_IsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpm_target_ValidError_vastzone(false);
            } else {
                setECpm_target_IsRequiredError_vastzone(false);
                setECpm_target_ValidError_vastzone(true);
            }
        }
        setECpm_target_vastzone(event.target.value.trim());
    }

    function onChangeRevSharePercent_vastzone(event) {
        setRevSharePercentIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setRevSharePercent_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false)
            }
            else {
                setRevSharePercentValidError_vastzone(true)
            }
        }
    }

    function onBlurRevSharePercent_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setRevSharePercentValidError_vastzone(false);
            setRevSharePercentIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false);
            } else {
                setRevSharePercentIsRequiredError_vastzone(false);
                setRevSharePercentValidError_vastzone(true);
            }
        }
        setRevSharePercent_vastzone(event.target.value.trim());
    }

    function onChangeHuman_vastzone(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setHuman_vastzone(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setHumanValidError_vastzone(false);
            } else {
                setHumanValidError_vastzone(true);
            }
        }
    }

    function onBlurHuman_vastzone(event) {
        setHuman_vastzone(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setHumanValidError_vastzone(true);
        } else {
            setHumanValidError_vastzone(false);
        }
    }

    // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
    /*
    function onChangePixalate_vastzone(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setPixalate_vastzone(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setPixalateValidError_vastzone(false);
            } else {
                setPixalateValidError_vastzone(true);
            }
        }
    }

    function onBlurPixalate_vastzone(event) {
        setPixalate_vastzone(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setPixalateValidError_vastzone(true);
        } else {
            setPixalateValidError_vastzone(false);
        }
    }
    */

    function onChangeDoubleverify_vastzone(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDoubleverify_vastzone(event.target.value.trim());
            if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
                setDoubleverifyValidError_vastzone(false);
            } else {
                setDoubleverifyValidError_vastzone(true);
            }
        }
    }

    function onBlurDoubleverify_vastzone(event) {
        setDoubleverify_vastzone(event.target.value.trim());
        if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
            setDoubleverifyValidError_vastzone(true);
        } else {
            setDoubleverifyValidError_vastzone(false);
        }
    }

    ///////////////////////////////////////////////////vast aniview tag code ///////////////////////////////////////////
    const [p_name_vast_aniview, setp_name_vast_aniview] = useState("");
    const [p_aniviewId_vast_aniview, setp_aniviewId_vast_aniview] = useState("");
    const [platformType_vast_aniview, setPlatformType_vast_aniview] = useState("Website");
    // const [platformType_vast_aniview_prev, setPlatformType_vast_aniview_prev] = useState("");

    const [channelName_vast_aniview, setChannelName_vast_aniview] = useState("");
    // const [channelName_vast_aniview_prev, setChannelName_vast_aniview_prev] = useState("");
    const [channelNameIsRequiredError_vast_aniview, setChannelNameIsRequiredError_vast_aniview] =
        useState(false);

    const [eCpm_vast_aniview, setECpm_vast_aniview] = useState("");
    // const [eCpm_vast_aniview_prev, setECpm_vast_aniview_prev] = useState("");
    const [eCpmIsRequiredError_vast_aniview, setECpmIsRequiredError_vast_aniview] = useState(false);
    const [eCpmValidError_vast_aniview, setECpmValidError_vast_aniview] = useState(false);

    function reset_vast_aniview() {
        setPlatformType_vast_aniview("Website");
        setChannelName_vast_aniview("");
        setChannelNameIsRequiredError_vast_aniview(false);
        setECpm_vast_aniview("");
        setECpmIsRequiredError_vast_aniview(false);
        setECpmValidError_vast_aniview(false);
    }

    function onChangePlatformType_vast_aniview(event) {
        setPlatformType_vast_aniview(event.target.value);

        //    if (publisherName !== "") {
        //      setChannelName_vast_aniview(
        //        publisherName + "_" + event.target.value 
        //      );
        //    }
        //    setChannelNameIsRequiredError_vast_aniview(false);
    }

    function onChangeChannelName_vast_aniview(event) {
        setChannelNameIsRequiredError_vast_aniview(false);
        setChannelName_vast_aniview(event.target.value);
    }

    function onBlurChannelName_vast_aniview(event) {
        if (event.target.value.trim().length === 0) {
            setChannelNameIsRequiredError_vast_aniview(true);
        }
        setChannelName_vast_aniview(event.target.value.trim());
    }



    function onChangeECpm_vast_aniview(event) {
        setECpmIsRequiredError_vast_aniview(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_vast_aniview(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vast_aniview(false)
            }
            else {
                setECpmValidError_vast_aniview(true)
            }
        }
    }

    function onBlurECpm_vast_aniview(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_vast_aniview(false);
            setECpmIsRequiredError_vast_aniview(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vast_aniview(false);
            } else {
                setECpmIsRequiredError_vast_aniview(false);
                setECpmValidError_vast_aniview(true);
            }
        }
        setECpm_vast_aniview(event.target.value.trim());
    }

    ///////////////////////////////////////////////////player tag code ///////////////////////////////////////////

    const [mainTableVideo_playertag, setMainTableVideo_playertag] = useState([]);
    const [platformType_playertag, setPlatformType_playertag] = useState("");

    const [playerMode_playertag, setPlayerMode_playertag] = useState("");
    const [playerModeOptions_playertag, setPlayerModeOptions_playertag] = useState([
        { label: "Article Video", value: "articleVideo" },
        { label: "Banner Video", value: "bannerVideo" },
    ]);

    const [floatingPosition_playertag, setFloatingPosition_playertag] = useState("");
    const [floatingPositionOptions_playertag] = useState([
        { label: "Bottom Right", value: "bottomRight" },
        { label: "Bottom Left", value: "bottomLeft" },
        { label: "Top Right", value: "topRight" },
        { label: "Top Left", value: "topLeft" },
        { label: "Top Center", value: "topCenter" },
        { label: "Bottom Center", value: "bottomCenter" },
    ]);
    const [floatingPositionOptions_tag_outstream] = useState([
        { label: "Default", value: "default" },
        { label: "Top Right", value: "topRight" },
        { label: "Top Left", value: "topLeft" },
    ]);

    const [channelName_playertag, setChannelName_playertag] = useState("");
    const [channelNameIsRequiredError_playertag, setChannelNameIsRequiredError_playertag] =
        useState(false);

    const [eCpm_playertag, setECpm_playertag] = useState("");
    const [eCpmIsRequiredError_playertag, setECpmIsRequiredError_playertag] = useState(false);
    const [eCpmValidError_playertag, setECpmValidError_playertag] = useState(false);

    function reset_playertag() {

        setPlatformType_playertag("");
        setPlayerMode_playertag("");
        setPlayerModeOptions_playertag([
            { label: "Article Video", value: "articleVideo" },
            { label: "Banner Video", value: "bannerVideo" },
        ]);

        setFloatingPosition_playertag("");
        setChannelName_playertag("");
        setChannelNameIsRequiredError_playertag(false)
        setECpm_playertag("");
        setECpmIsRequiredError_playertag(false)
        setECpmValidError_playertag(false)
        setMainTableVideo_playertag([])

    }



    function onChangeFloatingPosition_playertag(event) {
        setFloatingPosition_playertag(event);
    }

    function onChangeChannelName_playertag(event) {
        setChannelNameIsRequiredError_playertag(false);
        setChannelName_playertag(event.target.value);
    }

    function onBlurChannelName_playertag(event) {
        if (event.target.value.trim().length === 0) {
            setChannelNameIsRequiredError_playertag(true);
        }
        setChannelName_playertag(event.target.value.trim());
    }



    function onChangeECpm_playertag(event) {
        setECpmIsRequiredError_playertag(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_playertag(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_playertag(false)
            }
            else {
                setECpmValidError_playertag(true)
            }
        }
    }

    function onBlurECpm_playertag(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_playertag(false);
            setECpmIsRequiredError_playertag(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_playertag(false);
            } else {
                setECpmIsRequiredError_playertag(false);
                setECpmValidError_playertag(true);
            }
        }
        setECpm_playertag(event.target.value.trim());
    }


    // ///////////////////////////////Player tag modal related code ////////////////////////////////
    const videoRef1 = useRef([]);

    const handleFullscreen1 = (index) => {
        const videoElement = videoRef1.current[index];
        if (videoElement) {
            videoElement.currentTime = 0;

            if (videoElement.requestFullscreen) {
                videoElement.requestFullscreen();
            } else if (videoElement.mozRequestFullScreen) { /* Firefox */
                videoElement.mozRequestFullScreen();
            } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                videoElement.webkitRequestFullscreen();
            } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
                videoElement.msRequestFullscreen();
            }
        }
    };



    ///////////////////////////////////////////////////gam tag code ///////////////////////////////////////////

    const [accountName_gamtag, setAccountName_gamtag] = useState("");

    const [platformType_gamtag, setPlatformType_gamtag] = useState("");
    const [ownership_gamtag, setOwnership_gamtag] = useState("");
    const [ownershipOptions_gamtag, setOwnershipOptions_gamtag] = useState([
        { label: "Own", value: "Own" },
        { label: "Re-seller", value: "Re-seller" },
    ]);

    const [vastVersion_gamtag, setVastVersion_gamtag] = useState("");
    const [vastVersionOptions_gamtag, setVastVersionOptions_gamtag] = useState([
        { label: "VAST 2", value: "VAST 2" },
        { label: "VAST 3", value: "VAST 3" },
        { label: "VAST 4", value: "VAST 4" },
    ]);

    const [eCPM_gamtag, seteCPM_gamtag] = useState(null);
    const [eCPMOptions_gamtag, seteCPMOptions_gamtag] = useState([
        { label: "0.20", value: 0.20 },
        { label: "0.40", value: 0.40 },
        { label: "0.80", value: 0.80 },
        { label: "1.00", value: 1.00 },
        { label: "1.20", value: 1.20 }
    ]);

    function reset_gamtag() {
        setAccountName_gamtag("");

        setPlatformType_gamtag("");
        setOwnership_gamtag("");
        setOwnershipOptions_gamtag([
            { label: "Own", value: "Own" },
            { label: "Re-seller", value: "Re-seller" },
        ]);
        setVastVersion_gamtag("");
        setVastVersionOptions_gamtag([
            { label: "VAST 2", value: "VAST 2" },
            { label: "VAST 3", value: "VAST 3" },
            { label: "VAST 4", value: "VAST 4" },
        ]);
        seteCPM_gamtag(null);
        seteCPMOptions_gamtag([
            { label: 0.20, value: 0.20 },
            { label: 0.40, value: 0.40 },
            { label: 0.80, value: 0.80 },
            { label: 1.00, value: 1.00 },
            { label: 1.20, value: 1.20 }
        ]);
    }


    ///////////////////////////////////////////////////gam zone code ///////////////////////////////////////////

    // Multi-select dropdown open-state infra (mirrors PublisherReport)
    const [openSelectState_gam, setOpenSelectState_gam] = useState({});
    const refsMap_gam = useRef({});
    function getRef_gam(key) {
        if (!refsMap_gam.current[key]) {
            refsMap_gam.current[key] = React.createRef();
        }
        return refsMap_gam.current[key];
    }
    const toggleSelectOpen_gam = (key, open) => {
        setOpenSelectState_gam((prevState) => {
            if (prevState[key] === open) return prevState;
            return { ...prevState, [key]: open };
        });
        if (open) {
            setTimeout(() => {
                refsMap_gam.current[key]?.current?.focus();
            }, 500);
        } else {
            // clear the search input when the dropdown closes
            if (key === `sizes-gam`) setSearchSizesList_gam("");
            if (key === `companion-gam`) setSearchCompanionList_gam("");
            if (key === `sizes-gamtags`) setSearchTagSizes_gamtags("");
        }
    };

    // Traffic Type -> Website | Inapp | CTV
    const [platformType_gam, setPlatformType_gam] = useState("Website");
    // Format Type -> Banner | Video (CTV is forced to Video)
    const [formatType_gam, setFormatType_gam] = useState("Video");
    const [formatTypeOptions_gam] = useState([
        { label: "Video", value: "Video" },
        { label: "Banner", value: "Banner" },
    ]);
    // ── Zone-name uniqueness check (all non-GAM zone types) ────────────────────
    // Keyed by a field id (prebid/openrtb/publica/vastzone/aniview/playertag).
    // Hits gam-new/zone-name/check with the edited zoneId; response.data.nameExists === true => name already exists.
    const [nameExists, setNameExists] = useState({});
    const [nameChecking, setNameChecking] = useState({});
    const nameCheckSeq = useRef({});
    const nameCheckAbort = useRef({});
    const nameCheckTimers = useRef({});

    function checkZoneNameUnique(key, rawName) {
        const name = (rawName || "").trim();
        if (name === "" || name.length > 90) {
            setNameExists((p) => ({ ...p, [key]: false }));
            setNameChecking((p) => ({ ...p, [key]: false }));
            return;
        }
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        // cancel any in-flight check for this field so only the latest request resolves
        if (nameCheckAbort.current[key]) nameCheckAbort.current[key].abort();
        const controller = new AbortController();
        nameCheckAbort.current[key] = controller;
        const seq = (nameCheckSeq.current[key] || 0) + 1;
        nameCheckSeq.current[key] = seq;
        setNameChecking((p) => ({ ...p, [key]: true }));
        axios
            .get(configData.SERVER_URL + "zone/zone-name/check", {
                params: { name, zoneId: id },
                headers: { "x-access-token": token },
                signal: controller.signal,
            })
            .then((response) => {
                if (nameCheckSeq.current[key] !== seq) return;
                setNameExists((p) => ({ ...p, [key]: response.data?.nameExists === true }));
                setNameChecking((p) => ({ ...p, [key]: false }));
            })
            .catch((error) => {
                if (axios.isCancel(error)) return;
                if (nameCheckSeq.current[key] !== seq) return;
                setNameExists((p) => ({ ...p, [key]: false }));
                setNameChecking((p) => ({ ...p, [key]: false }));
            });
    }

    function debouncedCheckZoneName(key, name) {
        if (nameCheckTimers.current[key]) clearTimeout(nameCheckTimers.current[key]);
        nameCheckTimers.current[key] = setTimeout(() => checkZoneNameUnique(key, name), 500);
    }

    const [zoneName_gam, setZoneName_gam] = useState("");
    const [zoneNameIsRequiredError_gam, setZoneNameIsRequiredError_gam] = useState(false);
    const [zoneNameMaxError_gam, setZoneNameMaxError_gam] = useState(false);
    // Publisher name captured on load; used to rebuild the zone name when traffic/format type changes
    const [publisherName_gam, setPublisherName_gam] = useState("");

    // Sizes (multi-select) -> Banner uses sizes.json, Video uses vastMasterSizes.json
    const [sizesList_gam, setSizesList_gam] = useState([]);
    const [sizesIsRequiredError_gam, setSizesIsRequiredError_gam] = useState(false);
    const [searchSizesList_gam, setSearchSizesList_gam] = useState("");
    const sizesListOptions_gam = formatType_gam === "Video" ? gamVastMasterSizesData : gamSizesData;
    const filterSizesList_gam = sizesListOptions_gam?.filter((option) =>
        option.label.toLowerCase()?.includes(searchSizesList_gam.toLowerCase())
    );

    // Companion (multi-select, Video only) -> companionSizes.json
    const [companionList_gam, setCompanionList_gam] = useState([]);
    const [searchCompanionList_gam, setSearchCompanionList_gam] = useState("");
    const companionListOptions_gam = gamCompanionSizesData;
    const filterCompanionList_gam = companionListOptions_gam?.filter((option) =>
        option.label.toLowerCase()?.includes(searchCompanionList_gam.toLowerCase())
    );

    // TV app fields (CTV only) -> options fetched from /gam/ctv-applications
    const [tvAppNameCheckbox_gam, setTvAppNameCheckbox_gam] = useState(false);
    const [tvApplication_gam, setTvApplication_gam] = useState("");
    const [tvApplicationIsRequiredError_gam, setTvApplicationIsRequiredError_gam] = useState(false);
    const [tvApplicationOptions_gam, setTvApplicationOptions_gam] = useState([]);

    // Pricing
    const [fixedPrice_gam, setFixedPrice_gam] = useState("");
    const [fixedPriceIsRequiredError_gam, setFixedPriceIsRequiredError_gam] = useState(false);
    const [fixedPriceValidError_gam, setFixedPriceValidError_gam] = useState(false);
    // Set UPR is always disabled and auto = Fixed Price / (1 - 0.2)
    const [upr_gam, setUpr_gam] = useState("");
    // Override UPR -> when checked, an "Override Set UPR" input appears; its value drives the UPR Category auto-select
    const [overrideUpr_gam, setOverrideUpr_gam] = useState(false);
    const [overrideSetUpr_gam, setOverrideSetUpr_gam] = useState("");
    const [overrideSetUprIsRequiredError_gam, setOverrideSetUprIsRequiredError_gam] = useState(false);
    const [overrideSetUprValidError_gam, setOverrideSetUprValidError_gam] = useState(false);
    const [uprCategory_gam, setUprCategory_gam] = useState("");
    const [uprCategoryIsRequiredError_gam, setUprCategoryIsRequiredError_gam] = useState(false);
    // true when the driving value is greater than every category's expected_amount_usd (no match)
    const [uprCategoryNotFoundError_gam, setUprCategoryNotFoundError_gam] = useState(false);
    // true when a category (exact or nearest greater) was successfully matched -> show "matched" message
    const [uprCategoryMatched_gam, setUprCategoryMatched_gam] = useState(false);
    const [uprCategoryOptions_gam, setUprCategoryOptions_gam] = useState([]);
    const [zoneActiveCheckbox_gam, setZoneActiveCheckbox_gam] = useState(true);

    // Fetch CTV applications once (label: "displayName (appStoreId)", value: id)
    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "gam-new/ctv-applications", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    const apps = response.data?.data || [];
                    setTvApplicationOptions_gam(
                        apps.map((app) => ({
                            label: `${app.displayName} (${app.appStoreId})`,
                            value: app.id,
                        }))
                    );
                })
                .catch((error) => { });
        }
    }, []);

    // Fetch UPR placements once (label: upr_name, value: upr_id, expected: expected_amount_usd)
    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "upr-placement/", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    const uprs = response.data?.data || [];
                    setUprCategoryOptions_gam(
                        uprs.map((upr) => ({
                            label: upr.upr_name,
                            value: upr.upr_id,
                            expected: upr.expected_amount_usd,
                        }))
                    );
                })
                .catch((error) => { });
        }
    }, []);

    function buildZoneName_gam(platform, format) {
        if (publisherName_gam === "") return zoneName_gam;
        // Zone Name format: PublisherName-TrafficType-FormatType
        return publisherName_gam + "-" + platform + "-" + format;
    }

    function reset_gam() {
        setPlatformType_gam("Website");
        setFormatType_gam("Video");
        setZoneName_gam("");
        setZoneNameIsRequiredError_gam(false);
        setZoneNameMaxError_gam(false);
        setNameExists((p) => ({ ...p, gam: false }));
        setSizesList_gam([]);
        setSizesIsRequiredError_gam(false);
        setSearchSizesList_gam("");
        setCompanionList_gam([]);
        setSearchCompanionList_gam("");
        setTvAppNameCheckbox_gam(false);
        setTvApplication_gam("");
        setTvApplicationIsRequiredError_gam(false);
        setFixedPrice_gam("");
        setFixedPriceIsRequiredError_gam(false);
        setFixedPriceValidError_gam(false);
        setUpr_gam("");
        setOverrideUpr_gam(false);
        setOverrideSetUpr_gam("");
        setOverrideSetUprIsRequiredError_gam(false);
        setOverrideSetUprValidError_gam(false);
        setUprCategory_gam("");
        setUprCategoryIsRequiredError_gam(false);
        setUprCategoryNotFoundError_gam(false);
        setUprCategoryMatched_gam(false);
        setZoneActiveCheckbox_gam(true);
    }

    ///////////////////////////////////////////////////gam zone tags tab code ///////////////////////////////////////////
    // Overview | Tags tabs (GAM zone only). Tags tab is always a fresh form on open.
    const [activeTab_gam, setActiveTab_gam] = useState("overview");

    const [tagTypeOptions_gamtags] = useState([
        { label: "Google Publisher Tag", value: "GPT" },
        { label: "Mobile Application Tag", value: "MobileApp" },
        { label: "GPT for Video and Audio", value: "GPT_Video" },
    ]);
    const [tagType_gamtags, setTagType_gamtags] = useState("GPT");

    // Google Publisher Tag option
    const [createPassback_gamtags, setCreatePassback_gamtags] = useState(false);

    // GPT for Video and Audio options  (sdk: IMA | PAL | NO_SDK)
    const [sdkType_gamtags, setSdkType_gamtags] = useState("IMA");
    const [liveTraffic_gamtags, setLiveTraffic_gamtags] = useState(false);
    const [childDirected_gamtags, setChildDirected_gamtags] = useState(false);
    const [descriptionUrl_gamtags, setDescriptionUrl_gamtags] = useState("");
    const [descriptionUrlIsRequiredError_gamtags, setDescriptionUrlIsRequiredError_gamtags] = useState(false);

    // Shared options (all tag types)  (tagMode: single | per_size)
    const [tagSizes_gamtags, setTagSizes_gamtags] = useState([]);
    const [tagSizesIsRequiredError_gamtags, setTagSizesIsRequiredError_gamtags] = useState(false);
    const [searchTagSizes_gamtags, setSearchTagSizes_gamtags] = useState("");
    const [tagOutput_gamtags, setTagOutput_gamtags] = useState("single");

    // Sizes options are built from the zone's own gamData.sizes (banner + vast + companion)
    const [tagSizesOptions_gamtags, setTagSizesOptions_gamtags] = useState([]);
    const filterTagSizes_gamtags = tagSizesOptions_gamtags?.filter((option) =>
        option.label.toLowerCase()?.includes(searchTagSizes_gamtags.toLowerCase())
    );

    // Combine the zone's banner/vast/companion sizes into unique { label, value }
    // options. The value is the raw size (keeps payload/selection unchanged); the
    // label is the real display label looked up from each source's master JSON
    // (banner -> sizes.json, vast -> vastMasterSizes.json, companion -> companionSizes.json),
    // falling back to the value itself when no match is found.
    function buildTagSizesOptions_gamtags(sizes) {
        const toOptions = (values, masterList) =>
            (Array.isArray(values) ? values : []).map((value) => {
                const match = masterList?.find((option) => option.value === value);
                return { label: match ? match.label : value, value };
            });

        const all = [
            ...toOptions(sizes?.bannerSizes, gamSizesData),
            ...toOptions(sizes?.vastSizes, gamVastMasterSizesData),
            ...toOptions(sizes?.companionSizes, gamCompanionSizesData),
        ];

        // Dedupe by value, keeping the first occurrence (banner > vast > companion).
        const seen = new Set();
        const unique = all.filter((option) => {
            if (seen.has(option.value)) return false;
            seen.add(option.value);
            return true;
        });

        unique.sort((a, b) => {
            const [aw = 0, ah = 0] = String(a.value).split("x").map(Number);
            const [bw = 0, bh = 0] = String(b.value).split("x").map(Number);
            return (aw - bw) || (ah - bh);
        });
        return unique;
    }

    // Generated tag state + processing / downloading flags
    const [tagResponse_gamtags, setTagResponse_gamtags] = useState("");
    const [tagProcessing_gamtags, setTagProcessing_gamtags] = useState(false);
    const [tagDownloading_gamtags, setTagDownloading_gamtags] = useState(false);

    function reset_gamtags() {
        setActiveTab_gam("overview");
        setTagType_gamtags("GPT");
        setCreatePassback_gamtags(false);
        setSdkType_gamtags("IMA");
        setLiveTraffic_gamtags(false);
        setChildDirected_gamtags(false);
        setDescriptionUrl_gamtags("");
        setDescriptionUrlIsRequiredError_gamtags(false);
        setTagSizes_gamtags([]);
        setTagSizesIsRequiredError_gamtags(false);
        setSearchTagSizes_gamtags("");
        setTagOutput_gamtags("single");
        setTagResponse_gamtags("");
        setTagProcessing_gamtags(false);
        setTagDownloading_gamtags(false);
        setTagSizesOptions_gamtags([]);
    }

    // Changing tag type resets all tag options (and any previously generated tag)
    function onChangeTagType_gamtags(value) {
        setTagType_gamtags(value);
        setCreatePassback_gamtags(false);
        setSdkType_gamtags("IMA");
        setLiveTraffic_gamtags(false);
        setChildDirected_gamtags(false);
        setDescriptionUrl_gamtags("");
        setDescriptionUrlIsRequiredError_gamtags(false);
        setTagSizes_gamtags([]);
        setTagSizesIsRequiredError_gamtags(false);
        setSearchTagSizes_gamtags("");
        setTagOutput_gamtags("single");
        setTagResponse_gamtags("");
    }

    // Tag type is fixed by the zone's inventory (traffic) + format type and is
    // read-only in the tags form:
    //   Website + Banner          -> GPT       (Google Publisher Tag)
    //   Inapp   + Banner          -> MobileApp (Mobile Application Tag)
    //   Video (Website/Inapp/CTV) -> GPT_Video (GPT for Video and Audio)
    function getForcedGamTagType_gamtags(platform, format) {
        const effectiveFormat = platform === "CTV" ? "Video" : format;
        if (effectiveFormat === "Video") return "GPT_Video";
        if (platform === "Inapp") return "MobileApp";
        return "GPT";
    }

    function handleSearchTagSizes_gamtags(e) {
        setSearchTagSizes_gamtags(e.target.value);
    }
    function handleTagSizes_gamtags(value) {
        setTagSizes_gamtags((prev) =>
            prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
        );
        setTagSizesIsRequiredError_gamtags(false);
    }
    function handleSelectAllTagSizes_gamtags() {
        if (tagSizes_gamtags?.length === tagSizesOptions_gamtags?.length) {
            setTagSizes_gamtags([]);
        } else {
            setTagSizes_gamtags(tagSizesOptions_gamtags.map((o) => o.value));
            setTagSizesIsRequiredError_gamtags(false);
        }
    }

    // Request body shared by generate + download (zoneId goes as a query param)
    function buildTagPayload_gamtags() {
        let payload = {
            tagType: tagType_gamtags,     // GPT | MobileApp | GPT_Video
            tagMode: tagOutput_gamtags,   // single | per_size
            sizes: tagSizes_gamtags,

        };
        if (tagType_gamtags === "GPT") {
            payload.isPassback = createPassback_gamtags;
        }
        else {
            payload.isPassback = false;
        }

        if (tagType_gamtags === "GPT_Video") {
            payload.sdk = sdkType_gamtags;   // IMA | PAL | NO_SDK
            payload.liveTraffic = liveTraffic_gamtags;
            payload.childDirected = childDirected_gamtags;
            const descUrl_gamtags = descriptionUrl_gamtags.trim().replace(/^https?:\/\//i, "");
            payload.descriptionUrl = descUrl_gamtags === "" ? "" : "https://" + descUrl_gamtags;
        }
        else {
            payload.sdk = "";   // IMA | PAL | NO_SDK
            payload.liveTraffic = false;
            payload.childDirected = false;
            payload.descriptionUrl = "";
        }
        return payload;
    }

    // Validate the tag-options form (shared by generate + download)
    function validateTagForm_gamtags() {
        let hasError = false;
        if (!tagSizes_gamtags || tagSizes_gamtags.length === 0) {
            setTagSizesIsRequiredError_gamtags(true);
            hasError = true;
        }
        if (tagType_gamtags === "GPT_Video" && descriptionUrl_gamtags.trim() === "") {
            setDescriptionUrlIsRequiredError_gamtags(true);
            hasError = true;
        }
        return !hasError;
    }

    // Number of tags produced: 1 for "single", else one per selected size
    const tagCount_gamtags = tagOutput_gamtags === "single" ? 1 : (tagSizes_gamtags?.length || 0);

    // Download button label (mirrors the artifact produced per tag type)
    function getDownloadLabel_gamtags() {
        if (tagType_gamtags === "GPT") return "Download Header + Body";
        if (tagType_gamtags === "MobileApp") return "Download Ad Unit";
        return "Download Tag";
    }

    // Validate + call createTagGam123; on success the tags summary is shown
    function handleGenerateTag_gamtags() {
        if (!validateTagForm_gamtags()) return;

        setTagProcessing_gamtags(true);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `zone/tag?zoneId=` + id, buildTagPayload_gamtags(), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setTagResponse_gamtags(response.data?.data || {});
                    setTagProcessing_gamtags(false);
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error.response.data.message?.length !== 0) {
                            notifyfailure(error.response.data.message);
                        }
                    } else {
                        notifycatch();
                    }
                    setTagProcessing_gamtags(false);
                });
        } else {
            setTagProcessing_gamtags(false);
        }
    }

    // Download the generated tags as an Excel file (downloadtag12345)
    function handleDownloadTag_gamtags() {
        // if (!validateTagForm_gamtags()) return;

        setTagDownloading_gamtags(true);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `zone/tag/download?zoneId=` + id, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data?.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `tags_${id}_${new Date().getTime()}.xlsx`;
                    a.click();
                    URL.revokeObjectURL(url);
                    setTagDownloading_gamtags(false);
                })
                .catch((error) => {
                    notifyfailure("Failed to download tags.");
                    setTagDownloading_gamtags(false);
                });
        } else {
            setTagDownloading_gamtags(false);
        }
    }

    function onChangePlatformType_gam(event) {
        const value = event.target.value;
        setPlatformType_gam(value);
        // For CTV, video is selected by default. For Web/Inapp default to Banner.
        const nextFormat = value === "CTV" ? "Video" : formatType_gam;
        // switching format resets sizes and companion dropdowns

        if (value === "CTV") {
            setFormatType_gam("Video")
            if (formatType_gam !== "Video") {

                setSizesList_gam([]);
                setSizesIsRequiredError_gam(false);
                setCompanionList_gam([]);
            }
        }

        if (value !== "CTV") {
            // TV app fields are relevant to CTV only
            setTvAppNameCheckbox_gam(false);
            setTvApplication_gam("");
            setTvApplicationIsRequiredError_gam(false);
        }
        setZoneNameIsRequiredError_gam(false);
        setZoneName_gam(buildZoneName_gam(value, nextFormat));
    }

    function onChangeFormatType_gam(event) {
        const value = event.target.value;
        setFormatType_gam(value);
        // switching format resets sizes and companion dropdowns
        setSizesList_gam([]);
        setSizesIsRequiredError_gam(false);
        setCompanionList_gam([]);
        setZoneNameIsRequiredError_gam(false);
        setZoneName_gam(buildZoneName_gam(platformType_gam, value));
    }

    function onChangeZoneName_gam(event) {
        const value = event.target.value;
        setZoneNameIsRequiredError_gam(false);
        setZoneNameMaxError_gam(value.length > 90);
        setNameExists((p) => ({ ...p, gam: false }));
        setZoneName_gam(value);
        debouncedCheckZoneName("gam", value);
    }

    function onBlurZoneName_gam(event) {
        const value = event.target.value.trim();
        if (value.length === 0) {
            setZoneNameIsRequiredError_gam(true);
        }
        setZoneNameMaxError_gam(value.length > 90);
        setZoneName_gam(value);
        if (nameCheckTimers.current.gam) clearTimeout(nameCheckTimers.current.gam);
        checkZoneNameUnique("gam", value);
    }


    // Sizes multi-select handlers (mandatory: at least one selection)
    const handleSearchSizesList_gam = (e) => {
        setSearchSizesList_gam(e.target.value);
    };
    function handleSelectAllSizesList_gam() {
        const allValues = sizesListOptions_gam.map((option) => option.value);
        if (sizesList_gam?.length !== sizesListOptions_gam?.length) {
            setSizesList_gam([...allValues]);
            setSizesIsRequiredError_gam(false);
        } else {
            setSizesList_gam([]);
        }
    }
    function handleSizesList_gam(value) {
        let temp = [...sizesList_gam];
        if (temp?.includes(value)) {
            temp = temp.filter((item) => item !== value);
        } else {
            temp = [...temp, value];
        }
        setSizesList_gam(temp);
        if (temp.length > 0) setSizesIsRequiredError_gam(false);
    }

    // Companion multi-select handlers
    const handleSearchCompanionList_gam = (e) => {
        setSearchCompanionList_gam(e.target.value);
    };
    function handleSelectAllCompanionList_gam() {
        const allValues = companionListOptions_gam.map((option) => option.value);
        if (companionList_gam?.length !== companionListOptions_gam?.length) {
            setCompanionList_gam([...allValues]);
        } else {
            setCompanionList_gam([]);
        }
    }
    function handleCompanionList_gam(value) {
        let temp = [...companionList_gam];
        if (temp?.includes(value)) {
            temp = temp.filter((item) => item !== value);
        } else {
            temp = [...temp, value];
        }
        setCompanionList_gam(temp);
    }

    function onChangeTvAppNameCheckbox_gam(event) {
        setTvAppNameCheckbox_gam(event.target.checked);
        if (!event.target.checked) {
            setTvApplication_gam("");
            setTvApplicationIsRequiredError_gam(false);
        }
    }

    function onChangeTvApplication_gam(event) {
        setTvApplication_gam(event);
        setTvApplicationIsRequiredError_gam(false);
    }

    // Match the given value against the UPR Category options' expected_amount_usd:
    //  - exact match -> select that category
    //  - else nearest greater (ceiling) expected -> select that category (driving field left unchanged)
    //  - if every expected is less than the value -> clear the category and show "match not found"
    // targetOverride is kept for call-site compatibility; the driving field is no longer overwritten.
    function autoSelectUprCategory_gam(rawValue, targetOverride) {
        const num = parseFloat(rawValue);
        const candidates = (uprCategoryOptions_gam || [])
            .filter((o) => typeof o.expected === "number" && !isNaN(o.expected))
            .sort((a, b) => a.expected - b.expected);
        if (isNaN(num) || candidates.length === 0) return;
        // smallest expected value that is >= the given value (exact match or nearest greater)
        const chosen = candidates.find((o) => o.expected >= num);
        if (!chosen) {
            // every expected_amount_usd is less than the value -> no match
            setUprCategory_gam("");
            setUprCategoryMatched_gam(false);
            setUprCategoryNotFoundError_gam(true);
            setUprCategoryIsRequiredError_gam(false);
            return;
        }
        setUprCategory_gam(chosen.value);
        // Set UPR / Override Set UPR keep their computed/entered value; only the category reflects the nearest-ceiling match
        setUprCategoryIsRequiredError_gam(false);
        setUprCategoryNotFoundError_gam(false);
        setUprCategoryMatched_gam(true);
    }

    function onChangeFixedPrice_gam(event) {
        const value = event.target.value;
        setFixedPriceIsRequiredError_gam(false);
        setFixedPriceValidError_gam(false);
        // the Set UPR is about to change -> drop any stale category match/not-found state
        setUprCategoryNotFoundError_gam(false);
        setUprCategoryMatched_gam(false);
        // number only (allow decimals)
        if (value === "" || /^\d*\.?\d*$/.test(value)) {
            setFixedPrice_gam(value);
            // Set UPR is auto = Fixed Price / (1 - 0.2) (always disabled), fixed to 2 decimals
            const num = parseFloat(value);
            setUpr_gam(!isNaN(num) ? (num / (1 - 0.2)).toFixed(2) : "");
        }
    }

    function onBlurFixedPrice_gam(event) {
        const value = event.target.value.trim();
        if (value === "") {
            setFixedPriceIsRequiredError_gam(true);
            return;
        }
        const num = parseFloat(value);
        // must be greater than 0
        if (isNaN(num) || num <= 0) {
            setFixedPriceValidError_gam(true);
            return;
        }
        const uprValue = (num / (1 - 0.2)).toFixed(2);
        setUpr_gam(uprValue);
        // Trigger 1: on fixed price blur -> auto-select category from the Set UPR value
        if (!overrideUpr_gam) {
            autoSelectUprCategory_gam(uprValue, false);
        }
    }

    function onChangeOverrideUpr_gam(event) {
        const checked = event.target.checked;
        setOverrideUpr_gam(checked);
        // Trigger 2: override checkbox toggle
        if (checked) {
            // if no value in Override Set UPR, default it to the Set UPR value
            let valueForCategory = overrideSetUpr_gam;
            if (overrideSetUpr_gam === "" || isNaN(parseFloat(overrideSetUpr_gam))) {
                if (upr_gam !== "" && !isNaN(parseFloat(upr_gam))) {
                    setOverrideSetUpr_gam(upr_gam);
                    setOverrideSetUprIsRequiredError_gam(false);
                    setOverrideSetUprValidError_gam(false);
                    valueForCategory = upr_gam;
                }
            }
            if (valueForCategory !== "" && !isNaN(parseFloat(valueForCategory))) {
                // checked -> drive the category from the Override Set UPR value
                autoSelectUprCategory_gam(valueForCategory, true);
            }
        } else {
            // unchecked -> clear override errors and drive the category from the Set UPR value
            setOverrideSetUprIsRequiredError_gam(false);
            setOverrideSetUprValidError_gam(false);
            autoSelectUprCategory_gam(upr_gam, false);
        }
    }

    function onChangeOverrideSetUpr_gam(event) {
        const value = event.target.value;
        setOverrideSetUprIsRequiredError_gam(false);
        setOverrideSetUprValidError_gam(false);
        // the value driving the category is about to change -> drop stale match/not-found state
        setUprCategoryNotFoundError_gam(false);
        setUprCategoryMatched_gam(false);
        // number only (allow decimals)
        if (value === "" || /^\d*\.?\d*$/.test(value)) {
            setOverrideSetUpr_gam(value);
        }
    }

    function onBlurOverrideSetUpr_gam(event) {
        // mandatory & same validation as fixed price (must be > 0)
        const value = event.target.value.trim();
        if (value === "") {
            setOverrideSetUprIsRequiredError_gam(true);
            return;
        }
        const num = parseFloat(value);
        if (isNaN(num) || num <= 0) {
            setOverrideSetUprValidError_gam(true);
            return;
        }
        // Trigger 3: override set upr blur (relevant while override is checked)
        autoSelectUprCategory_gam(value, true);
    }

    function onChangeUprCategory_gam(event) {
        setUprCategoryIsRequiredError_gam(false);
        setUprCategoryNotFoundError_gam(false);
        setUprCategory_gam(event);
        // manual selection -> copy the selected category's expected_amount_usd into the driving field
        // (Override Set UPR when Override UPR is checked, otherwise Set UPR)
        const selected = (uprCategoryOptions_gam || []).find((o) => o.value === event);
        if (selected && typeof selected.expected === "number" && !isNaN(selected.expected)) {
            const expectedStr = Number(selected.expected).toFixed(2);
            if (overrideUpr_gam) {
                setOverrideSetUpr_gam(expectedStr);
                setOverrideSetUprIsRequiredError_gam(false);
                setOverrideSetUprValidError_gam(false);
            } else {
                setUpr_gam(expectedStr);
            }
        }
        setUprCategoryMatched_gam(!!event);
    }

    // true when the selected category differs from the one the Set UPR (upr_gam) value implies.
    // Always derived live from the Set UPR value so manually picking a category that doesn't match it surfaces the alert.
    function isUprCategoryMismatch_gam() {
        if (!uprCategory_gam) return false;
        const num = parseFloat(upr_gam);
        if (isNaN(num)) return false;
        const candidates = (uprCategoryOptions_gam || [])
            .filter((o) => typeof o.expected === "number" && !isNaN(o.expected))
            .sort((a, b) => a.expected - b.expected);
        if (candidates.length === 0) return false;
        // smallest expected value that is >= the Set UPR value (the category it should be)
        const expectedCat = candidates.find((o) => o.expected >= num);
        if (!expectedCat) return false; // no match -> handled by the "not found" error instead
        return uprCategory_gam !== expectedCat.value;
    }

    function onChangeZoneActiveCheckbox_gam(event) {
        setZoneActiveCheckbox_gam(event.target.checked);
    }


    ///////////////////////////////////////submit //////////////////////////////////////////////////////////////////
    const channelDetailsRef = useRef(null)
    const supplyDetailsRef = useRef(null)

    const errorDetect = () => {

        if ((role !== "admin" && role !== "u_admin")) {


            if (channelName_publica.trim() === "" || channelNameIsRequiredError_publica || region_publica === "" || regionIsRequiredError_publica || eCpm_publica === "" || eCpmIsRequiredError_publica || eCpmValidError_publica || bidAdjustment_publica === "" || bidAdjustmentIsRequiredError_publica || bidAdjustmentValidError_publica || bidValueValidError_publica) {
                scrollToItem(channelDetailsRef);
                return
            }

            if (asi_publica.trim() === "" || asiIsRequiredError_publica || sid_publica.trim() === "" || sidIsRequiredError_publica || name_publica.trim() === "" || nameIsRequiredError_publica || domain_publica.trim() === "" || domainIsRequiredError_publica) {
                scrollToItem(supplyDetailsRef);
                return
            }
        }


    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // block submit if the active zone/channel name is a known duplicate (GAM handled in its own branch)
        const nameCheckKeyByFormType = {
            "Prebid": "prebid",
            "Open RTB": "openrtb",
            "publica": "publica",
            "Vast Zone": "vastzone",
            "GAM": "gam",
        };
        const activeNameKey = nameCheckKeyByFormType[formType];
        if (activeNameKey && nameExists[activeNameKey]) {
            notifyfailure("Zone name already exists");
            return;
        }

        if (formType === "Prebid") {



            // let feedListRepeaterTemp = []

            if (
                zoneName_prebid !== "" &&
                revSharePercent_prebid !== ""
                // validateFeedListRepeater()
            ) {
                if (
                    zoneNameIsRequiredError_prebid === false &&
                    revSharePercentIsRequiredError_prebid === false &&
                    revSharePercentValidError_prebid === false &&
                    minCpmValueError_prebid === false &&
                    maxCpmValueError_prebid === false &&
                    humanValidError_prebid === false &&
                    // PIXALATE SUNSET: pixalateValidError_prebid === false &&
                    doubleverifyValidError_prebid === false) {

                    // if (feedListRepeater.length > 0) {
                    //     feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)
                    // }

                    if ((role === "admin" || role === "u_admin") && (human_prebid === "" || /* PIXALATE SUNSET: pixalate_prebid === "" || */ doubleverify_prebid === "")) {
                        notifyfailure("Sampling values are empty");
                        return;
                    }

                    if ((role !== "admin" && role !== "u_admin") && (human_prebid === "" || /* PIXALATE SUNSET: pixalate_prebid === "" || */ doubleverify_prebid === "")) {
                        if (human_prebid === "") setHumanValidError_prebid(true);
                        // PIXALATE SUNSET: if (pixalate_prebid === "") setPixalateValidError_prebid(true);
                        if (doubleverify_prebid === "") setDoubleverifyValidError_prebid(true);
                        return;
                    }

                    let payload = {
                        // remoteIds: feedListRepeaterTemp,
                        remoteIds: [],
                        name: zoneName_prebid,
                        revshare: revSharePercent_prebid,
                        minEcpm: minCpm_prebid,
                        maxEcpm: maxCpm_prebid,
                        isHighestBidFloor: (minCpm_prebid === "" || minCpm_prebid === null) ? false : highestBidFloorCheckbox_prebid,
                        sampling_human: Number(human_prebid),
                        // PIXALATE SUNSET: not sent in payload
                        // sampling_pixalate: Number(pixalate_prebid),
                        sampling_dv: Number(doubleverify_prebid),
                        blockCategory: [...blockCategorySelected],
                    };
                    payload.ipd_bool = isAddValueCheckbox_prebid;
                    payload.ipd_value = override_prebid;

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(configData.SERVER_URL + `zone/editPrebidZone?zoneId=` + id, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }

                }

            }
            else {
                if (zoneName_prebid === "") {
                    setZoneNameIsRequiredError_prebid(true);
                }

                if (revSharePercent_prebid === "") {
                    setRevSharePercentIsRequiredError_prebid(true)
                }
            }


        }

        if (formType === "Open RTB") {



            // let feedListRepeaterTemp = []
            if (
                zoneName_openrtb !== "" &&
                revSharePercent_openrtb !== ""
                // validateFeedListRepeater()
            ) {
                if (
                    zoneNameIsRequiredError_openrtb === false &&
                    revSharePercentIsRequiredError_openrtb === false &&
                    revSharePercentValidError_openrtb === false &&
                    minCpmValueError_openrtb === false &&
                    maxCpmValueError_openrtb === false &&
                    humanValidError_openrtb === false &&
                    // PIXALATE SUNSET: pixalateValidError_openrtb === false &&
                    doubleverifyValidError_openrtb === false
                ) {

                    // if (feedListRepeater.length > 0) {
                    //     feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)
                    // }

                    if ((role === "admin" || role === "u_admin") && (human_openrtb === "" || /* PIXALATE SUNSET: pixalate_openrtb === "" || */ doubleverify_openrtb === "")) {
                        notifyfailure("Sampling values are empty");
                        return;
                    }

                    if ((role !== "admin" && role !== "u_admin") && (human_openrtb === "" || /* PIXALATE SUNSET: pixalate_openrtb === "" || */ doubleverify_openrtb === "")) {
                        if (human_openrtb === "") setHumanValidError_openrtb(true);
                        // PIXALATE SUNSET: if (pixalate_openrtb === "") setPixalateValidError_openrtb(true);
                        if (doubleverify_openrtb === "") setDoubleverifyValidError_openrtb(true);
                        return;
                    }

                    let payload = {
                        name: zoneName_openrtb,
                        // remoteIds: feedListRepeaterTemp,
                        remoteIds: [],
                        revshare: revSharePercent_openrtb,
                        minEcpm: minCpm_openrtb,
                        maxEcpm: maxCpm_openrtb,
                        isHighestBidFloor: (minCpm_openrtb === "" || minCpm_openrtb === null) ? false : highestBidFloorCheckbox_openrtb,
                        sampling_human: Number(human_openrtb),
                        // PIXALATE SUNSET: not sent in payload
                        // sampling_pixalate: Number(pixalate_openrtb),
                        sampling_dv: Number(doubleverify_openrtb),
                        blockCategory: [...blockCategorySelected],
                    };
                    payload.ipd_bool = isAddValueCheckbox_openrtb;
                    payload.ipd_value = override_openrtb;

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(configData.SERVER_URL + `zone/editORTBZone?zoneId=` + id, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }

                }

            }
            else {
                if (zoneName_openrtb === "") {
                    setZoneNameIsRequiredError_openrtb(true);
                }
                if (revSharePercent_openrtb === "") {
                    setRevSharePercentIsRequiredError_openrtb(true)
                }
            }

        }

        if (formType === "publica") {
            errorDetect()

            if ((role === "admin" || role === "u_admin")) {
                if (
                    region_publica !== "" &&
                    template_publica !== ""

                ) {
                    if (

                        regionIsRequiredError_publica === false &&
                        templateIsRequiredError_publica === false &&
                        humanValidError_publica === false &&
                        pixalateValidError_publica === false


                    ) {

                        if ((role === "admin" || role === "u_admin") && (human_publica === "" || pixalate_publica === "")) {
                            notifyfailure("Sampling values are empty");
                            return;
                        }

                        let payload = {
                            region: region_publica,
                            template: template_publica,
                            sampling_human: Number(human_publica),
                            sampling_pixalate: Number(pixalate_publica),
                            sampling_dv: Number(doubleverify_publica),
                        }


                        setButtonProcessing(true)

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            // setButtonValue(true);
                            let token = Cookies.get("token_xapads_ssp");

                            axios
                                .post(configData.SERVER_URL + `zone/editPublicaZone?zoneId=` + id, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    notifysuccess(response.data.message);
                                    handlePageViewChange("table", "yes")
                                    resetFormView()

                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message);
                                            setButtonProcessing(false)
                                        }
                                    } else {
                                        notifycatch();
                                        setButtonProcessing(false)
                                    }
                                });
                        }
                    }
                } else {
                    if (region_publica === "") {
                        setRegionIsRequiredError_publica(true)
                    }

                    if (template_publica === "") {
                        setTemplateIsRequiredError_publica(true)
                    }
                }

            }
            else {
                if (
                    channelName_publica !== "" &&
                    region_publica !== "" &&
                    eCpm_publica !== "" &&
                    bidAdjustment_publica !== "" &&
                    asi_publica !== "" &&
                    sid_publica !== "" &&
                    name_publica !== "" &&
                    domain_publica !== "" &&
                    template_publica !== "" &&
                    (override_eCpm_Checkbox_publica ? eCpm_target_publica !== "" : true)

                ) {
                    if (
                        channelNameIsRequiredError_publica === false &&
                        regionIsRequiredError_publica === false &&
                        eCpmIsRequiredError_publica === false &&
                        eCpmValidError_publica === false &&
                        bidAdjustmentIsRequiredError_publica === false &&
                        bidAdjustmentValidError_publica === false &&
                        bidValueValidError_publica === false &&
                        asiIsRequiredError_publica === false &&
                        sidIsRequiredError_publica === false &&
                        nameIsRequiredError_publica === false &&
                        domainIsRequiredError_publica === false &&
                        templateIsRequiredError_publica === false &&
                        humanValidError_publica === false &&
                        pixalateValidError_publica === false &&
                        (override_eCpm_Checkbox_publica ? eCpm_target_IsRequiredError_publica === false : true) &&
                        (override_eCpm_Checkbox_publica ? eCpm_target_ValidError_publica === false : true)

                    ) {
                        if (human_publica === "" || pixalate_publica === "") {
                            // if (human_publica === "") setHumanValidError_publica(true);
                            // if (pixalate_publica === "") setPixalateValidError_publica(true);
                            notifyfailure("Sampling values are empty");
                            return;
                        }

                        let payload = {
                            formType: formType,
                            invent_type: platformType_publica,
                            header_bidder_vast_version: vastVersion_publica,
                            channel_name: channelName_publica,
                            region: region_publica,
                            eCpm: eCpm_publica,
                            bid_adjustment: typeof bidAdjustment_publica === "number"
                                ? String(bidAdjustment_publica)
                                : bidAdjustment_publica,
                            bid_adjustment_value: bidValue_publica,
                            asi: asi_publica,
                            sid: sid_publica,
                            name: name_publica,
                            domain: domain_publica,
                            isAddValueCheckbox: isAddValueCheckbox_publica,
                            override: override_publica,
                            template: template_publica,
                            sampling_human: Number(human_publica),
                            sampling_pixalate: Number(pixalate_publica),
                            sampling_dv: Number(doubleverify_publica),
                        }

                        if (role === "sa" || role === "mobops" || role === "am") {
                            // if (override_eCpm_Checkbox_publica) {
                            payload.isTargetEcpm = override_eCpm_Checkbox_publica
                            payload.target_ecpm = Number(eCpm_target_publica)
                            // }
                        }



                        setButtonProcessing(true)

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            // setButtonValue(true);
                            let token = Cookies.get("token_xapads_ssp");

                            axios
                                .post(configData.SERVER_URL + `zone/editPublicaZone?zoneId=` + id, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    notifysuccess(response.data.message);
                                    handlePageViewChange("table", "yes")
                                    resetFormView()
                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message);
                                            setButtonProcessing(false)
                                        }
                                    } else {
                                        notifycatch();
                                        setButtonProcessing(false)
                                    }
                                    // setButtonValue(false);
                                });
                        }
                    }
                } else {

                    if (channelName_publica === "") {
                        setChannelNameIsRequiredError_publica(true);
                    }
                    if (region_publica === "") {
                        setRegionIsRequiredError_publica(true)
                    }

                    if (eCpm_publica === "") {
                        setECpmIsRequiredError_publica(true)
                    }

                    if (bidAdjustment_publica === "") {
                        setBidAdjustmentIsRequiredError_publica(true)
                    }

                    if (asi_publica === "") {
                        setAsiIsRequiredError_publica(true)
                    }

                    if (sid_publica === "") {
                        setSidIsRequiredError_publica(true)
                    }

                    if (name_publica === "") {
                        setNameIsRequiredError_publica(true)
                    }

                    if (domain_publica === "") {
                        setDomainIsRequiredError_publica(true)
                    }

                    if (template_publica === "") {
                        setTemplateIsRequiredError_publica(true)
                    }

                    if (override_eCpm_Checkbox_publica && eCpm_target_publica === "") {
                        setECpm_target_IsRequiredError_publica(true);
                    }


                }
            }
        }

        if (formType === "Vast Zone") {


            // let feedListRepeaterTemp = []
            if (
                zoneName_vastzone !== "" &&
                (override_eCpm_Checkbox_vastzone ? eCpm_target_vastzone !== "" : true)
                // validateFeedListRepeater()
                // (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
                // (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
            ) {
                if (
                    zoneNameIsRequiredError_vastzone === false &&
                    humanValidError_vastzone === false &&
                    // PIXALATE SUNSET: pixalateValidError_vastzone === false &&
                    doubleverifyValidError_vastzone === false &&
                    (override_eCpm_Checkbox_vastzone ? eCpm_target_IsRequiredError_vastzone === false : true) &&
                    (override_eCpm_Checkbox_vastzone ? eCpm_target_ValidError_vastzone === false : true)
                    // (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
                    // (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
                    // (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
                    // (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true)
                ) {



                    // if (feedListRepeater.length > 0) {

                    //     feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)

                    // }


                    if ((role === "admin" || role === "u_admin") && (human_vastzone === "" || /* PIXALATE SUNSET: pixalate_vastzone === "" || */ doubleverify_vastzone === "")) {
                        notifyfailure("Sampling values are empty");
                        return;
                    }

                    if ((role !== "admin" && role !== "u_admin") && (human_vastzone === "" || /* PIXALATE SUNSET: pixalate_vastzone === "" || */ doubleverify_vastzone === "")) {
                        if (human_vastzone === "") setHumanValidError_vastzone(true);
                        // PIXALATE SUNSET: if (pixalate_vastzone === "") setPixalateValidError_vastzone(true);
                        if (doubleverify_vastzone === "") setDoubleverifyValidError_vastzone(true);
                        return;
                    }

                    let payload =
                    {
                        name: zoneName_vastzone,
                        // remoteIds: feedListRepeaterTemp,
                        remoteIds: [],
                        sampling_human: Number(human_vastzone),
                        // PIXALATE SUNSET: not sent in payload
                        // sampling_pixalate: Number(pixalate_vastzone),
                        sampling_dv: Number(doubleverify_vastzone),
                        // fixed_cpm: Number(eCpm_vastzone),
                        blockCategory: [...blockCategorySelected],
                    }
                    payload.ipd_bool = isAddValueCheckbox_vastzone;
                    payload.ipd_value = override_vastzone;
                    if (template_vastzone) {
                        payload.template = template_vastzone;
                    }


                    if (role === "sa" || role === "mobops" || role === "am") {
                        // if (override_eCpm_Checkbox_vastzone) {
                        payload.isTargetEcpm = override_eCpm_Checkbox_vastzone
                        payload.target_ecpm = Number(eCpm_target_vastzone)
                        // }
                    }

                    // revenueType_vastzone === "Fixed_Price"
                    //     ? {
                    //         revenue_type: revenueType_vastzone,
                    //         fixed_cpm: Number(eCpm_vastzone),
                    //         remoteIds: feedListRepeaterTemp,


                    //     }
                    //     : {

                    //         revenue_type: revenueType_vastzone,
                    //         revshare: Number(revSharePercent_vastzone),
                    //         remoteIds: feedListRepeaterTemp,
                    //     };

                    setButtonProcessing(true)


                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(configData.SERVER_URL + `zone/editVastZone?zoneId=` + id, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }


            } else {
                if (zoneName_vastzone === "") {
                    setZoneNameIsRequiredError_vastzone(true);
                }

                if (override_eCpm_Checkbox_vastzone && eCpm_target_vastzone === "") {
                    setECpm_target_IsRequiredError_vastzone(true);
                }
                // if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
                //     setRevSharePercentIsRequiredError_vastzone(true);
                // }

            }




        }


        if (formType === "Player Tag" || formType === "tag_outstream") {

            if (
                floatingPosition_playertag !== "" &&
                channelName_playertag !== "" &&
                eCpm_playertag !== ""
            ) {

                if (
                    channelNameIsRequiredError_playertag === false &&
                    eCpmIsRequiredError_playertag === false &&
                    eCpmValidError_playertag === false
                ) {

                    let payload = {
                        floatingPos: floatingPosition_playertag,
                        channelName: channelName_playertag,
                        fixed_ecpm: Number(eCpm_playertag)
                    }

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(configData.SERVER_URL + `zone/editAniviewZone?zoneId=` + id, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }
                                // setButtonValue(false);
                            });
                    }

                }

            }
            else {
                if (channelName_playertag === "") {
                    setChannelNameIsRequiredError_playertag(true);
                }
                if (eCpm_playertag === "") {
                    setECpmIsRequiredError_playertag(true);
                }
            }



        }

        else if (formType === "vast_aniview") {
            if (channelName_vast_aniview !== ""
                // &&
                // eCpm_vast_aniview !== ""
            ) {
                if (
                    channelNameIsRequiredError_vast_aniview === false
                    // &&
                    // eCpmIsRequiredError_vast_aniview === false &&
                    // eCpmValidError_vast_aniview === false
                ) {

                    let payload = {
                        formType: formType,
                        // environment: platformType_vast_aniview,
                        channelName: channelName_vast_aniview,
                        // fixed_ecpm: Number(eCpm_vast_aniview),
                        p_name: p_name_vast_aniview,
                        p_aniviewId: p_aniviewId_vast_aniview
                    }


                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");
                        axios
                            .put(configData.SERVER_URL + `zone/editVastZoneAniview?zoneId=` + id, payload, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }
                            });
                    }
                }
            } else {
                if (channelName_vast_aniview === "") {
                    setChannelNameIsRequiredError_vast_aniview(true);
                }
                if (eCpm_vast_aniview === "") {
                    setECpmIsRequiredError_vast_aniview(true);
                }
            }



        }

        else if (formType === "GAM") {
            // validations
            let hasError = false;
            if (zoneName_gam.trim() === "") {
                setZoneNameIsRequiredError_gam(true);
                hasError = true;
            } else if (zoneName_gam.trim().length > 90) {
                setZoneNameMaxError_gam(true);
                hasError = true;
            }
            // Sizes is mandatory: at least one option must be selected
            if (!sizesList_gam || sizesList_gam.length === 0) {
                setSizesIsRequiredError_gam(true);
                hasError = true;
            }
            if (fixedPrice_gam.toString().trim() === "") {
                setFixedPriceIsRequiredError_gam(true);
                hasError = true;
            } else if (isNaN(parseFloat(fixedPrice_gam)) || parseFloat(fixedPrice_gam) <= 0) {
                setFixedPriceValidError_gam(true);
                hasError = true;
            }
            // These fields are hidden for restricted roles, so skip their validations
            if (!isGamRestricted) {
                // Override Set UPR is mandatory when Override UPR is checked (same rules as fixed price)
                if (overrideUpr_gam) {
                    if (overrideSetUpr_gam.toString().trim() === "") {
                        setOverrideSetUprIsRequiredError_gam(true);
                        hasError = true;
                    } else if (isNaN(parseFloat(overrideSetUpr_gam)) || parseFloat(overrideSetUpr_gam) <= 0) {
                        setOverrideSetUprValidError_gam(true);
                        hasError = true;
                    }
                }
                if (uprCategoryNotFoundError_gam) {
                    // driving value had no matching category -> block submit, keep the "match not found" message
                    hasError = true;
                } else if (uprCategory_gam === "") {
                    setUprCategoryIsRequiredError_gam(true);
                    hasError = true;
                }
                if (platformType_gam === "CTV" && tvAppNameCheckbox_gam && !tvApplication_gam) {
                    setTvApplicationIsRequiredError_gam(true);
                    hasError = true;
                }
            }

            if (!hasError) {
                const isVideo = (platformType_gam === "CTV" ? "Video" : formatType_gam) === "Video";
                let payload = {
                    formType: formType,
                    invent_type: platformType_gam,
                    traffic_type: formatType_gam,
                    name: zoneName_gam,
                    is_active: zoneActiveCheckbox_gam,
                    sizes: {
                        bannerSizes: !isVideo ? sizesList_gam : [],
                        vastSizes: isVideo ? sizesList_gam : [],
                        companionSizes: isVideo ? companionList_gam : [],
                    },
                    is_tv_app_name: isGamRestricted ? false : (platformType_gam === "CTV" ? tvAppNameCheckbox_gam : false),
                    applicationId: isGamRestricted ? "" : (platformType_gam === "CTV" && tvAppNameCheckbox_gam ? tvApplication_gam : ""),
                    isTargetEcpm: isGamRestricted ? false : overrideUpr_gam,
                    fixed_cpm: fixedPrice_gam !== "" ? Number(fixedPrice_gam) : 0,
                    set_upr: upr_gam !== "" ? Number(upr_gam) : 0,
                    target_ecpm: isGamRestricted
                        ? (upr_gam !== "" ? Number(upr_gam) : 0)
                        : (overrideUpr_gam && overrideSetUpr_gam !== "" ? Number(overrideSetUpr_gam) : Number(upr_gam)),
                };

                // UPR Category is hidden for restricted roles -> don't send upr_id
                // if (!isGamRestricted) {
                payload.upr_id = uprCategory_gam;
                // }

                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    let token = Cookies.get("token_xapads_ssp");
                    axios
                        .put(configData.SERVER_URL + `gam-new/adunit?zoneId=` + id, payload, {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")
                            resetFormView()
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }
                        });
                }
            }
        }
    }










    return (
        <>


            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                if (zoneCategory === "GAM") {
                                    handlePageViewChange("table", "yes")
                                }
                                else {
                                    handlePageViewChange("table", "no")
                                }
                                resetFormView()
                            }}>
                                <img src={zoneIcon} alt="USP" /> Zones
                            </Link>
                        </li>
                        <li className="primary">View</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                if (zoneCategory === "GAM") {
                                    handlePageViewChange("table", "yes")
                                }
                                else {
                                    handlePageViewChange("table", "no")
                                }
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            {zoneViewName + " (" + id + ")"}
                        </h1>
                    </div>
                </div>

                {/* Overview | Tags tabs - GAM zone only */}
                {formVisible && formType === "GAM" &&
                    <div className="radio_btn_with_bars w-100 justify-content-between" style={{ marginTop: 16 }}>
                        <div className="radios_btns --radios_btns_new">
                            <Radio.Group
                                className='radio_btn--group mb-0'
                                value={activeTab_gam}
                                onChange={(event) => setActiveTab_gam(event.target.value)}
                            >
                                <Radio.Button value="overview">Overview</Radio.Button>
                                <Radio.Button value="tags">Tags</Radio.Button>
                            </Radio.Group>
                        </div>
                    </div>
                }

                {/* Overview tab content (existing edit form) */}
                {/* Kept mounted (hidden via CSS) when on the GAM Tags tab so neither
                    tab's state is torn down / reset when switching tabs. */}
                {formVisible &&
                    <div
                        className="container_box--content pt_20"
                        style={{ display: (formType === "GAM" && activeTab_gam === "tags") ? "none" : undefined }}
                    >
                        <div className="container_box--width">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Zone Type</label>
                                        <p className="sub_text">Choose your zone type.</p>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Zone Type * </label>
                                                    <Select
                                                        showSearch={false}
                                                        optionFilterProp="label"
                                                        className="form_select basic no_search"
                                                        // open={true}
                                                        value={formType}

                                                        options={formTypeOption}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            {formType === "Prebid" ? (
                                <>
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>General details</label>
                                                <p className="sub_text">Please enter zone details</p>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container" >
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                Traffic Type *
                                                            </label>
                                                            <Radio.Group

                                                                value={platformType_prebid}
                                                                className="form_radio equal_space"
                                                                disabled
                                                            >
                                                                <Radio className="radio_btn" value="Website">
                                                                    Website
                                                                </Radio>
                                                                <Radio className="radio_btn" value="Inapp">
                                                                    Inapp
                                                                </Radio>
                                                            </Radio.Group>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Format Type *</label>
                                                            {/* <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={formatType_prebid}

                                                                options={formatTypeOptions_prebid}
                                                                disabled
                                                            /> */}


                                                            <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                                                <Checkbox.Group className="form_checkbox equal_space" value={formatType_prebid} disabled>
                                                                    <Checkbox className="checkbox_btn" value="Banner">
                                                                        Banner
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Video">
                                                                        Video
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Native">
                                                                        Native
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">{formatTypeIsRequiredError_prebid && <> Minimum 1 selection is required</>} </span>
                                                        </div>
                                                        {formatType_prebid?.includes("Banner") && (
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    In Banner Video Allow *
                                                                </label>
                                                                <Radio.Group

                                                                    value={bannerCheckbox_prebid}
                                                                    className="form_radio equal_space"
                                                                    disabled
                                                                >
                                                                    <Radio className="radio_btn" value={true}>
                                                                        Yes
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value={false}>
                                                                        No
                                                                    </Radio>
                                                                </Radio.Group>

                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="hr_custom my_24"></div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Zone Name *</label>
                                                            <Input
                                                                className={
                                                                    zoneNameIsRequiredError_prebid || nameExists.prebid
                                                                        ? "form_control basic error"
                                                                        : "form_control basic"
                                                                }
                                                                value={zoneName_prebid}
                                                                onChange={onChangeZoneName_prebid}
                                                                onBlur={onBlurZoneName_prebid}
                                                                autocomplete="off"
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                suffix={nameChecking.prebid ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                                            />
                                                            <span className="error_content">
                                                                {zoneNameIsRequiredError_prebid && (
                                                                    <> This field is required</>
                                                                )}
                                                                {nameExists.prebid && (
                                                                    <> Zone name already exists</>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox
                                                                    id="zone_checkbox_prebid"
                                                                    name="zone_checkbox_prebid"
                                                                    checked={zoneActiveCheckbox_prebid}

                                                                    disabled
                                                                >
                                                                    <span className="form_label">
                                                                        Is Zone Active?
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                        <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group "}>
                                                            <label className="form_label">
                                                                Integration Type *
                                                            </label>
                                                            <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={integrationType_prebid}

                                                                options={integrationTypeOptions_prebid}
                                                                disabled
                                                            />
                                                        </div>

                                                        {
                                                            (role !== "admin" && role !== "u_admin") &&

                                                            <Col span={12} style={{ paddingLeft: "0px" }}>
                                                                <div className="form_content_block--group mb-0">
                                                                    <label className='form_label'>Rev Share *</label>
                                                                    <Input
                                                                        placeholder='Enter Revshare'
                                                                        className={
                                                                            (revSharePercentIsRequiredError_prebid || revSharePercentValidError_prebid)
                                                                                ? "form_control basic error form_control_with_icon_d2"
                                                                                : "form_control basic form_control_with_icon_d2"
                                                                        }
                                                                        value={revSharePercent_prebid}
                                                                        onChange={onChangeRevSharePercent_prebid}
                                                                        onBlur={onBlurRevSharePercent_prebid}
                                                                        autocomplete="off"
                                                                        suffix={'%'} eCPM
                                                                    />
                                                                    <span className="error_content">
                                                                        {revSharePercentIsRequiredError_prebid && (
                                                                            <> This field is required</>
                                                                        )}

                                                                        {revSharePercentValidError_prebid && (
                                                                            <> Value must be between 0.1 and 100</>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </Col>

                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Please select all sensitive categories you would like us to block on your supply.</label>
                                                {/* <p className="sub_text">Categories you would like us to block on your supply.</p> */}
                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="container_box--form-container">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group mb-0">
                                                            <BlockCategoryTable selected={blockCategorySelected} setSelected={setBlockCategorySelected} disabled={(role === "admin" || role === "u_admin")} normalizeKey={blockCategoryNormalizeKey} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>


                                    {(role !== "admin" && role !== "u_admin") && (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Limits</label>
                                                        <p className="sub_text">Enter your zone limits</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">

                                                        <Row gutter={16}
                                                        //  className='position-relative'
                                                        >
                                                            <Col span={12}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Min eCPM </label>
                                                                    <Input
                                                                        className={minCpmValueError_prebid ? 'form_control basic  prefix_sign error' : 'form_control basic prefix_sign'}
                                                                        placeholder='Min' autocomplete="off"
                                                                        value={minCpm_prebid}
                                                                        onChange={onChangeMinCpm_prebid}
                                                                        prefix={'$'}
                                                                    />
                                                                    <span className="error_content">

                                                                        {minCpmValueError_prebid && (
                                                                            <>
                                                                                Value must be between 0.00001 and 50
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                {/* <small className='line_between_cols_d2'>-</small> */}
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group ">
                                                                    <label className="form_label ">Max eCPM </label>
                                                                    <Input
                                                                        className={maxCpmValueError_prebid ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                                                        placeholder='Max' autocomplete="off"
                                                                        value={maxCpm_prebid}
                                                                        onChange={onChangeMaxCpm_prebid}
                                                                        prefix={'$'}
                                                                    />
                                                                    <span className="error_content">

                                                                        {maxCpmValueError_prebid && (
                                                                            <>
                                                                                Value must be between 0.00001 and 50
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                {(minCpm_prebid === "" || minCpm_prebid === null) ?
                                                                    <Checkbox
                                                                        id="highestBidFloor_checkbox_prebid"
                                                                        name="highestBidFloor_checkbox_prebid"
                                                                        checked={false}
                                                                        disabled
                                                                    >
                                                                        <span className="form_label">
                                                                            Use the highest bid floor
                                                                        </span>
                                                                    </Checkbox>
                                                                    :
                                                                    <Checkbox
                                                                        id="highestBidFloor_checkbox_prebid"
                                                                        name="highestBidFloor_checkbox_prebid"
                                                                        checked={highestBidFloorCheckbox_prebid}
                                                                        onChange={onChangeHighestBidFloorCheckbox_prebid}
                                                                    >
                                                                        <span className="form_label">
                                                                            Use the highest bid floor
                                                                        </span>
                                                                    </Checkbox>
                                                                }
                                                            </div>
                                                        </div>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Requests per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={request_prebid}

                                                                        autocomplete="off"
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Impressions per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={impression_prebid}

                                                                        autocomplete="off"
                                                                        disabled
                                                                    />
                                                                    <span className="error_content">
                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {/* <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Remote Feed Type</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">
                                                        {feedListRepeater.map((x, i) => {
                                                            return (
                                                                <Row gutter={16} className='formHtml' key={i}>
                                                                    <Col span={16}>
                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                            <label className="form_label">
                                                                                Remote Feed Type *
                                                                            </label>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                className='form_select basic'
                                                                                // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                //     return acc.concat(item.feed_provider_id);
                                                                                // }, []).includes(option.value))}

                                                                                options={feedListRepeaterOptions.filter(option => {
                                                                                    const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                        return acc.concat(item.feed_provider_id);
                                                                                    }, []);

                                                                                    // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                    return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                })}

                                                                                value={x.feed_provider_id}
                                                                                onChange={(e) =>
                                                                                    handleChangeFeedProviderId(
                                                                                        e,
                                                                                        i,
                                                                                    )
                                                                                }
                                                                            />
                                                                            <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                        </div>

                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label"> Remote ID * </label>
                                                                            <div className='d-flex'>
                                                                                <Input className="form_control basic"
                                                                                    value={x.remote_id}
                                                                                    onChange={(e) =>
                                                                                        handleChangeRemoteId(
                                                                                            e,
                                                                                            i,
                                                                                        )
                                                                                    }
                                                                                />

                                                                                <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                    <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                </div>

                                                                            </div>
                                                                            <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                        <Row>
                                                            <Col span={24}>
                                                                <div className='addnewform_d2'>
                                                                    <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                        <img src={addIcon} alt='Add New' /> Add New
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row> */}

                                        </>
                                    )}


                                    {(role !== "admin" && role !== "u_admin") && (

                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Inventory Partner Domain Override</label>
                                                </div>
                                            </Col>
                                            <Col span={16}>
                                                <div className="container_box--form-container ">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        disabled={(role === "admin" || role === "u_admin")}
                                                                        checked={isAddValueCheckbox_prebid}
                                                                        onChange={onChangeIsAddValueCheckbox_prebid}
                                                                    >
                                                                        <span className="form_label">Pass Inventory Partner Domain</span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">Inventory Partner Domain</label>
                                                                <Input
                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                    className="form_control basic"
                                                                    value={override_prebid}
                                                                    onBlur={onBlurOverride_prebid}
                                                                    onChange={onChangeOverride_prebid}
                                                                    placeholder="Enter Inventory Partner Domain"
                                                                    autocomplete="off"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>IVT Sampling</label>
                                                <p className="sub_text">Set the sampling percentage</p>
                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="container_box--form-container mb_0">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="alert_yellow_div">
                                                            <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Human *</label>
                                                            <Input
                                                                className={humanValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={human_prebid}
                                                                onChange={onChangeHuman_prebid}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onBlur={onBlurHuman_prebid}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {humanValidError_prebid && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Pixalate *</label>
                                                            <Input
                                                                className={pixalateValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={pixalate_prebid}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onChange={onChangePixalate_prebid}
                                                                onBlur={onBlurPixalate_prebid}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {pixalateValidError_prebid && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                */}
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">DoubleVerify *</label>
                                                            <Input
                                                                className={doubleverifyValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={doubleverify_prebid}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onChange={onChangeDoubleverify_prebid}
                                                                onBlur={onBlurDoubleverify_prebid}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {doubleverifyValidError_prebid && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>


                                </>
                            ) : formType === "Open RTB" ? (
                                <>
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>General details</label>
                                                <p className="sub_text">Please enter zone details</p>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container" >
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                Traffic Type *
                                                            </label>
                                                            <Radio.Group

                                                                value={platformType_openrtb}
                                                                className="form_radio equal_space"
                                                                disabled
                                                            >
                                                                <Radio className="radio_btn" value="Website">
                                                                    Website
                                                                </Radio>
                                                                <Radio className="radio_btn" value="Inapp">
                                                                    Inapp
                                                                </Radio>
                                                                <Radio className="radio_btn" value="CTV">
                                                                    CTV
                                                                </Radio>
                                                            </Radio.Group>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Format Type *</label>
                                                            {platformType_openrtb === "CTV" ?
                                                                <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                                                    <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                                                        <Checkbox className="checkbox_btn" value="Banner">
                                                                            Banner
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Video">
                                                                            Video
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Native">
                                                                            Native
                                                                        </Checkbox>
                                                                    </Checkbox.Group>
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                                                        <Checkbox.Group className="form_checkbox equal_space" value={formatType_openrtb} disabled>
                                                                            <Checkbox className="checkbox_btn" value="Banner">
                                                                                Banner
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="Video">
                                                                                Video
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="Native">
                                                                                Native
                                                                            </Checkbox>
                                                                        </Checkbox.Group>
                                                                    </div>

                                                                </>
                                                            }

                                                        </div>
                                                        {formatType_openrtb?.includes("Banner") && platformType_openrtb !== "CTV" && (
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    In Banner Video Allow *
                                                                </label>
                                                                <Radio.Group

                                                                    value={bannerCheckbox_openrtb}
                                                                    className="form_radio equal_space"
                                                                    disabled
                                                                >
                                                                    <Radio className="radio_btn" value={true}>
                                                                        Yes
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value={false}>
                                                                        No
                                                                    </Radio>
                                                                </Radio.Group>

                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="hr_custom my_24"></div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Zone Name *</label>
                                                            <Input
                                                                className={
                                                                    zoneNameIsRequiredError_openrtb || nameExists.openrtb
                                                                        ? "form_control basic error"
                                                                        : "form_control basic"
                                                                }
                                                                value={zoneName_openrtb}
                                                                onBlur={onBlurZoneName_openrtb}
                                                                onChange={onChangeZoneName_openrtb}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                autocomplete="off"
                                                                suffix={nameChecking.openrtb ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                                            />
                                                            <span className="error_content">
                                                                {zoneNameIsRequiredError_openrtb && (
                                                                    <> This field is required</>
                                                                )}
                                                                {nameExists.openrtb && (
                                                                    <> Zone name already exists</>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox
                                                                    id="zone_checkbox_openrtb"
                                                                    name="zone_checkbox_openrtb"
                                                                    checked={zoneActiveCheckbox_openrtb}
                                                                    disabled

                                                                >
                                                                    <span className="form_label">
                                                                        Is Zone Active?
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                        <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group "}>
                                                            <label className="form_label">
                                                                Integration Type *
                                                            </label>
                                                            <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={integrationType_openrtb}
                                                                disabled
                                                                options={integrationTypeOptions_openrtb}
                                                            />
                                                        </div>

                                                        {
                                                            (role !== "admin" && role !== "u_admin") &&

                                                            <Col span={12} style={{ paddingLeft: "0px" }}>
                                                                <div className="form_content_block--group mb-0">
                                                                    <label className='form_label'>Rev Share *</label>
                                                                    <Input
                                                                        placeholder='Enter Revshare'
                                                                        className={
                                                                            (revSharePercentIsRequiredError_openrtb || revSharePercentValidError_openrtb)
                                                                                ? "form_control basic error form_control_with_icon_d2"
                                                                                : "form_control basic form_control_with_icon_d2"
                                                                        }
                                                                        value={revSharePercent_openrtb}
                                                                        onChange={onChangeRevSharePercent_openrtb}
                                                                        onBlur={onBlurRevSharePercent_openrtb}
                                                                        autocomplete="off"
                                                                        suffix={'%'}
                                                                    />
                                                                    <span className="error_content">
                                                                        {revSharePercentIsRequiredError_openrtb && (
                                                                            <> This field is required</>
                                                                        )}

                                                                        {revSharePercentValidError_openrtb && (
                                                                            <> Value must be between 0.1 and 100</>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </Col>

                                                        }

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>


                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Please select all sensitive categories you would like us to block on your supply.</label>
                                                {/* <p className="sub_text">Categories you would like us to block on your supply.</p> */}
                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="container_box--form-container">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group mb-0">
                                                            <BlockCategoryTable selected={blockCategorySelected} setSelected={setBlockCategorySelected} disabled={(role === "admin" || role === "u_admin")} normalizeKey={blockCategoryNormalizeKey} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    {(role !== "admin" && role !== "u_admin") && (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Limits</label>
                                                        <p className="sub_text">Enter your zone limits</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">
                                                        <Row gutter={16}
                                                        //  className='position-relative'
                                                        >
                                                            <Col span={12}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Min eCPM </label>
                                                                    <Input
                                                                        className={minCpmValueError_openrtb ? 'form_control basic  prefix_sign error' : 'form_control basic prefix_sign'}
                                                                        placeholder='Min' autocomplete="off"
                                                                        value={minCpm_openrtb}
                                                                        onChange={onChangeMinCpm_openrtb}
                                                                        prefix={'$'}
                                                                    />
                                                                    <span className="error_content">

                                                                        {minCpmValueError_openrtb && (
                                                                            <>
                                                                                Value must be between 0.00001 and 50
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                {/* <small className='line_between_cols_d2'>-</small> */}
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group ">
                                                                    <label className="form_label ">Max eCPM </label>
                                                                    <Input
                                                                        className={maxCpmValueError_openrtb ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                                                        placeholder='Max' autocomplete="off"
                                                                        value={maxCpm_openrtb}
                                                                        onChange={onChangeMaxCpm_openrtb}
                                                                        prefix={'$'}
                                                                    />
                                                                    <span className="error_content">

                                                                        {maxCpmValueError_openrtb && (
                                                                            <>
                                                                                Value must be between 0.00001 and 50
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                {(minCpm_openrtb === "" || minCpm_openrtb === null) ?
                                                                    <Checkbox
                                                                        id="highestBidFloor_checkbox_openrtb"
                                                                        name="highestBidFloor_checkbox_openrtb"
                                                                        checked={false}
                                                                        disabled
                                                                    >
                                                                        <span className="form_label">
                                                                            Use the highest bid floor
                                                                        </span>
                                                                    </Checkbox>
                                                                    :
                                                                    <Checkbox
                                                                        id="highestBidFloor_checkbox_openrtb"
                                                                        name="highestBidFloor_checkbox_openrtb"
                                                                        checked={highestBidFloorCheckbox_openrtb}
                                                                        onChange={onChangeHighestBidFloorCheckbox_openrtb}
                                                                    >
                                                                        <span className="form_label">
                                                                            Use the highest bid floor
                                                                        </span>
                                                                    </Checkbox>
                                                                }
                                                            </div>
                                                        </div>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Requests per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={request_openrtb}
                                                                        disabled
                                                                        autocomplete="off"
                                                                    />
                                                                </div>
                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Impressions per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={impression_openrtb}
                                                                        disabled
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        <></>
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {/* <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Remote Feed Type</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">
                                                        {feedListRepeater.map((x, i) => {
                                                            return (
                                                                <Row gutter={16} className='formHtml' key={i}>
                                                                    <Col span={16}>
                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                            <label className="form_label">
                                                                                Remote Feed Type *
                                                                            </label>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                className='form_select basic'
                                                                                // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                //     return acc.concat(item.feed_provider_id);
                                                                                // }, []).includes(option.value))}

                                                                                options={feedListRepeaterOptions.filter(option => {
                                                                                    const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                        return acc.concat(item.feed_provider_id);
                                                                                    }, []);

                                                                                    // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                    return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                })}

                                                                                value={x.feed_provider_id}
                                                                                onChange={(e) =>
                                                                                    handleChangeFeedProviderId(
                                                                                        e,
                                                                                        i,
                                                                                    )
                                                                                }
                                                                            />
                                                                            <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                        </div>

                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label"> Remote ID * </label>
                                                                            <div className='d-flex'>
                                                                                <Input className="form_control basic"
                                                                                    value={x.remote_id}
                                                                                    onChange={(e) =>
                                                                                        handleChangeRemoteId(
                                                                                            e,
                                                                                            i,
                                                                                        )
                                                                                    }
                                                                                />

                                                                                <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                    <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                </div>

                                                                            </div>
                                                                            <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                        <Row>
                                                            <Col span={24}>
                                                                <div className='addnewform_d2'>
                                                                    <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                        <img src={addIcon} alt='Add New' /> Add New
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row> */}
                                        </>
                                    )}

                                    {(role !== "admin" && role !== "u_admin") && (
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Inventory Partner Domain Override</label>
                                                </div>
                                            </Col>
                                            <Col span={16}>
                                                <div className="container_box--form-container s">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        disabled={(role === "admin" || role === "u_admin")}
                                                                        checked={isAddValueCheckbox_openrtb}
                                                                        onChange={onChangeIsAddValueCheckbox_openrtb}
                                                                    >
                                                                        <span className="form_label">Pass Inventory Partner Domain</span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">Inventory Partner Domain</label>
                                                                <Input
                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                    className="form_control basic"
                                                                    value={override_openrtb}
                                                                    onBlur={onBlurOverride_openrtb}
                                                                    onChange={onChangeOverride_openrtb}
                                                                    placeholder="Enter Inventory Partner Domain"
                                                                    autocomplete="off"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>IVT Sampling</label>
                                                <p className="sub_text">Set the sampling percentage</p>
                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="container_box--form-container mb_0">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="alert_yellow_div">
                                                            <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Human *</label>
                                                            <Input
                                                                className={humanValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={human_openrtb}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onChange={onChangeHuman_openrtb}
                                                                onBlur={onBlurHuman_openrtb}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {humanValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Pixalate *</label>
                                                            <Input
                                                                className={pixalateValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={pixalate_openrtb}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onChange={onChangePixalate_openrtb}
                                                                onBlur={onBlurPixalate_openrtb}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {pixalateValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                */}
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">DoubleVerify *</label>
                                                            <Input
                                                                className={doubleverifyValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                placeholder='0'
                                                                autocomplete="off"
                                                                value={doubleverify_openrtb}
                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                onChange={onChangeDoubleverify_openrtb}
                                                                onBlur={onBlurDoubleverify_openrtb}
                                                                suffix={'%'}
                                                            />
                                                            <span className="error_content">
                                                                {doubleverifyValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>



                                </>
                            ) :
                                formType === "publica" ?
                                    (<>
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>General details</label>
                                                    <p className="sub_text">Please enter zone details</p>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div
                                                    className="container_box--form-container "
                                                >
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    Traffic Type *
                                                                </label>
                                                                <Radio.Group
                                                                    onChange={onChangePlatformType_publica}
                                                                    value={platformType_publica}
                                                                    // disabled={(role === "admin" || role === "u_admin")}
                                                                    disabled
                                                                    className="form_radio equal_space"
                                                                >
                                                                    <Radio className="radio_btn" value="Website">
                                                                        Website
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value="Inapp">
                                                                        Inapp
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value="CTV">
                                                                        CTV
                                                                    </Radio>
                                                                </Radio.Group>
                                                            </div>


                                                            <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                                                <label className="form_label">Format Type *</label>
                                                                <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                                                    <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                                                        <Checkbox className="checkbox_btn" value="Banner">
                                                                            Banner
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Video">
                                                                            Video
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Native">
                                                                            Native
                                                                        </Checkbox>
                                                                    </Checkbox.Group>
                                                                </div>
                                                            </div>

                                                            {(role !== "admin" && role !== "u_admin") &&
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Header Bidder Vast Version
                                                                    </label>
                                                                    <Select
                                                                        optionFilterProp="label"
                                                                        className="form_select basic no_search"
                                                                        value={vastVersion_publica}
                                                                        onChange={onChangeVastVersion_publica}
                                                                        options={vastVersionOptions_publica}
                                                                    />


                                                                </div>
                                                            }

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Channel details</label>
                                                    {/* <p className="sub_text">Please enter zone details</p> */}
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div
                                                    className="container_box--form-container "
                                                    ref={channelDetailsRef}
                                                >
                                                    <Row gutter={16}>
                                                        <Col span={24}>

                                                            <div className="form_content_block--group">
                                                                <label className="form_label">Channel Name *</label>
                                                                <Input
                                                                    // className="form_control basic"
                                                                    className={
                                                                        channelNameIsRequiredError_publica || nameExists.publica
                                                                            ? "form_control basic error"
                                                                            : "form_control basic"
                                                                    }
                                                                    value={channelName_publica}
                                                                    onBlur={onBlurChannelName_publica}
                                                                    onChange={onChangeChannelName_publica}
                                                                    autocomplete="off"
                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                    suffix={nameChecking.publica ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                                                />
                                                                <span className="error_content">
                                                                    {channelNameIsRequiredError_publica && (
                                                                        <> This field is required</>
                                                                    )}
                                                                    {nameExists.publica && (
                                                                        <> Channel name already exists</>
                                                                    )}
                                                                </span>
                                                            </div>




                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    Region *
                                                                </label>
                                                                <Select
                                                                    optionFilterProp="label"
                                                                    className={regionIsRequiredError_publica ? "form_select basic no_search error" : "form_select basic no_search"}
                                                                    value={region_publica}
                                                                    onChange={onChangeRegion_publica}
                                                                    options={regionOptions_publica}
                                                                />
                                                                <span className="error_content">
                                                                    {regionIsRequiredError_publica && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>


                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                                                        <label className='form_label d-flex justify_content_between'><>eCPM *   </>
                                                                            {(role === "sa" || role === "mobops") &&
                                                                                <div className="primary_checkbox" >
                                                                                    <Checkbox
                                                                                        id="override_eCpm_checkbox_publica"
                                                                                        name="override_eCpm_checkbox_publica"
                                                                                        checked={override_eCpm_Checkbox_publica}
                                                                                        onChange={(e) => {
                                                                                            setOverride_eCpm_Checkbox_publica(e.target.checked)
                                                                                            if (!e.target.checked) {
                                                                                                setBidAdjustment_publica(Math.round((Number(eCpm_publica) * 100) / (Number(eCpm_publica) + 2.5)))
                                                                                                setBidAdjustmentIsRequiredError_publica(false)
                                                                                                setBidAdjustmentValidError_publica(false)
                                                                                            }
                                                                                            else {
                                                                                                if (eCpm_target_publica !== "") {
                                                                                                    setBidAdjustment_publica(Math.round((Number(eCpm_target_publica) * 100) / (Number(eCpm_target_publica) + 2.5)))
                                                                                                    setBidAdjustmentIsRequiredError_publica(false)
                                                                                                    setBidAdjustmentValidError_publica(false)
                                                                                                }
                                                                                            }
                                                                                        }}

                                                                                    >
                                                                                        <span className="form_label" style={{ fontSize: "1.1rem" }}>
                                                                                            Override the current eCPM
                                                                                        </span>
                                                                                    </Checkbox>
                                                                                </div>
                                                                            }
                                                                        </label>
                                                                        <Input
                                                                            placeholder='Enter eCpm'
                                                                            className={
                                                                                eCpmIsRequiredError_publica || eCpmValidError_publica
                                                                                    ? "form_control basic error"
                                                                                    : "form_control basic"
                                                                            }
                                                                            value={eCpm_publica}
                                                                            onBlur={onBlurECpm_publica}
                                                                            onChange={onChangeECpm_publica}
                                                                            autocomplete="off"
                                                                            // disabled={(role === "admin" || role === "u_admin")}
                                                                            disabled
                                                                        />
                                                                        <span className="error_content">
                                                                            {eCpmIsRequiredError_publica && (
                                                                                <> This field is required</>
                                                                            )}
                                                                            {eCpmValidError_publica && (
                                                                                <> Value should be greater than or equal to 0</>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                                {(role === "sa" || role === "mobops") && override_eCpm_Checkbox_publica &&
                                                                    <Col span={12}>

                                                                        <div className="form_content_block--group mb_0">

                                                                            <label className='form_label' >
                                                                                Target eCPM *
                                                                            </label>


                                                                            <Input
                                                                                placeholder='Enter eCpm'
                                                                                className={
                                                                                    eCpm_target_IsRequiredError_publica
                                                                                        ? "form_control basic error"
                                                                                        : "form_control basic"
                                                                                }
                                                                                value={eCpm_target_publica}
                                                                                onBlur={onBlurECpm_target_publica}
                                                                                onChange={onChangeECpm_target_publica}
                                                                                autocomplete="off"
                                                                            // disabled={(role === "admin" || role === "u_admin")}
                                                                            />
                                                                            <span className="error_content">
                                                                                {eCpm_target_IsRequiredError_publica && (
                                                                                    <> This field is required</>
                                                                                )}
                                                                                {eCpm_target_ValidError_publica && (
                                                                                    <> Value should be greater than 0 and less than 100</>
                                                                                )}
                                                                            </span>

                                                                        </div>

                                                                    </Col>
                                                                }
                                                            </Row>

                                                            {(role !== "admin" && role !== "u_admin") &&
                                                                <Row gutter={16} >
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">Bid Adjustment * </label>
                                                                            <Input
                                                                                className={(bidAdjustmentIsRequiredError_publica || bidAdjustmentValidError_publica) ? 'form_control basic form_control_with_icon_d2  error' : 'form_control basic form_control_with_icon_d2 '}
                                                                                placeholder='0' autocomplete="off"
                                                                                value={bidAdjustment_publica}
                                                                                onChange={onChangeBidAdjustment_publica}
                                                                                onBlur={onBlurBidAdjustment_publica}
                                                                                suffix={'%'}
                                                                            />
                                                                            <span className="error_content">
                                                                                {bidAdjustmentIsRequiredError_publica && (
                                                                                    <>
                                                                                        This field is required
                                                                                    </>
                                                                                )}
                                                                                {bidAdjustmentValidError_publica && (
                                                                                    <>
                                                                                        Value must be between 0 - 100
                                                                                    </>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label ">Bid Adjustment Value  </label>
                                                                            <Input
                                                                                className={bidValueValidError_publica ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                                                                placeholder='0' autocomplete="off"
                                                                                value={bidValue_publica}
                                                                                onChange={onChangeBidValue_publica}
                                                                                onBlur={onBlurBidValue_publica}
                                                                                prefix={'$'}
                                                                            />
                                                                            <span className="error_content">

                                                                                {bidValueValidError_publica && (
                                                                                    <> Value should be greater than or equal to 0</>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                            }

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>


                                        {(role !== "admin" && role !== "u_admin") &&

                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Supply Chain</label>
                                                        {/* <p className="sub_text">Please enter zone details</p> */}
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div
                                                        className="container_box--form-container"
                                                        ref={supplyDetailsRef}
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={24}>

                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">ASI *</label>
                                                                    <Input

                                                                        className={
                                                                            asiIsRequiredError_publica
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={asi_publica}
                                                                        onBlur={onBlurAsi_publica}
                                                                        onChange={onChangeAsi_publica}
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        {asiIsRequiredError_publica && (
                                                                            <> This field is required</>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">SID *</label>
                                                                    <Input

                                                                        className={
                                                                            sidIsRequiredError_publica
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={sid_publica}
                                                                        onBlur={onBlurSid_publica}
                                                                        onChange={onChangeSid_publica}
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        {sidIsRequiredError_publica && (
                                                                            <> This field is required</>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Name *</label>
                                                                    <Input
                                                                        className={
                                                                            nameIsRequiredError_publica
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={name_publica}
                                                                        onBlur={onBlurName_publica}
                                                                        onChange={onChangeName_publica}
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        {nameIsRequiredError_publica && (
                                                                            <> This field is required</>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">Domain *</label>
                                                                    <Input
                                                                        className={
                                                                            domainIsRequiredError_publica
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={domain_publica}
                                                                        onBlur={onBlurDomain_publica}
                                                                        onChange={onChangeDomain_publica}
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        {domainIsRequiredError_publica && (
                                                                            <> This field is required</>
                                                                        )}
                                                                    </span>
                                                                </div>


                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }

                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Endpoint</label>
                                                    {/* <p className="sub_text">Please enter zone details</p> */}
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div
                                                    className={(role === "admin" || role === "u_admin") ? "container_box--form-container mb_0" : "container_box--form-container "}
                                                >
                                                    <Row gutter={16}>
                                                        <Col span={24}>


                                                            <div className="form_content_block--group  "
                                                                style={{ marginBottom: "10px" }}
                                                            >
                                                                <label className="form_label">
                                                                    Template *
                                                                </label>

                                                                <Select
                                                                    open={isDropdownOpenTemplate} // Controlled open state for Select dropdown
                                                                    onDropdownVisibleChange={(open) => setIsDropdownOpenTemplate(open)} // Track dropdown visibility
                                                                    showSearch
                                                                    className={templateIsRequiredError_publica ? "form_select basic  error" : "form_select basic "}
                                                                    // placeholder="-Select-"
                                                                    value={template_publica}
                                                                    onChange={onChangeTemplate_publica}
                                                                    optionFilterProp="label"
                                                                    dropdownRender={(menu) => (
                                                                        <>
                                                                            {(role !== "admin" && role !== "u_admin") &&
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px',
                                                                                        cursor: 'pointer',
                                                                                        color: '#9254de',
                                                                                        borderBottom: '1px solid #f0f0f0',
                                                                                    }}
                                                                                    onClick={() => openTemplateModal("publica")}
                                                                                >
                                                                                    + New Template
                                                                                </div>
                                                                            }

                                                                            {menu}
                                                                        </>
                                                                    )}
                                                                    options={templateOptions_publica}
                                                                />

                                                                <span className="error_content">
                                                                    {templateIsRequiredError_publica && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>


                                                            </div>

                                                            <div className="form_content_block--group mb_0">
                                                                {/* <label className="form_label">Override *</label> */}
                                                                <TextArea autocomplete="off" placeholder=''
                                                                    className="form_control basic form_control_h textarea_paddingY_d2 --120"
                                                                    disabled
                                                                    //  className={siteIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                    value={templateText_publica}
                                                                // onChange={onChangeSiteIdList}
                                                                // onBlur={onBlurSiteIdList}
                                                                />
                                                                <span className="error_content">
                                                                    {/* {channelNameIsRequiredError_vast_aniview && (
                                                              <> This field is required</>
                                                            )} */}
                                                                </span>
                                                            </div>


                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>

                                        {(role !== "admin" && role !== "u_admin") &&
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Inventory Partner Domain Override</label>
                                                        {/* <p className="sub_text">Please enter zone details</p> */}
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div
                                                        className="container_box--form-container  mb_0"
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={24}>

                                                                <div className="form_content_block--group">
                                                                    <div className="primary_checkbox">
                                                                        <Checkbox
                                                                            id="zone_checkbox_prebid"
                                                                            name="zone_checkbox_prebid"
                                                                            checked={isAddValueCheckbox_publica}
                                                                            onChange={onChangeIsAddValueCheckbox_publica}
                                                                        >
                                                                            <span className="form_label">
                                                                                Add value only if obj. empty in bid request
                                                                            </span>
                                                                        </Checkbox>
                                                                    </div>
                                                                </div>

                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">Override </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={override_publica}
                                                                        onBlur={onBlurOverride_publica}
                                                                        onChange={onChangeOverride_publica}
                                                                        autocomplete="off"
                                                                    />

                                                                </div>


                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }




                                        {/* <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>IVT Sampling</label>
                                                    <p className="sub_text">Set the sampling percentage</p>
                                                </div>
                                            </Col>
                                            <Col span={16}>
                                                <div className="container_box--form-container mb_0">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="alert_yellow_div">
                                                                <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group ">
                                                                <label className="form_label">Human *</label>
                                                                <Input
                                                                    className={humanValidError_publica ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                    placeholder='0'
                                                                    autocomplete="off"
                                                                    value={human_publica}
                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                    onChange={onChangeHuman_publica}
                                                                    onBlur={onBlurHuman_publica}
                                                                    suffix={'%'}
                                                                />
                                                                <span className="error_content">
                                                                    {humanValidError_publica && <>Value must be an integer between 0 and 100</>}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">Pixalate *</label>
                                                                <Input
                                                                    className={pixalateValidError_publica ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                    placeholder='0'
                                                                    autocomplete="off"
                                                                    value={pixalate_publica}
                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                    onChange={onChangePixalate_publica}
                                                                    onBlur={onBlurPixalate_publica}
                                                                    suffix={'%'}
                                                                />
                                                                <span className="error_content">
                                                                    {pixalateValidError_publica && <>Value must be an integer between 0 and 100</>}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row> */}

                                    </>)

                                    :
                                    formType === "Vast Zone" ?
                                        (
                                            <>
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info">
                                                            <label>General details</label>
                                                            <p className="sub_text">Please enter zone details</p>
                                                        </div>
                                                    </Col>

                                                    <Col span={16}>
                                                        <div className="container_box--form-container" >
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">
                                                                            Traffic Type *
                                                                        </label>
                                                                        <Radio.Group

                                                                            value={platformType_vastzone}
                                                                            disabled
                                                                            className="form_radio equal_space"
                                                                        >
                                                                            <Radio className="radio_btn" value="Website">
                                                                                Website
                                                                            </Radio>
                                                                            <Radio className="radio_btn" value="Inapp">
                                                                                Inapp
                                                                            </Radio>
                                                                            <Radio className="radio_btn" value="CTV">
                                                                                CTV
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    </div>


                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Format Type *</label>
                                                                        <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                                                            <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                                                                <Checkbox className="checkbox_btn" value="Banner">
                                                                                    Banner
                                                                                </Checkbox>
                                                                                <Checkbox className="checkbox_btn" value="Video">
                                                                                    Video
                                                                                </Checkbox>
                                                                                <Checkbox className="checkbox_btn" value="Native">
                                                                                    Native
                                                                                </Checkbox>
                                                                            </Checkbox.Group>
                                                                        </div>
                                                                    </div>

                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Stream Position *</label>
                                                                        {platformType_vastzone === "CTV" ?
                                                                            <Input
                                                                                className="form_control basic"
                                                                                value="Instream"
                                                                                autocomplete="off"
                                                                                disabled
                                                                            />
                                                                            :
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={streamPosition_vastzone}
                                                                                disabled
                                                                                options={streamPositionOptions_vastzone}
                                                                            />
                                                                        }
                                                                    </div>


                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Zone Name *</label>
                                                                        <Input
                                                                            className={
                                                                                zoneNameIsRequiredError_vastzone || nameExists.vastzone
                                                                                    ? "form_control basic error"
                                                                                    : "form_control basic"
                                                                            }
                                                                            value={zoneName_vastzone}
                                                                            onBlur={onBlurZoneName_vastzone}
                                                                            onChange={onChangeZoneName_vastzone}
                                                                            disabled={(role === "admin" || role === "u_admin")}
                                                                            autocomplete="off"
                                                                            suffix={nameChecking.vastzone ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                                                        />
                                                                        <span className="error_content">
                                                                            {zoneNameIsRequiredError_vastzone && (
                                                                                <> This field is required</>
                                                                            )}
                                                                            {nameExists.vastzone && (
                                                                                <> Zone name already exists</>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                    <div className="form_content_block--group">
                                                                        <div className="primary_checkbox">
                                                                            <Checkbox
                                                                                id="zone_checkbox_vastzone"
                                                                                name="zone_checkbox_vastzone"
                                                                                checked={zoneActiveCheckbox_vastzone}
                                                                                disabled
                                                                            >
                                                                                <span className="form_label">
                                                                                    Is Zone Active?
                                                                                </span>
                                                                            </Checkbox>
                                                                        </div>
                                                                    </div>
                                                                    <Row gutter={16}>
                                                                        <Col span={12}>
                                                                            <div className="form_content_block--group  mb_0">
                                                                                <label className='form_label'>Revenue Type *</label>
                                                                                <Select
                                                                                    showSearch={false}
                                                                                    optionFilterProp="label"
                                                                                    className='form_select basic no_search'
                                                                                    value={revenueType_vastzone}
                                                                                    disabled
                                                                                    options={revenueTypeOptions_vastzone}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                        {revenueType_vastzone === "Fixed_Price" ?
                                                                            <>
                                                                                <Col span={(override_eCpm_Checkbox_vastzone && (role === "sa" || role === "mobops")) ? 6 : 12}>
                                                                                    <div className="form_content_block--group mb_0">
                                                                                        {(role === "sa" || role === "mobops") ?

                                                                                            <label className='form_label' style={{ marginBottom: "0.3rem", display: "flex", justifyContent: "flex-end" }} >

                                                                                                <div className="primary_checkbox" >
                                                                                                    <Checkbox
                                                                                                        id="override_eCpm_checkbox_vastzone"
                                                                                                        name="override_eCpm_checkbox_vastzone"
                                                                                                        checked={override_eCpm_Checkbox_vastzone}
                                                                                                        onChange={(e) => { setOverride_eCpm_Checkbox_vastzone(e.target.checked) }}

                                                                                                    >
                                                                                                        <span className="form_label" style={{ fontSize: "1.1rem" }}>
                                                                                                            Override the current eCPM
                                                                                                        </span>
                                                                                                    </Checkbox>
                                                                                                </div>

                                                                                            </label>
                                                                                            :
                                                                                            <label className='form_label'>&nbsp;</label>
                                                                                        }
                                                                                        <Input
                                                                                            placeholder='Enter eCpm'
                                                                                            className={
                                                                                                eCpmIsRequiredError_vastzone
                                                                                                    ? "form_control basic error"
                                                                                                    : "form_control basic"
                                                                                            }
                                                                                            value={eCpm_vastzone}
                                                                                            onBlur={onBlurECpm_vastzone}
                                                                                            onChange={onChangeECpm_vastzone}
                                                                                            autocomplete="off"
                                                                                            disabled
                                                                                        // disabled={(role === "admin" || role === "u_admin")}
                                                                                        />
                                                                                        <span className="error_content">
                                                                                            {eCpmIsRequiredError_vastzone && (
                                                                                                <> This field is required</>
                                                                                            )}
                                                                                            {eCpmValidError_vastzone && (
                                                                                                <> Value should be greater than 0 and less than 100</>
                                                                                            )}
                                                                                        </span>
                                                                                    </div>
                                                                                </Col>
                                                                                {override_eCpm_Checkbox_vastzone && (role === "sa" || role === "mobops") &&
                                                                                    <Col span={6}>
                                                                                        <div className="form_content_block--group mb_0">
                                                                                            <label className='form_label'>Target eCPM *</label>

                                                                                            <Input
                                                                                                placeholder='Enter eCpm'
                                                                                                className={
                                                                                                    eCpm_target_IsRequiredError_vastzone
                                                                                                        ? "form_control basic error"
                                                                                                        : "form_control basic"
                                                                                                }
                                                                                                value={eCpm_target_vastzone}
                                                                                                onBlur={onBlurECpm_target_vastzone}
                                                                                                onChange={onChangeECpm_target_vastzone}
                                                                                                autocomplete="off"

                                                                                            // disabled={(role === "admin" || role === "u_admin")}
                                                                                            />
                                                                                            <span className="error_content">
                                                                                                {eCpm_target_IsRequiredError_vastzone && (
                                                                                                    <> This field is required</>
                                                                                                )}
                                                                                                {eCpm_target_ValidError_vastzone && (
                                                                                                    <> Value should be greater than 0 and less than 100</>
                                                                                                )}
                                                                                            </span>
                                                                                        </div>
                                                                                    </Col>
                                                                                }

                                                                            </>
                                                                            :
                                                                            <Col span={12}>
                                                                                <div className="form_content_block--group mb-0">
                                                                                    <label className='form_label'>&nbsp;</label>
                                                                                    <Input
                                                                                        placeholder='Enter Revshare'
                                                                                        className={
                                                                                            revSharePercentIsRequiredError_vastzone
                                                                                                ? "form_control basic error form_control_with_icon_d2"
                                                                                                : "form_control basic form_control_with_icon_d2"
                                                                                        }
                                                                                        value={revSharePercent_vastzone}
                                                                                        onBlur={onBlurRevSharePercent_vastzone}
                                                                                        onChange={onChangeRevSharePercent_vastzone}
                                                                                        autocomplete="off"
                                                                                        suffix={'%'}
                                                                                        disabled
                                                                                    // disabled={(role === "admin" || role === "u_admin")}
                                                                                    />
                                                                                </div>
                                                                                <span className="error_content">
                                                                                    {revSharePercentIsRequiredError_vastzone && (
                                                                                        <> This field is required</>
                                                                                    )}
                                                                                    {revSharePercentValidError_vastzone && (
                                                                                        <> Value should be greater than 0 and less or equal to  80</>
                                                                                    )}
                                                                                </span>
                                                                            </Col>
                                                                        }

                                                                    </Row>

                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>


                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info">
                                                            <label>Please select all sensitive categories you would like us to block on your supply.</label>
                                                            {/* <p className="sub_text">Categories you would like us to block on your supply.</p> */}
                                                        </div>
                                                    </Col>
                                                    <Col span={16}>
                                                        <div className="container_box--form-container">
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group mb-0">
                                                                        <BlockCategoryTable selected={blockCategorySelected} setSelected={setBlockCategorySelected} disabled={(role === "admin" || role === "u_admin")} normalizeKey={blockCategoryNormalizeKey} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {(role !== "admin" && role !== "u_admin") && (
                                                    <>
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>Limits</label>
                                                                    <p className="sub_text">Enter your zone limits</p>
                                                                </div>
                                                            </Col>

                                                            <Col span={16}>
                                                                <div className="container_box--form-container ">
                                                                    <Row gutter={16}>
                                                                        <Col span={12}>
                                                                            <div className="form_content_block--group mb_0">
                                                                                <label className="form_label">
                                                                                    Requests per Day
                                                                                </label>
                                                                                <Input
                                                                                    className="form_control basic"
                                                                                    value={request_vastzone}
                                                                                    disabled
                                                                                    autocomplete="off"
                                                                                />
                                                                            </div>
                                                                            <span className="error_content">
                                                                                <></>
                                                                            </span>
                                                                        </Col>
                                                                        <Col span={12}>
                                                                            <div className="form_content_block--group mb_0">
                                                                                <label className="form_label">
                                                                                    Impressions per Day
                                                                                </label>
                                                                                <Input
                                                                                    className="form_control basic"
                                                                                    value={impression_vastzone}
                                                                                    disabled
                                                                                    autocomplete="off"
                                                                                />
                                                                                <span className="error_content">
                                                                                    <></>
                                                                                </span>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {/* <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>Remote Feed Type</label>
                                                                </div>
                                                            </Col>

                                                            <Col span={16}>
                                                                <div className="container_box--form-container ">
                                                                    {feedListRepeater.map((x, i) => {
                                                                        return (
                                                                            <Row gutter={16} className='formHtml' key={i}>
                                                                                <Col span={16}>
                                                                                    <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                        <label className="form_label">
                                                                                            Remote Feed Type *
                                                                                        </label>
                                                                                        <Select
                                                                                            showSearch
                                                                                            placeholder="-Select-"
                                                                                            optionFilterProp="label"
                                                                                            className='form_select basic'
                                                                                            // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                            //     return acc.concat(item.feed_provider_id);
                                                                                            // }, []).includes(option.value))}

                                                                                            options={feedListRepeaterOptions.filter(option => {
                                                                                                const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                                    return acc.concat(item.feed_provider_id);
                                                                                                }, []);

                                                                                                // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                                return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                            })}

                                                                                            value={x.feed_provider_id}
                                                                                            onChange={(e) =>
                                                                                                handleChangeFeedProviderId(
                                                                                                    e,
                                                                                                    i,
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                        <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                                    </div>

                                                                                </Col>
                                                                                <Col span={8}>
                                                                                    <div className="form_content_block--group mb_0">
                                                                                        <label className="form_label"> Remote ID * </label>
                                                                                        <div className='d-flex'>
                                                                                            <Input className="form_control basic"
                                                                                                value={x.remote_id}
                                                                                                onChange={(e) =>
                                                                                                    handleChangeRemoteId(
                                                                                                        e,
                                                                                                        i,
                                                                                                    )
                                                                                                }
                                                                                            />

                                                                                            <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                                <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                            </div>

                                                                                        </div>
                                                                                        <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        )
                                                                    })}
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            <div className='addnewform_d2'>
                                                                                <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                                    <img src={addIcon} alt='Add New' /> Add New
                                                                                </button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row> */}
                                                    </>
                                                )}

                                                {(role !== "admin" && role !== "u_admin") && (
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info">
                                                                <label>Inventory Partner Domain Override</label>
                                                            </div>
                                                        </Col>
                                                        <Col span={16}>
                                                            <div className="container_box--form-container ">
                                                                <Row gutter={16}>
                                                                    <Col span={24}>
                                                                        <div className="form_content_block--group">
                                                                            <div className="primary_checkbox">
                                                                                <Checkbox
                                                                                    disabled={(role === "admin" || role === "u_admin")}
                                                                                    checked={isAddValueCheckbox_vastzone}
                                                                                    onChange={onChangeIsAddValueCheckbox_vastzone}
                                                                                >
                                                                                    <span className="form_label">Pass Inventory Partner Domain</span>
                                                                                </Checkbox>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">Inventory Partner Domain</label>
                                                                            <Input
                                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                                className="form_control basic"
                                                                                value={override_vastzone}
                                                                                onBlur={onBlurOverride_vastzone}
                                                                                onChange={onChangeOverride_vastzone}
                                                                                placeholder="Enter Inventory Partner Domain"
                                                                                autocomplete="off"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info">
                                                            <label>IVT Sampling</label>
                                                            <p className="sub_text">Set the sampling percentage</p>
                                                        </div>
                                                    </Col>
                                                    <Col span={16}>
                                                        <div className="container_box--form-container ">
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="alert_yellow_div">
                                                                        <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Human *</label>
                                                                        <Input
                                                                            className={humanValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                            placeholder='0'
                                                                            autocomplete="off"
                                                                            value={human_vastzone}
                                                                            disabled={(role === "admin" || role === "u_admin")}
                                                                            onChange={onChangeHuman_vastzone}
                                                                            onBlur={onBlurHuman_vastzone}
                                                                            suffix={'%'}
                                                                        />
                                                                        <span className="error_content">
                                                                            {humanValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Pixalate *</label>
                                                                        <Input
                                                                            className={pixalateValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                            placeholder='0'
                                                                            autocomplete="off"
                                                                            value={pixalate_vastzone}
                                                                            disabled={(role === "admin" || role === "u_admin")}
                                                                            onChange={onChangePixalate_vastzone}
                                                                            onBlur={onBlurPixalate_vastzone}
                                                                            suffix={'%'}
                                                                        />
                                                                        <span className="error_content">
                                                                            {pixalateValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            */}
                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className="form_label">DoubleVerify *</label>
                                                                        <Input
                                                                            className={doubleverifyValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                                                            placeholder='0'
                                                                            autocomplete="off"
                                                                            value={doubleverify_vastzone}
                                                                            disabled={(role === "admin" || role === "u_admin")}
                                                                            onChange={onChangeDoubleverify_vastzone}
                                                                            onBlur={onBlurDoubleverify_vastzone}
                                                                            suffix={'%'}
                                                                        />
                                                                        <span className="error_content">
                                                                            {doubleverifyValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info ">
                                                            <label>Endpoint</label>
                                                        </div>
                                                    </Col>

                                                    <Col span={16}>
                                                        <div
                                                            className={(role === "admin" || role === "u_admin") ? "container_box--form-container mb_0" : "container_box--form-container mb_0 "}
                                                        >
                                                            <Row gutter={16}>
                                                                <Col span={24}>

                                                                    <div className="form_content_block--group  "
                                                                        style={{ marginBottom: "10px" }}
                                                                    >
                                                                        <label className="form_label">
                                                                            Template *
                                                                        </label>

                                                                        <Select
                                                                            open={isDropdownOpenTemplate_vastzone}
                                                                            onDropdownVisibleChange={(open) => setIsDropdownOpenTemplate_vastzone(open)}
                                                                            showSearch
                                                                            className={templateIsRequiredError_vastzone ? "form_select basic  error" : "form_select basic "}
                                                                            value={template_vastzone}
                                                                            onChange={onChangeTemplate_vastzone}
                                                                            optionFilterProp="label"
                                                                            dropdownRender={(menu) => (
                                                                                <>
                                                                                    {(role !== "admin" && role !== "u_admin") &&
                                                                                        <div
                                                                                            style={{
                                                                                                padding: '8px',
                                                                                                cursor: 'pointer',
                                                                                                color: '#9254de',
                                                                                                borderBottom: '1px solid #f0f0f0',
                                                                                            }}
                                                                                            onClick={() => openTemplateModal("vastzone")}
                                                                                        >
                                                                                            + New Template
                                                                                        </div>
                                                                                    }
                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                            options={templateOptions_vastzone[platformType_vastzone] || []}
                                                                        />

                                                                        <span className="error_content">
                                                                            {templateIsRequiredError_vastzone && (
                                                                                <> This field is required</>
                                                                            )}
                                                                        </span>

                                                                    </div>

                                                                    <div className="form_content_block--group mb_0">
                                                                        <TextArea autocomplete="off" placeholder=''
                                                                            className="form_control basic form_control_h textarea_paddingY_d2 --120"
                                                                            disabled
                                                                            value={templateText_vastzone}
                                                                        />
                                                                        <span className="error_content"></span>
                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>


                                            </>
                                        )
                                        :
                                        formType === "vast_aniview" ?
                                            <>
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info">
                                                            <label>General details</label>
                                                            <p className="sub_text">Please enter zone details</p>
                                                        </div>
                                                    </Col>

                                                    <Col span={16}>
                                                        <div className="container_box--form-container">
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">
                                                                            Traffic Type *
                                                                        </label>
                                                                        <Radio.Group
                                                                            onChange={onChangePlatformType_vast_aniview}
                                                                            value={platformType_vast_aniview}
                                                                            className="form_radio equal_space"
                                                                            disabled
                                                                        // disabled={(role === "admin" || role === "u_admin")}
                                                                        >
                                                                            <Radio className="radio_btn" value="Website">
                                                                                Website
                                                                            </Radio>
                                                                            <Radio className="radio_btn" value="Inapp">
                                                                                Inapp
                                                                            </Radio>
                                                                            <Radio className="radio_btn" value="CTV">
                                                                                CTV
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    </div>

                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Channel Name *</label>
                                                                        <Input
                                                                            className={
                                                                                channelNameIsRequiredError_vast_aniview
                                                                                    ? "form_control basic error"
                                                                                    : "form_control basic"
                                                                            }
                                                                            value={channelName_vast_aniview}
                                                                            onBlur={onBlurChannelName_vast_aniview}
                                                                            onChange={onChangeChannelName_vast_aniview}
                                                                            autocomplete="off"
                                                                            disabled={(role === "admin" || role === "u_admin")}
                                                                        />
                                                                        <span className="error_content">
                                                                            {channelNameIsRequiredError_vast_aniview && (
                                                                                <> This field is required</>
                                                                            )}
                                                                        </span>
                                                                    </div>


                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className='form_label'>eCPM *</label>
                                                                        <Input
                                                                            placeholder='Enter eCpm'
                                                                            className={
                                                                                eCpmIsRequiredError_vast_aniview || eCpmValidError_vast_aniview
                                                                                    ? "form_control basic error"
                                                                                    : "form_control basic"
                                                                            }
                                                                            value={eCpm_vast_aniview}
                                                                            onBlur={onBlurECpm_vast_aniview}
                                                                            onChange={onChangeECpm_vast_aniview}
                                                                            autocomplete="off"
                                                                            disabled
                                                                        // disabled={(role === "admin" || role === "u_admin")}
                                                                        />
                                                                        <span className="error_content">
                                                                            {eCpmIsRequiredError_vast_aniview && (
                                                                                <> This field is required</>
                                                                            )}
                                                                            {eCpmValidError_vast_aniview && (
                                                                                <> Value should be greater than 0 and less than 100</>
                                                                            )}
                                                                        </span>
                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>


                                            </>
                                            :
                                            (formType === "Player Tag" || formType === "tag_outstream") ?
                                                <>
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info">
                                                                <label>General details</label>
                                                                <p className="sub_text">Please enter zone details</p>
                                                            </div>
                                                        </Col>

                                                        <Col span={16}>
                                                            <div className="container_box--form-container">
                                                                <Row gutter={16}>
                                                                    <Col span={24}>
                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">
                                                                                Traffic Type *
                                                                            </label>
                                                                            <Radio.Group

                                                                                value={platformType_playertag}
                                                                                disabled
                                                                                className="form_radio equal_space"
                                                                            >
                                                                                <Radio className="radio_btn" value="Website">
                                                                                    Website
                                                                                </Radio>
                                                                                <Radio className="radio_btn" value="Inapp">
                                                                                    Inapp
                                                                                </Radio>

                                                                            </Radio.Group>
                                                                        </div>
                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Player Mode *</label>
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={playerMode_playertag}
                                                                                disabled

                                                                                options={playerModeOptions_playertag}
                                                                            />
                                                                        </div>


                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Floating Position *</label>
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={floatingPosition_playertag}
                                                                                onChange={onChangeFloatingPosition_playertag}
                                                                                options={formType === "tag_outstream" ? floatingPositionOptions_tag_outstream : floatingPositionOptions_playertag}
                                                                                disabled={(role === "admin" || role === "u_admin")}

                                                                            />
                                                                        </div>



                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Channel Name *</label>
                                                                            <Input
                                                                                className={
                                                                                    channelNameIsRequiredError_playertag
                                                                                        ? "form_control basic error"
                                                                                        : "form_control basic"
                                                                                }
                                                                                value={channelName_playertag}
                                                                                onBlur={onBlurChannelName_playertag}
                                                                                onChange={onChangeChannelName_playertag}
                                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                                autocomplete="off"
                                                                            />
                                                                            <span className="error_content">
                                                                                {channelNameIsRequiredError_playertag && (
                                                                                    <> This field is required</>
                                                                                )}
                                                                            </span>
                                                                        </div>


                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className='form_label'>eCPM *</label>
                                                                            <Input
                                                                                placeholder='Enter eCpm'
                                                                                className={
                                                                                    eCpmIsRequiredError_playertag || eCpmValidError_playertag
                                                                                        ? "form_control basic error"
                                                                                        : "form_control basic"
                                                                                }
                                                                                value={eCpm_playertag}
                                                                                onBlur={onBlurECpm_playertag}
                                                                                onChange={onChangeECpm_playertag}
                                                                                disabled={(role === "admin" || role === "u_admin")}
                                                                                autocomplete="off"
                                                                            />
                                                                            <span className="error_content">
                                                                                {eCpmIsRequiredError_playertag && (
                                                                                    <> This field is required</>
                                                                                )}
                                                                                {eCpmValidError_playertag && (
                                                                                    <> Value should be greater than 0 and less than 100</>
                                                                                )}
                                                                            </span>
                                                                        </div>

                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info"

                                                            >
                                                                <label>CMS</label>
                                                                <p className='sub_text'>Upload your desired video</p>
                                                            </div>
                                                        </Col>

                                                        <Col span={16}>
                                                            <div className="form_content_block--group mb_0"

                                                            >


                                                                {mainTableVideo_playertag?.length > 0 &&
                                                                    <>
                                                                        {mainTableVideo_playertag?.map((video, index) => (
                                                                            <>
                                                                                <div className="ant_upload_list--item">

                                                                                    <div className="ant_upload_list--content gap_12">
                                                                                        <div className="thumbnail_content--video position-relative">
                                                                                            <button className='thumbnail_content--play'
                                                                                                onClick={() => { handleFullscreen1(index) }}
                                                                                            ><img src={playIcon} alt='USP' /></button>
                                                                                            <video
                                                                                                ref={el => videoRef1.current[index] = el}
                                                                                                width="138"
                                                                                                height="79"
                                                                                                controls={false}
                                                                                                className='video_thumb'
                                                                                                // onMouseEnter={handleMouseEnter}
                                                                                                // onMouseLeave={handleMouseLeave}
                                                                                                muted
                                                                                            >
                                                                                                <source src={video.url} />
                                                                                                Your browser does not support the video tag.
                                                                                            </video>
                                                                                        </div>

                                                                                        <div className="ant_upload_list--info">
                                                                                            <span className="ant_upload_list--info-name">{video?.url?.includes("blob") ? video?.filename : video?.url?.substring(video?.url?.lastIndexOf('/') + 1)}</span>
                                                                                            <span className="ant_upload_list--info-size">{video?.url?.includes("blob") ? video?.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB` : ""}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    {/* <button type="link" className="download_icon download_icon_d2"
                                                                                onClick={() => {
                                                                                    const newArray = [...mainTableVideo_playertag];
                                                                                    newArray.splice(index, 1);
                                                                                    setMainTableVideo_playertag(newArray);
                                                                                }}
                                                                            >
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </button> */}

                                                                                </div>
                                                                            </>

                                                                        ))}
                                                                    </>
                                                                }
                                                            </div>
                                                        </Col>

                                                    </Row>

                                                </>
                                                :
                                                formType === "GAM" ? (
                                                    <>
                                                        {/* ------- General details ------- */}
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>General details</label>
                                                                    <p className="sub_text">Please enter zone details</p>
                                                                </div>
                                                            </Col>
                                                            <Col span={16}>
                                                                <div className="container_box--form-container">
                                                                    <Row gutter={16}>
                                                                        <Col span={24}>
                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Traffic Type *</label>
                                                                                <Radio.Group
                                                                                    onChange={onChangePlatformType_gam}
                                                                                    value={platformType_gam}
                                                                                    className="form_radio equal_space"
                                                                                    // disabled={isGamRestricted}
                                                                                    disabled
                                                                                >
                                                                                    <Radio className="radio_btn" value="Website">Website</Radio>
                                                                                    <Radio className="radio_btn" value="Inapp">Inapp</Radio>
                                                                                    <Radio className="radio_btn" value="CTV">CTV</Radio>
                                                                                </Radio.Group>
                                                                            </div>
                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Format Type *</label>
                                                                                <Radio.Group
                                                                                    onChange={onChangeFormatType_gam}
                                                                                    value={platformType_gam === "CTV" ? "Video" : formatType_gam}
                                                                                    className="form_radio equal_space"
                                                                                    // disabled={isGamRestricted || platformType_gam === "CTV"}
                                                                                    disabled
                                                                                >
                                                                                    {formatTypeOptions_gam.map((opt) => (
                                                                                        <Radio className="radio_btn" key={opt.value} value={opt.value}>
                                                                                            {opt.label}
                                                                                        </Radio>
                                                                                    ))}
                                                                                </Radio.Group>
                                                                            </div>
                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Ad Unit/Zone Name *</label>
                                                                                <Input
                                                                                    className={
                                                                                        zoneNameIsRequiredError_gam || zoneNameMaxError_gam || nameExists.gam
                                                                                            ? "form_control basic error"
                                                                                            : "form_control basic"
                                                                                    }
                                                                                    value={zoneName_gam}
                                                                                    onBlur={onBlurZoneName_gam}
                                                                                    onChange={onChangeZoneName_gam}
                                                                                    disabled={isGamRestricted}
                                                                                    maxLength={90}
                                                                                    autocomplete="off"
                                                                                    suffix={nameChecking.gam ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                                                                />
                                                                                <span className="error_content">
                                                                                    {zoneNameIsRequiredError_gam && (
                                                                                        <> This field is required</>
                                                                                    )}
                                                                                    {zoneNameMaxError_gam && (
                                                                                        <> Maximum 90 characters allowed</>
                                                                                    )}
                                                                                    {nameExists.gam && (
                                                                                        <> Zone name already exists</>
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                            <div className="form_content_block--group mb_0">
                                                                                <div className="primary_checkbox">
                                                                                    <Checkbox
                                                                                        id="zone_checkbox_gam"
                                                                                        name="zone_checkbox_gam"
                                                                                        checked={zoneActiveCheckbox_gam}
                                                                                        onChange={onChangeZoneActiveCheckbox_gam}
                                                                                        // disabled={isGamRestricted}
                                                                                        disabled
                                                                                    >
                                                                                        <span className="form_label">Is Zone Active?</span>
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* ------- Sizes ------- */}
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>Sizes</label>
                                                                    <p className="sub_text">Choose ad sizes</p>
                                                                </div>
                                                            </Col>
                                                            <Col span={16}>
                                                                <div className="container_box--form-container --form_contaier_sizes">
                                                                    <Row gutter={16}>
                                                                        <Col span={24}>
                                                                            {/* Sizes (multi-select) - Banner: sizes.json | Video: vastMasterSizes.json */}
                                                                            <div className="form_content_block--group mt-0">
                                                                                <label className="form_label">Sizes *</label>
                                                                                <div className={`checkbox_value_select_d2 multi_select_tag_d2 w-100 ${isGamRestricted ? "gam_readonly_select" : ""}`}>
                                                                                    <Select
                                                                                        value={sizesList_gam}
                                                                                        popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                                                        maxTagCount={3}
                                                                                        showSearch={false}
                                                                                        placeholder='- Select -'
                                                                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                                                        className={sizesIsRequiredError_gam ? "form_select_multiple error" : "form_select_multiple"}
                                                                                        mode='multiple'
                                                                                        optionLabelProp="label"
                                                                                        onChange={(event) => {
                                                                                            if (isGamRestricted) return;
                                                                                            setSizesList_gam(event);
                                                                                            if (event.length > 0) setSizesIsRequiredError_gam(false);
                                                                                        }}
                                                                                        open={!!openSelectState_gam[`sizes-gam`]}
                                                                                        onDropdownVisibleChange={(open) => toggleSelectOpen_gam(`sizes-gam`, open)}
                                                                                        dropdownRender={menu => (
                                                                                            <>
                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                    <Input placeholder="Search" value={searchSizesList_gam}
                                                                                                        onChange={(e) => { handleSearchSizesList_gam(e) }}
                                                                                                        onKeyDown={(e) => e.stopPropagation()}
                                                                                                        ref={getRef_gam(`sizes-gam`)}
                                                                                                        prefix={<img src={searchIcon} alt="USP" />} allowClear
                                                                                                        onClear={() => {
                                                                                                            setSearchSizesList_gam('');
                                                                                                            setTimeout(() => { refsMap_gam.current[`sizes-gam`]?.current?.focus(); }, 0);
                                                                                                        }} />
                                                                                                </div>
                                                                                                {searchSizesList_gam.length === 0 && sizesListOptions_gam?.length > 0 &&
                                                                                                    <div
                                                                                                        className={`select_all_d2 ${(sizesList_gam?.length > 0 && sizesList_gam?.length !== sizesListOptions_gam?.length) ? 'intermediate_state' : ''}`}
                                                                                                        onClick={() => { if (!isGamRestricted) handleSelectAllSizesList_gam(); }}
                                                                                                    >
                                                                                                        <Checkbox
                                                                                                            checked={sizesList_gam?.length === sizesListOptions_gam?.length}
                                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                                        >
                                                                                                            Select All
                                                                                                        </Checkbox>
                                                                                                    </div>
                                                                                                }
                                                                                                {menu}
                                                                                            </>
                                                                                        )}
                                                                                    >
                                                                                        {[
                                                                                            ...filterSizesList_gam?.filter(option => sizesList_gam?.includes(option.value)),
                                                                                            ...filterSizesList_gam?.filter(option => !sizesList_gam?.includes(option.value))
                                                                                        ].map(option => (
                                                                                            <Option key={option.value} value={option.value} label={option.label}>
                                                                                                <div
                                                                                                    onClick={() => { if (!isGamRestricted) handleSizesList_gam(option.value); }}
                                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={sizesList_gam?.includes(option.value)}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        {option.label}
                                                                                                    </Checkbox>
                                                                                                </div>
                                                                                            </Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </div>
                                                                                <span className="error_content">
                                                                                    {sizesIsRequiredError_gam && (<> Minimum 1 selection is required</>)}
                                                                                </span>
                                                                            </div>

                                                                            {/* Companion (multi-select) - Video only, companionSizes.json */}
                                                                            {formatType_gam === "Video" && (
                                                                                <div className="form_content_block--group">
                                                                                    <label className="form_label">Companion</label>
                                                                                    <div className={`checkbox_value_select_d2 multi_select_tag_d2 w-100 ${isGamRestricted ? "gam_readonly_select" : ""}`}>
                                                                                        <Select
                                                                                            value={companionList_gam}
                                                                                            popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                                                            maxTagCount={3}
                                                                                            showSearch={false}
                                                                                            placeholder='- Select -'
                                                                                            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                                                            className="form_select_multiple"
                                                                                            mode='multiple'
                                                                                            optionLabelProp="label"
                                                                                            onChange={(event) => { if (isGamRestricted) return; setCompanionList_gam(event); }}
                                                                                            open={!!openSelectState_gam[`companion-gam`]}
                                                                                            onDropdownVisibleChange={(open) => toggleSelectOpen_gam(`companion-gam`, open)}
                                                                                            dropdownRender={menu => (
                                                                                                <>
                                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                                        <Input placeholder="Search" value={searchCompanionList_gam}
                                                                                                            onChange={(e) => { handleSearchCompanionList_gam(e) }}
                                                                                                            onKeyDown={(e) => e.stopPropagation()}
                                                                                                            ref={getRef_gam(`companion-gam`)}
                                                                                                            prefix={<img src={searchIcon} alt="USP" />} allowClear
                                                                                                            onClear={() => {
                                                                                                                setSearchCompanionList_gam('');
                                                                                                                setTimeout(() => { refsMap_gam.current[`companion-gam`]?.current?.focus(); }, 0);
                                                                                                            }} />
                                                                                                    </div>
                                                                                                    {searchCompanionList_gam.length === 0 && companionListOptions_gam?.length > 0 &&
                                                                                                        <div
                                                                                                            className={`select_all_d2 ${(companionList_gam?.length > 0 && companionList_gam?.length !== companionListOptions_gam?.length) ? 'intermediate_state' : ''}`}
                                                                                                            onClick={() => { if (!isGamRestricted) handleSelectAllCompanionList_gam(); }}
                                                                                                        >
                                                                                                            <Checkbox
                                                                                                                checked={companionList_gam?.length === companionListOptions_gam?.length}
                                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                                            >
                                                                                                                Select All
                                                                                                            </Checkbox>
                                                                                                        </div>
                                                                                                    }
                                                                                                    {menu}
                                                                                                </>
                                                                                            )}
                                                                                        >
                                                                                            {[
                                                                                                ...filterCompanionList_gam?.filter(option => companionList_gam?.includes(option.value)),
                                                                                                ...filterCompanionList_gam?.filter(option => !companionList_gam?.includes(option.value))
                                                                                            ].map(option => (
                                                                                                <Option key={option.value} value={option.value} label={option.label}>
                                                                                                    <div
                                                                                                        onClick={() => { if (!isGamRestricted) handleCompanionList_gam(option.value); }}
                                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                                    >
                                                                                                        <Checkbox
                                                                                                            checked={companionList_gam?.includes(option.value)}
                                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                                        >
                                                                                                            {option.label}
                                                                                                        </Checkbox>
                                                                                                    </div>
                                                                                                </Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {platformType_gam === "CTV" && !isGamRestricted && (
                                                                                <>
                                                                                    <div className="form_content_block--group">
                                                                                        <div className="primary_checkbox">
                                                                                            <Checkbox
                                                                                                id="tv_app_name_gam"
                                                                                                name="tv_app_name_gam"
                                                                                                checked={tvAppNameCheckbox_gam}
                                                                                                onChange={onChangeTvAppNameCheckbox_gam}
                                                                                            >
                                                                                                <span className="form_label">TV app name</span>
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                    </div>
                                                                                    {tvAppNameCheckbox_gam && (
                                                                                        <div className="form_content_block--group mb_0">
                                                                                            <label className="form_label">TV Application *</label>
                                                                                            <Select
                                                                                                showSearch
                                                                                                optionFilterProp="label"
                                                                                                className={tvApplicationIsRequiredError_gam ? "form_select basic error" : "form_select basic"}
                                                                                                value={tvApplication_gam}
                                                                                                placeholder="- Select -"
                                                                                                onChange={onChangeTvApplication_gam}
                                                                                                options={tvApplicationOptions_gam}
                                                                                            />
                                                                                            <span className="error_content">
                                                                                                {tvApplicationIsRequiredError_gam && (
                                                                                                    <> This field is required</>
                                                                                                )}
                                                                                            </span>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* ------- Pricing ------- */}
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>Pricing</label>
                                                                    <p className="sub_text">Set zone pricing</p>
                                                                </div>
                                                            </Col>
                                                            <Col span={16}>
                                                                <div className="container_box--form-container mb_0">
                                                                    <Row gutter={16}>
                                                                        <Col span={24}>
                                                                            <Row gutter={16}>
                                                                                <Col span={overrideUpr_gam && !isGamRestricted ? 8 : isGamRestricted ? 24 : 12}>
                                                                                    <div className="form_content_block--group">
                                                                                        <label className="form_label">Fixed Price *</label>
                                                                                        <Input
                                                                                            className={
                                                                                                fixedPriceIsRequiredError_gam || fixedPriceValidError_gam
                                                                                                    ? "form_control basic prefix_sign error"
                                                                                                    : "form_control basic prefix_sign"
                                                                                            }
                                                                                            placeholder="0"
                                                                                            autocomplete="off"
                                                                                            value={fixedPrice_gam}
                                                                                            onChange={onChangeFixedPrice_gam}
                                                                                            onBlur={onBlurFixedPrice_gam}
                                                                                            prefix={"$"}
                                                                                            disabled
                                                                                        // disabled={isGamRestricted}
                                                                                        />
                                                                                        <span className="error_content">
                                                                                            {fixedPriceIsRequiredError_gam && (<> This field is required</>)}
                                                                                            {fixedPriceValidError_gam && (<> Value must be greater than 0</>)}
                                                                                        </span>
                                                                                    </div>
                                                                                </Col>
                                                                                {!isGamRestricted &&
                                                                                    <Col span={overrideUpr_gam && !isGamRestricted ? 8 : 12}>
                                                                                        <div className="form_content_block--group">
                                                                                            <div className="d_flex justify-content-between align-items-center">
                                                                                                <label className="form_label">Set UPR *</label>
                                                                                                {!isGamRestricted && (
                                                                                                    <div className="primary_checkbox">
                                                                                                        <Checkbox
                                                                                                            id="override_upr_gam"
                                                                                                            name="override_upr_gam"
                                                                                                            checked={overrideUpr_gam}
                                                                                                            onChange={onChangeOverrideUpr_gam}
                                                                                                        >
                                                                                                            <span className="form_label">Override UPR</span>
                                                                                                        </Checkbox>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                            <Input
                                                                                                className="form_control basic prefix_sign"
                                                                                                placeholder="0"
                                                                                                autocomplete="off"
                                                                                                value={upr_gam}
                                                                                                prefix={"$"}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                }
                                                                                {overrideUpr_gam && !isGamRestricted && (
                                                                                    <Col span={8}>
                                                                                        <div className="form_content_block--group">
                                                                                            <label className="form_label">Override Set UPR *</label>
                                                                                            <Input
                                                                                                className={
                                                                                                    overrideSetUprIsRequiredError_gam || overrideSetUprValidError_gam
                                                                                                        ? "form_control basic prefix_sign error"
                                                                                                        : "form_control basic prefix_sign"
                                                                                                }
                                                                                                placeholder="0"
                                                                                                autocomplete="off"
                                                                                                value={overrideSetUpr_gam}
                                                                                                onChange={onChangeOverrideSetUpr_gam}
                                                                                                onBlur={onBlurOverrideSetUpr_gam}
                                                                                                prefix={"$"}
                                                                                            />
                                                                                            <span className="error_content">
                                                                                                {overrideSetUprIsRequiredError_gam && (<> This field is required</>)}
                                                                                                {overrideSetUprValidError_gam && (<> Value must be greater than 0</>)}
                                                                                            </span>
                                                                                        </div>
                                                                                    </Col>
                                                                                )}
                                                                            </Row>
                                                                            {!isGamRestricted && (
                                                                                <div className="form_content_block--group mb_0">
                                                                                    <label className="form_label">UPR Category *</label>
                                                                                    <Select
                                                                                        optionFilterProp="label"
                                                                                        className={
                                                                                            uprCategoryIsRequiredError_gam || uprCategoryNotFoundError_gam
                                                                                                ? "form_select basic no_search error"
                                                                                                : "form_select basic no_search"
                                                                                        }
                                                                                        value={uprCategory_gam || undefined}
                                                                                        onChange={onChangeUprCategory_gam}
                                                                                        options={uprCategoryOptions_gam}
                                                                                        placeholder="- Select -"
                                                                                        disabled={!overrideUpr_gam}
                                                                                    />
                                                                                    <span className="error_content">
                                                                                        {uprCategoryIsRequiredError_gam && (<> This field is required</>)}
                                                                                        {uprCategoryNotFoundError_gam && (<> UPR Category as per UPR not found</>)}
                                                                                    </span>
                                                                                    {uprCategoryMatched_gam && !uprCategoryNotFoundError_gam && !uprCategoryIsRequiredError_gam && uprCategory_gam && !isUprCategoryMismatch_gam() && (
                                                                                        <span className="error_content" style={{ color: "#12B76A" }}>
                                                                                            UPR Category set as per UPR
                                                                                        </span>
                                                                                    )}
                                                                                    {overrideUpr_gam && !uprCategoryNotFoundError_gam && !uprCategoryIsRequiredError_gam && isUprCategoryMismatch_gam() && (
                                                                                        <div className="upr_category_info">
                                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                                <p>UPR Category does not match the price. Please cross-check the details or proceed if you wish to continue.</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="container_box--label-info">
                                                                    <label>General details</label>
                                                                    <p className="sub_text">Please enter zone details</p>
                                                                </div>
                                                            </Col>

                                                            <Col span={16}>
                                                                <div className="container_box--form-container ">
                                                                    <Row gutter={16}>
                                                                        <Col span={24}>

                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Account Name *</label>
                                                                                <Input
                                                                                    className="form_control basic"
                                                                                    value={accountName_gamtag}
                                                                                    disabled
                                                                                    autocomplete="off"
                                                                                />
                                                                                <span className="error_content">
                                                                                    <></>
                                                                                </span>
                                                                            </div>

                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Inventory Type *</label>
                                                                                <Input
                                                                                    className="form_control basic"
                                                                                    value="Video"
                                                                                    autocomplete="off"
                                                                                    disabled
                                                                                />
                                                                                <span className="error_content">
                                                                                </span>
                                                                            </div>


                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">
                                                                                    Traffic Type *
                                                                                </label>
                                                                                <Radio.Group

                                                                                    value={platformType_gamtag}
                                                                                    className="form_radio equal_space"
                                                                                    disabled
                                                                                >
                                                                                    <Radio className="radio_btn" value="Website">
                                                                                        Website
                                                                                    </Radio>
                                                                                    <Radio className="radio_btn" value="Inapp">
                                                                                        Inapp
                                                                                    </Radio>
                                                                                    <Radio className="radio_btn" value="CTV">
                                                                                        CTV
                                                                                    </Radio>
                                                                                </Radio.Group>
                                                                            </div>

                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">Ownership *</label>
                                                                                <Select
                                                                                    optionFilterProp="label"
                                                                                    className="form_select basic no_search"
                                                                                    value={ownership_gamtag}
                                                                                    disabled
                                                                                    options={ownershipOptions_gamtag}
                                                                                />
                                                                            </div>

                                                                            <div className="form_content_block--group">
                                                                                <label className="form_label">VAST Version *</label>
                                                                                <Select
                                                                                    optionFilterProp="label"
                                                                                    className="form_select basic no_search"
                                                                                    value={vastVersion_gamtag}
                                                                                    disabled
                                                                                    options={vastVersionOptions_gamtag}
                                                                                />
                                                                            </div>

                                                                            <div className="form_content_block--group mb_0">
                                                                                <label className="form_label">eCPM *</label>
                                                                                <Select
                                                                                    optionFilterProp="label"
                                                                                    className="form_select basic no_search"
                                                                                    value={eCPM_gamtag}
                                                                                    disabled

                                                                                    options={eCPMOptions_gamtag}
                                                                                />
                                                                            </div>

                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                    </>
                                                )

                            }

                        </div>
                        {/* <div className={(role !== "admin" && role !== "u_admin") && (formType === "Vast Zone" || formType === "Player Tag") ? 'hr_custom mb_20' : 'mb_20'}></div> */}
                        <div className={(role !== "admin" && role !== "u_admin") && (formType === "Vast Zone" || formType === "Player Tag" || formType === "tag_outstream") ? '' : ''}></div>
                        <div className="height_89_d2"></div>
                        {(((role !== "admin" && role !== "u_admin")
                            && (formType === "Prebid" || formType === "Open RTB" || formType === "publica" || formType === "Vast Zone" || formType === "Player Tag" || formType === "tag_outstream" || formType === "vast_aniview")
                        )
                            ||
                            ((role === "admin" || role === "u_admin")
                                && (formType === "publica")
                            )
                            ||
                            (formType === "GAM" && !isGamRestricted)
                        )

                            &&
                            <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                                {buttonProcessing ?
                                    <>
                                        {/* <button className="btn btn_white_outline w_fit_content"
                                            disabled
                                        >
                                            Discard
                                        </button> */}
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content loader"

                                        >
                                            <span>Save</span>

                                            <img
                                                src={loaderIcon}
                                                alt="USP"
                                                className="loader_icon"
                                            />
                                        </button>
                                    </> :
                                    <>
                                        <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                            onClick={() => {
                                                if (zoneCategory === "GAM") {
                                                    handlePageViewChange("table", "yes")
                                                }
                                                else {
                                                    handlePageViewChange("table", "no")
                                                }

                                                resetFormView()
                                            }}
                                        >
                                            Discard
                                        </button>
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content"
                                            onClick={handleSubmit}

                                        // disabled={
                                        //     (formType === "Prebid" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData)) ||
                                        //     (formType === "Open RTB" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData)) ||

                                        //     ((formType === "Player Tag" || formType === "tag_outstream") && floatingPosition_playertag === floatingPosition_playertag_prev) ||
                                        //     ((formType === "Vast Zone" && revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === eCpm_vastzone_prev) && (formType === "Vast Zone" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData))) ||
                                        //     ((formType === "Vast Zone" && revenueType_vastzone === "Revshare" && revSharePercent_vastzone === revSharePercent_vastzone_prev) && (formType === "Vast Zone" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData))) ||
                                        //     (formType === "vast_aniview" && platformType_vast_aniview === platformType_vast_aniview_prev && channelName_vast_aniview === channelName_vast_aniview_prev && eCpm_vast_aniview === eCpm_vast_aniview_prev)

                                        // }

                                        >
                                            Save
                                        </button>
                                    </>
                                }

                            </div>
                        }


                    </div>
                }

                {/* Tags tab content (GAM zone only). Kept mounted (hidden via CSS)
                    while on the Overview tab so the generated-tag state is preserved
                    across tab switches when tagResponse_gamtags is set. */}
                {formVisible && formType === "GAM" &&
                    <div
                        className="container_box--content pt_20"
                        style={{ display: activeTab_gam === "tags" ? undefined : "none" }}
                    >
                        <div className="container_box--width">
                            {/* ------- Tag Type ------- */}
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Tag Type</label>
                                        <p className="sub_text">Select Tag type</p>
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Tag type *</label>
                                                    <Select
                                                        showSearch={false}
                                                        optionFilterProp="label"
                                                        className="form_select basic no_search"
                                                        placeholder="- Select -"
                                                        value={tagType_gamtags || undefined}
                                                        options={tagTypeOptions_gamtags}
                                                        onChange={onChangeTagType_gamtags}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            {/* ------- Tag Options (changes by tag type) ------- */}
                            {tagType_gamtags &&
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Tag Options</label>
                                        </div>
                                    </Col>
                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>

                                                    {/* Google Publisher Tag: Create passback tag */}
                                                    {tagType_gamtags === "GPT" &&
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox
                                                                    checked={createPassback_gamtags}
                                                                    onChange={(e) => { setCreatePassback_gamtags(e.target.checked); setTagResponse_gamtags(""); }}
                                                                    disabled={!!tagResponse_gamtags}
                                                                >
                                                                    <span className="form_label">Create passback tag</span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                    }

                                                    {/* GPT for Video and Audio: SDK Type + flags + Description URL */}
                                                    {tagType_gamtags === "GPT_Video" &&
                                                        <>
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">SDK Type</label>
                                                                <Radio.Group
                                                                    className="form_radio equal_space"
                                                                    value={sdkType_gamtags}
                                                                    onChange={(e) => setSdkType_gamtags(e.target.value)}
                                                                    disabled={!!tagResponse_gamtags}
                                                                >
                                                                    <Radio className="radio_btn" value="IMA">Google IMA SDK (CTV)</Radio>
                                                                    <Radio className="radio_btn" value="NO_SDK">No SDK (CTV)</Radio>
                                                                    <Radio className="radio_btn" value="PAL">PAL SDK (CTV)</Radio>
                                                                </Radio.Group>
                                                            </div>
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        checked={liveTraffic_gamtags}
                                                                        onChange={(e) => setLiveTraffic_gamtags(e.target.checked)}
                                                                        disabled={!!tagResponse_gamtags}
                                                                    >
                                                                        <span className="form_label">Live traffic</span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        checked={childDirected_gamtags}
                                                                        onChange={(e) => setChildDirected_gamtags(e.target.checked)}
                                                                        disabled={!!tagResponse_gamtags}
                                                                    >
                                                                        <span className="form_label">Enable child-directed</span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">Description URL *</label>
                                                                <Input
                                                                    prefix="https://"
                                                                    className={descriptionUrlIsRequiredError_gamtags ? "form_control basic error" : "form_control basic"}
                                                                    value={descriptionUrl_gamtags}
                                                                    onChange={(e) => {
                                                                        setDescriptionUrl_gamtags(e.target.value);
                                                                        if (e.target.value.trim() !== "") setDescriptionUrlIsRequiredError_gamtags(false);
                                                                    }}
                                                                    onBlur={() => { if (descriptionUrl_gamtags.trim() === "") setDescriptionUrlIsRequiredError_gamtags(true); }}
                                                                    autocomplete="off"
                                                                    disabled={!!tagResponse_gamtags}
                                                                />
                                                                <span className="error_content">
                                                                    {descriptionUrlIsRequiredError_gamtags && (<>This field is required</>)}
                                                                </span>
                                                            </div>
                                                        </>
                                                    }

                                                    {/* Sizes (multi-select) - all tag types */}
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">Sizes *</label>
                                                        {/* Frozen once a tag is generated: the custom design hides the chip
                                                            close icon via CSS but the remove node is still present, so AntD can
                                                            strip the tag on click. pointer-events:none blocks any interaction
                                                            with the field (chips included) while keeping the values visible. */}
                                                        <div
                                                            className="checkbox_value_select_d2 multi_select_tag_d2 w-100"
                                                            style={tagResponse_gamtags ? { pointerEvents: "none" } : undefined}
                                                        >
                                                            <Select
                                                                value={tagSizes_gamtags}
                                                                popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                                maxTagCount={3}
                                                                showSearch={false}
                                                                placeholder='- Select -'
                                                                maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                                className={tagSizesIsRequiredError_gamtags ? "form_select_multiple error" : "form_select_multiple"}
                                                                mode='multiple'
                                                                optionLabelProp="label"
                                                                disabled={!!tagResponse_gamtags}
                                                                onChange={(event) => {
                                                                    // Frozen once a tag is generated: the custom design hides the
                                                                    // chip close icon via CSS but the remove node is still clickable,
                                                                    // so guard here to stop chips being cleared in disabled mode.
                                                                    if (tagResponse_gamtags) return;
                                                                    setTagSizes_gamtags(event);
                                                                    if (event.length > 0) setTagSizesIsRequiredError_gamtags(false);
                                                                }}
                                                                open={!!openSelectState_gam[`sizes-gamtags`]}
                                                                onDropdownVisibleChange={(open) => toggleSelectOpen_gam(`sizes-gamtags`, open)}
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchTagSizes_gamtags}
                                                                                onChange={(e) => { handleSearchTagSizes_gamtags(e) }}
                                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                                ref={getRef_gam(`sizes-gamtags`)}
                                                                                prefix={<img src={searchIcon} alt="USP" />} allowClear
                                                                                onClear={() => {
                                                                                    setSearchTagSizes_gamtags('');
                                                                                    setTimeout(() => { refsMap_gam.current[`sizes-gamtags`]?.current?.focus(); }, 0);
                                                                                }} />
                                                                        </div>
                                                                        {searchTagSizes_gamtags.length === 0 && tagSizesOptions_gamtags?.length > 0 &&
                                                                            <div
                                                                                className={`select_all_d2 ${(tagSizes_gamtags?.length > 0 && tagSizes_gamtags?.length !== tagSizesOptions_gamtags?.length) ? 'intermediate_state' : ''}`}
                                                                                onClick={() => { handleSelectAllTagSizes_gamtags(); }}
                                                                            >
                                                                                <Checkbox
                                                                                    checked={tagSizes_gamtags?.length === tagSizesOptions_gamtags?.length}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    Select All
                                                                                </Checkbox>
                                                                            </div>
                                                                        }
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {[
                                                                    ...filterTagSizes_gamtags?.filter(option => tagSizes_gamtags?.includes(option.value)),
                                                                    ...filterTagSizes_gamtags?.filter(option => !tagSizes_gamtags?.includes(option.value))
                                                                ].map(option => (
                                                                    <Option key={option.value} value={option.value} label={option.label}>
                                                                        <div
                                                                            onClick={() => { handleTagSizes_gamtags(option.value); }}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={tagSizes_gamtags?.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content">
                                                            {tagSizesIsRequiredError_gamtags && (<> Minimum 1 selection is required</>)}
                                                        </span>
                                                    </div>

                                                    {/* Output - all tag types */}
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">Output</label>
                                                        <Radio.Group
                                                            className="form_radio equal_space"
                                                            value={tagOutput_gamtags}
                                                            onChange={(e) => setTagOutput_gamtags(e.target.value)}
                                                            disabled={!!tagResponse_gamtags}
                                                        >
                                                            <Radio className="radio_btn" value="single">One Tag - All Sizes</Radio>
                                                            <Radio className="radio_btn" value="per_size">One Tag per Size</Radio>
                                                        </Radio.Group>
                                                    </div>

                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            }

                        </div>

                        {/* ------- Generated tags summary (full-width, mirrors Overview Tags) ------- */}
                        {tagResponse_gamtags &&
                            <>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <hr className="divider_line_dashed" />
                                    </Col>
                                </Row>
                                <div className="container_box--width">
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Tags</label>
                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="bottom_margin_cls">
                                                <div style={{ background: "#F1FCFC", border: "1px solid #E2E8F0", borderRadius: 6, padding: 24, boxShadow: "0 5px 16px 0 rgba(16, 24, 40, 0.05)" }}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                                                        <span className="form_label tags_heading_cls">
                                                            {tagCount_gamtags} tag{tagCount_gamtags > 1 ? "s" : ""} ready — {tagOutput_gamtags === "single" ? "one tag, all sizes" : "one per size"}
                                                        </span>

                                                    </div>
                                                    <div className="tags_and_btn_div_cls">
                                                        <div className="tags_div_cls_container">
                                                            {tagSizes_gamtags.map((sizeVal) => {
                                                                const opt = tagSizesOptions_gamtags.find((o) => o.value === sizeVal);
                                                                return (
                                                                    <span key={sizeVal} className="tags_div_cls">
                                                                        {opt ? opt.label : sizeVal}
                                                                    </span>
                                                                );
                                                            })}
                                                        </div>
                                                        <button
                                                            className="btn btn_primary w_fit_content"
                                                            onClick={handleDownloadTag_gamtags}
                                                            disabled={tagDownloading_gamtags}
                                                            style={{ padding: "0.8rem 1.6rem", flexShrink: 0, }}
                                                        >
                                                            {tagDownloading_gamtags ?
                                                                <>
                                                                    <span>{getDownloadLabel_gamtags()}</span>
                                                                    <img src={loaderIcon} alt="USP" className="loader_icon" />
                                                                </>
                                                                :
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="me-3" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M4.66797 6.66675L8.0013 10.0001L11.3346 6.66675" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M8 10V2" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                    {getDownloadLabel_gamtags()}
                                                                </>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        }

                        {/* <div className="height_89_d2"></div> */}
                        <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2 position-relative">
                            {tagProcessing_gamtags ?
                                <button className="w_120_d2 btn btn_primary w_fit_content loader">
                                    <span>Generate Tag</span>
                                    <img src={loaderIcon} alt="USP" className="loader_icon" />
                                </button>
                                :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                        onClick={() => {
                                            handlePageViewChange("table", "yes")
                                            resetFormView()
                                        }}
                                    >
                                        Discard
                                    </button>
                                    {!tagResponse_gamtags &&
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content"
                                            onClick={handleGenerateTag_gamtags}
                                        >
                                            Generate Tag
                                        </button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                }

                {!formVisible &&
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                    </div>
                }

                <Modal
                    className='custom_modal custom_modal_form_d2'
                    visible={isTemplateModalOpen}
                    onOk={closeTemplateModal}
                    width={770}
                    onCancel={closeTemplateModal}
                    maskClosable={false}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={creativetemicon} alt='USP' /> Create Template</h3>
                    </div>}
                    closable={true} // This removes the default close button
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end">
                            <div className="btn_group justify-content-end gap_8">
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModal}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleTemplateCreationValidation}>Create</button>
                            </div>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="form_content_block--group modal_form_bottom_gap_d2">
                            <label className="form_label">Template Name * </label>
                            <Input className={nameTemplate_htmlIsRequiredError ? 'form_control basic error ' : 'form_control basic '} placeholder='' autocomplete="off"
                                value={nameTemplate_html}
                                onChange={onChangeNameTemplate_html}
                                onBlur={onBlurNameTemplate_html}
                            />
                            <span className="error_content">{nameTemplate_htmlIsRequiredError && <>This field is required</>} </span>
                        </div>
                        <div className="form_content_block--group">
                            <label className="form_label">Tag * </label>
                            <TextArea autocomplete="off" placeholder='' className={tagTemplate_htmlIsRequiredError ? 'form_control basic form_control_h --160 error textarea_paddingY_d2' : 'form_control basic form_control_h --160 textarea_paddingY_d2'}
                                value={tagTemplate_html}
                                onChange={onChangeTagTemplate_html}
                                onBlur={onBlurTagTemplate_html}
                            />
                            <span className="error_content"> {tagTemplate_htmlIsRequiredError && <>This field is required</>}</span>
                        </div>

                    </div>
                </Modal>
            </div >

        </>
    );
};

export default ZoneViewEdit;
